// ============================================================================
// JAMB Question Bank — Government
// Auto-split from QB.js for better code organisation
// ============================================================================

export const QB_GOVERNMENT = [
  {
    yr: 1978,
    q: "The treaty establishing the Economic Community of West African States (ECOWAS) was",
    o: [
      "concluded in Lome (Togo) in December, 1976 after hard and extensive negotiations.",
      "designed as the main pillar on which an eventual African common market would be built.",
      "the brain-child of Togo and Ghana.",
      "signed in Lagos in May, 1975, to promote trade and other economic co-operation in the region as a whole."
    ],
    a: 3,
    e: "ECOWAS was established by the Treaty of Lagos signed on May 28, 1975.",
    full: "The Economic Community of West African States (ECOWAS) was founded on May 28, 1975, with the signing of the Treaty of Lagos. Its primary goal was to promote economic integration and cooperation among West African states.",
    h: "The treaty is named after the city where it was signed."
  },
  {
    yr: 1979,
    q: "ECOWAS represents",
    o: [
      "the English-speaking equivalent of the Francophone economic community in West Africa.",
      "an attempt to progressively eliminate obstacles to free movement of goods, services and people throughout West Africa.",
      "a continent-wide economic dimension of pan-Africanism.",
      "a concrete achievement by the Economic Community for Africa (ECA)."
    ],
    a: 1,
    e: "ECOWAS aims to eliminate trade barriers and promote the free movement of people, goods, and services.",
    full: "A core objective of ECOWAS, as outlined in its treaty (Article 3), is the elimination of customs duties and other barriers to trade, as well as the abolition of obstacles to the free movement of persons, goods, services, and capital within the West African region.",
    h: "Think about what 'economic community' implies for movement across borders."
  },
  {
    yr: 1981,
    q: "Where is the Headquarters of the fund of the Economic Community of West African States (ECOWAS)?",
    o: ["Lagos.", "Accra.", "Cotonou.", "Lome."],
    a: 2,
    e: "The ECOWAS Fund for Cooperation, Compensation and Development is headquartered in Lome, Togo.",
    full: "While the ECOWAS Commission is headquartered in Abuja, Nigeria, the ECOWAS Fund for Cooperation, Compensation and Development (now known as the ECOWAS Bank for Investment and Development - EBID) is located in Lome, Togo.",
    h: "This is a specific fact about the location of the fund."
  },
  {
    yr: 1982,
    q: "The ECOWAS treaty was signed in",
    o: ["Abidjan.", "Lome.", "Lagos.", "Accra."],
    a: 2,
    e: "The ECOWAS treaty was signed in Lagos in May 1975.",
    full: "The founding treaty of ECOWAS was signed in Lagos, Nigeria on May 28, 1975.",
    h: "Nigeria hosted the signing — which city was Nigeria's capital then?"
  },
  {
    yr: 1983,
    q: "The administrative headquarters of ECOWAS is in",
    o: ["Abidjan.", "Lome.", "Accra.", "Abidjan."],
    a: 1,
    e: "The administrative headquarters of ECOWAS is in Abuja (formerly Lagos).",
    full: "ECOWAS secretariat was originally in Lagos, Nigeria, but was later moved to Abuja, Nigeria.",
    h: "The host country of ECOWAS is Nigeria — where is its capital?"
  },
  {
    yr: 1985,
    q: "The administrative headquarters of ECOWAS is in",
    o: ["Freetown.", "Lome.", "Abidjan.", "Lagos."],
    a: 3,
    e: "ECOWAS administrative HQ was in Lagos at the time of this question.",
    full: "When ECOWAS was founded in 1975, its secretariat was based in Lagos, Nigeria, which was then the federal capital.",
    h: "Where was Nigeria's capital in 1985?"
  },
  {
    yr: 1987,
    q: "Which of the following is NOT a member of ECOWAS?",
    o: ["Nigeria.", "Togo.", "Ghana.", "Cameroon."],
    a: 3,
    e: "Cameroon is not a member of ECOWAS; it belongs to ECCAS (Central African region).",
    full: "ECOWAS is a regional bloc of West African nations. Cameroon is a Central African country and belongs to the Economic Community of Central African States (ECCAS), not ECOWAS.",
    h: "Which country is geographically in Central Africa rather than West Africa?"
  },
  {
    yr: 1988,
    q: "Which of the following pairs are members of ECOWAS?",
    o: ["Nigeria and Cameroon.", "Nigeria and Cameroon.", "Congo and Cameroon.", "Nigeria and Cameroon."],
    a: 0,
    e: "Only Nigeria and other West African states are ECOWAS members.",
    full: "ECOWAS membership is restricted to West African nations. Nigeria is a founding member. Congo and Cameroon are Central African states.",
    h: "Focus on which countries fall within the West African subregion."
  },
  {
    yr: 1990,
    q: "The ECOWAS trade liberalization programme excludes trade in",
    o: ["unprocessed goods.", "crude oil.", "traditional crafts.", "industrial products."],
    a: 1,
    e: "ECOWAS trade liberalization originally excluded crude oil from its free trade provisions.",
    full: "Under the ECOWAS Trade Liberalization Scheme (ETLS), crude oil was among the goods initially excluded from the provisions of duty-free trade within the community.",
    h: "Think about which commodity is so economically sensitive that nations initially kept it outside free trade rules."
  },
  {
    yr: 1991,
    q: "ECOWAS is aimed at uniting the West African states",
    o: ["politically.", "socially.", "culturally.", "economically."],
    a: 3,
    e: "ECOWAS is primarily an economic integration body.",
    full: "ECOWAS — Economic Community of West African States — was established with the primary objective of promoting economic cooperation and integration among West African countries.",
    h: "What does the 'E' in ECOWAS stand for?"
  },
  {
    yr: 1995,
    q: "One of the achievements of ECOWAS is",
    o: [
      "adoption of colonialism.",
      "respect for human rights.",
      "settlement of Liberian refugees.",
      "eradication of vehicle insurance scheme."
    ],
    a: 2,
    e: "ECOWAS achieved notable success in peacekeeping, including managing Liberian refugee crises through ECOMOG.",
    full: "ECOWAS deployed its military monitoring group ECOMOG in Liberia during the civil war, and played a central role in managing refugee flows and restoring peace in the subregion.",
    h: "Think about ECOMOG's role in West African conflicts in the 1990s."
  },
  {
    yr: 1998,
    q: "The organ responsible for the general administration of ECOWAS is the",
    o: [
      "Executive Secretariat.",
      "Council of Ministers.",
      "Authority of Heads of State and Government.",
      "Tribunal of the Community."
    ],
    a: 2,
    e: "The general administration of ECOWAS falls under its Executive Secretariat (now called the Commission).",
    full: "The ECOWAS Secretariat, headed by the Executive Secretary, is responsible for the general administration and day-to-day running of the community's affairs.",
    h: "Which organ handles the administrative rather than political leadership of ECOWAS?"
  },
  {
    yr: 1997,
    q: "Nations join international organizations so that they could",
    o: ["advance their interests.", "get foreign aid.", "form alliances.", "become more developed."],
    a: 0,
    e: "The primary motivation for joining international organizations is to advance national interests.",
    full: "Nations participate in international organizations primarily as a means of promoting and protecting their national interests, including economic development, security, and diplomatic influence.",
    h: "What is the fundamental driver of a state's foreign policy decisions?"
  },
  {
    yr: 2003,
    q: "The activities of Nigeria in the international community are primarily influenced by",
    o: ["propaganda.", "national interest.", "military power.", "diplomacy."],
    a: 1,
    e: "National interest is the primary driver of any country's international activities.",
    full: "Like all sovereign states, Nigeria's foreign policy and international activities are fundamentally shaped by her national interest, which encompasses her political, economic, and security objectives.",
    h: "What fundamental principle guides every state's international conduct?"
  },
  {
    yr: 1987,
    q: "An important factor that brought about the introduction of federalism in Nigeria was the",
    o: [
      "existence of three regions.",
      "diversity and complexity in social and cultural patterns.",
      "existence of cultural patterns.",
      "division of powers between the federal and state governments."
    ],
    a: 1,
    e: "Nigeria's ethnic, cultural, and social diversity made federalism the most suitable form of government.",
    full: "Nigeria adopted federalism primarily because of its enormous ethnic, linguistic, and cultural diversity. A unitary system would have been unsuitable for a country with over 250 ethnic groups and distinct regional identities.",
    h: "What feature of Nigerian society made a single centralized government impractical?"
  },
  {
    yr: 1995,
    q: "The first restructuring of the Nigerian Federation took place with the",
    o: [
      "creation of the Mid-West Region.",
      "abolition of federalism in 1966.",
      "military counter-coup of 1966.",
      "creation of states in 1967."
    ],
    a: 0,
    e: "The Mid-Western Region was carved out of the Western Region in 1963, marking the first restructuring.",
    full: "In 1963, the Mid-Western Region was created from part of the Western Region, becoming Nigeria's fourth region and constituting the first major restructuring of the Nigerian federation.",
    h: "Which region was split to create a new one before the 1967 state creation exercise?"
  },
  {
    yr: 2001,
    q: "The Land Use Decree of 1970 vested the ownership of land in Nigeria in the",
    o: ["local chiefs.", "local governments.", "state governments.", "federal government."],
    a: 2,
    e: "The Land Use Act vested land ownership in state governments.",
    full: "The Land Use Decree (later Act) vested all land in each state in the Governor of that state, to be held in trust for the people. This effectively transferred land ownership from individuals and communities to state governments.",
    h: "Which tier of government holds land 'in trust' under Nigerian law?"
  },
  {
    yr: 2011,
    q: "The principle of federal character was adopted in order to promote equitable allocation of",
    o: [
      "opportunities between males and females.",
      "revenue between groups in the country.",
      "positions and appointments among people of various regions.",
      "appointments between the North and the South."
    ],
    a: 2,
    e: "Federal character ensures that appointments and positions reflect Nigeria's diversity across regions and states.",
    full: "The Federal Character Principle, enshrined in the Nigerian Constitution, was adopted to ensure that appointments into federal institutions reflect the diversity of the country, with no state or region dominating.",
    h: "What problem of regional imbalance was the federal character principle designed to solve?"
  },
  {
    yr: 1993,
    q: "Which of the following advocates equitable distribution of wealth?",
    o: ["Plutocracy.", "Capitalism.", "Socialism.", "Aristocracy."],
    a: 2,
    e: "Socialism advocates for equitable distribution of wealth among all citizens.",
    full: "Socialism is an economic and political system that advocates collective or state ownership of the means of production, and aims for an equitable distribution of wealth and resources among all members of society.",
    h: "Which ideology prioritizes collective ownership and reducing wealth inequality?"
  },
  {
    yr: 1989,
    q: "Liberalism is a philosophy underlying",
    o: ["socialism.", "capitalism.", "feudalism.", "nazism."],
    a: 1,
    e: "Liberalism underpins capitalism, emphasizing individual freedom and free markets.",
    full: "Liberalism, with its emphasis on individual rights, free markets, private property, and limited government intervention, forms the philosophical foundation of capitalism.",
    h: "Which economic system emphasizes individual freedom, private enterprise, and market competition?"
  },
  {
    yr: 1990,
    q: "Governments whose central concern is the equitable distribution of wealth are said to be",
    o: ["feudalist.", "capitalist.", "socialist.", "fascist."],
    a: 2,
    e: "Socialist governments focus on equitable wealth distribution.",
    full: "Socialism is characterized by government concern for equitable distribution of resources and wealth, often through collective ownership or regulation of the means of production.",
    h: "Which ideology places the redistribution of wealth at the center of its governance philosophy?"
  },
  {
    yr: 1984,
    q: "Nazism as a doctrine was proposed by",
    o: ["Benito Stalin.", "Adolf Hitler.", "Karl Marx.", "Josef Stalin."],
    a: 1,
    e: "Adolf Hitler was the leading proponent of Nazism in Germany.",
    full: "National Socialism (Nazism) was the ideology of the National Socialist German Workers' Party led by Adolf Hitler. It combined extreme nationalism, racism, and totalitarianism.",
    h: "Which German leader became synonymous with National Socialism in the 20th century?"
  },
  {
    yr: 1994,
    q: "Privatization and commercialization of public enterprises in Nigeria will lead to further",
    o: ["socialism.", "capitalism.", "communalism.", "fascism."],
    a: 1,
    e: "Privatization moves ownership to private hands, which is a hallmark of capitalism.",
    full: "When government transfers ownership and control of public enterprises to private individuals or groups through privatization and commercialization, the economy moves in the direction of capitalism, which favors private ownership and market-driven operations.",
    h: "Which economic system is characterized by private ownership of enterprises?"
  },
  {
    yr: 1979,
    q: "The major role of national legislature is to",
    o: [
      "scrutinize and criticize the executive branch.",
      "step into political vacuum created by weak executives.",
      "make laws for the general welfare of citizens.",
      "find ways and means to get money for governments."
    ],
    a: 2,
    e: "The primary function of any legislature is lawmaking.",
    full: "The legislature's main role is to enact laws for the peace, order, and good governance of the country. All other functions, such as oversight, are secondary to this core lawmaking mandate.",
    h: "What is the most fundamental purpose of a parliament or national assembly?"
  },
  {
    yr: 1979,
    q: "The main function of the legislature is",
    o: ["To implement law.", "to enforce law.", "to make law.", "to interpret law."],
    a: 2,
    e: "Making law is the primary function of the legislature.",
    full: "The legislature is the arm of government constitutionally empowered to make laws. Implementation is the executive's role, and interpretation belongs to the judiciary.",
    h: "Match each arm of government to its core function: make, implement, or interpret."
  },
  {
    yr: 1986,
    q: "The main function of the upper chamber in a parliamentary system of government is to",
    o: [
      "initiate new legislation.",
      "execute laws.",
      "act as a check on the lower chamber.",
      "direct the activities of the lower chamber."
    ],
    a: 2,
    e: "The upper house serves as a revising and checking body over the lower house.",
    full: "In a bicameral parliament, the upper chamber (such as a Senate or House of Lords) primarily serves as a revising body that reviews, amends, and acts as a check on legislation passed by the lower chamber.",
    h: "Why have two chambers? What does the second one add to the legislative process?"
  },
  {
    yr: 1987,
    q: "Bicameral legislature exists",
    o: [
      "where cameramen are allowed to cover the proceedings of the legislature.",
      "to prevent the concentration of power in one legislative house.",
      "to provide jobs for more politicians.",
      "to ensure that just laws are passed."
    ],
    a: 1,
    e: "Bicameralism prevents concentration of legislative power in one house.",
    full: "A bicameral legislature is established to distribute legislative power between two chambers, thereby preventing any single body from dominating the lawmaking process and providing checks and balances within the legislature itself.",
    h: "What principle does having two legislative chambers serve in governance?"
  },
  {
    yr: 1988,
    q: "A major weakness of unicameral legislature is that it",
    o: [
      "delays legislation.",
      "is unsuitable for a unitary state.",
      "breeds struggle for power.",
      "does not provide a check against hasty legislation."
    ],
    a: 3,
    e: "Without a second chamber, hasty or poorly considered laws can pass without adequate review.",
    full: "A unicameral legislature lacks the checks provided by a second chamber. This means legislation can be passed hastily without the additional scrutiny and revision that a bicameral system provides.",
    h: "What safeguard does a second legislative chamber provide that a single chamber lacks?"
  },
  {
    yr: 1985,
    q: "The supreme power of a state to make and enforce laws within its jurisdiction is called",
    o: ["decolonization.", "independence.", "nationalism.", "sovereignty."],
    a: 3,
    e: "Sovereignty refers to the supreme authority of a state over its territory.",
    full: "Sovereignty is the principle that a state has absolute and supreme authority to govern itself, make and enforce laws within its borders, and conduct its affairs without interference from external powers.",
    h: "What concept captures a state's absolute supreme authority within its own borders?"
  },
  {
    yr: 1984,
    q: "Government means the machinery established by",
    o: ["rulers.", "aliens.", "civil servants.", "people."],
    a: 3,
    e: "Government is machinery established by the people to manage their affairs.",
    full: "Government refers to the institution and machinery established by the people of a state to manage their collective affairs, maintain order, and provide public services through the exercise of authority.",
    h: "In a democratic framework, who is the ultimate source of governmental authority?"
  },
  {
    yr: 1988,
    q: "A major difference between power and authority is that authority is",
    o: [
      "popularly acquired.",
      "more frequently exercised.",
      "less dependent on costly exercise.",
      "subject to no other authority."
    ],
    a: 0,
    e: "Authority is legitimate power that is recognized and accepted by the people.",
    full: "While power is the ability to compel obedience, authority is legitimate power that is voluntarily recognized and accepted by those over whom it is exercised. Authority is thus 'popularly acquired' through legitimacy.",
    h: "What makes authority different from mere force or coercion?"
  },
  {
    yr: 1990,
    q: "Political authority is vested in the",
    o: ["state.", "judiciary.", "government.", "armed forces."],
    a: 2,
    e: "Political authority resides in the government acting on behalf of the state.",
    full: "While sovereignty belongs to the state, political authority — the right to govern and make binding decisions — is exercised by the government, which acts as the agent of the state.",
    h: "Which institution formally holds and exercises political decision-making power?"
  },
  {
    yr: 1991,
    q: "The unrestrained power of a state over its citizens defines the concept of",
    o: ["nationalism.", "self-determination.", "nation-state.", "sovereignty."],
    a: 3,
    e: "Sovereignty denotes the unrestricted supreme power of a state.",
    full: "Sovereignty represents the absolute, supreme, and unrestrained authority of a state to govern within its own territory, free from external interference or internal challenge.",
    h: "Which concept in political science describes absolute, unrestrained state power?"
  },
  {
    yr: 1991,
    q: "Political authority refers to the",
    o: [
      "ability to effect political action.",
      "capacity to produce desired political results.",
      "capacity to reshape the political behaviour of citizens.",
      "recognized right to exercise political power."
    ],
    a: 3,
    e: "Authority is the recognized and legitimate right to exercise power.",
    full: "Political authority is defined as the legitimate and recognized right to exercise power over others. It is distinguished from mere force or coercion by its acceptance and recognition by those subject to it.",
    h: "What makes political power 'authoritative' rather than merely forceful?"
  },
  {
    yr: 1993,
    q: "The sovereignty of a state is determined by",
    o: [
      "social and political aspects.",
      "economic aspects.",
      "political and legal aspects.",
      "economic and political aspects."
    ],
    a: 2,
    e: "Sovereignty is understood through political and legal dimensions.",
    full: "Sovereignty is fundamentally a political and legal concept. It is established through legal frameworks (constitutions and international law) and exercised through political institutions and processes.",
    h: "In what two related disciplines is sovereignty primarily defined and studied?"
  },
  {
    yr: 1978,
    q: "The major function of the legislative assembly is to",
    o: [
      "debate on committee reports.",
      "represent the people.",
      "make laws.",
      "vote on bills."
    ],
    a: 2,
    e: "Lawmaking is the fundamental function of the legislature.",
    full: "The primary and most important function of any legislative assembly is to make laws. All other activities — debating, representing constituents, and approving budgets — serve this overarching legislative mandate.",
    h: "What does the word 'legislature' itself tell you about its primary role?"
  },
  {
    yr: 1982,
    q: "Which of the following governs a state in-between meetings of the legislature?",
    o: [
      "The Legislative Organ.",
      "a committee of the legislature.",
      "The Lower House.",
      "The Executive."
    ],
    a: 3,
    e: "The Executive governs continuously, including when the legislature is not in session.",
    full: "The Executive arm of government is responsible for the day-to-day administration and governance of the state. It operates continuously and does not depend on the legislature being in session.",
    h: "Which arm of government has continuous governing responsibility?"
  },
  {
    yr: 1978,
    q: "All members of the government councils in the newly constituted local government councils in Nigeria were",
    o: [
      "directly elected.",
      "indirectly elected.",
      "appointed by the Head of State.",
      "appointed by the Governor."
    ],
    a: 0,
    e: "Members of the new local government councils were directly elected by the people.",
    full: "Under the 1976 local government reforms in Nigeria, local government councils were to be composed of directly elected members, establishing a democratic basis for grassroots governance.",
    h: "What democratic principle guided the composition of local government councils after the 1976 reforms?"
  },
  {
    yr: 1983,
    q: "Rates are generally collected in Nigeria by the",
    o: [
      "the Inland Revenue.",
      "the Department of Finance.",
      "the Emirate or Traditional Council.",
      "State Ministry of Finance."
    ],
    a: 0,
    e: "Rates (local taxes) are collected by local government bodies, often through inland revenue departments.",
    full: "In Nigeria, rates — which are local government levies on property and residents — are typically assessed and collected through the Inland Revenue service at the local government level.",
    h: "Which level of government is primarily responsible for collecting rates as a source of revenue?"
  },
  {
    yr: 1979,
    q: "The primary function of the judiciary is to",
    o: ["interpret the law.", "make laws.", "regulate behaviour.", "execute laws."],
    a: 0,
    e: "The judiciary's primary role is the interpretation and application of the law.",
    full: "The judiciary is responsible for interpreting the law and applying it to specific cases brought before the courts. This distinguishes it from the legislature (which makes laws) and the executive (which implements them).",
    h: "Which of the three core legal functions — make, implement, or interpret — belongs to the judiciary?"
  },
  {
    yr: 2000,
    q: "The Supreme Court through its interpretations of the constitution, is a",
    o: [
      "protector of the state.",
      "guardian of freedom.",
      "participator in the politics of the state.",
      "preserver of the status quo."
    ],
    a: 1,
    e: "The Supreme Court acts as a guardian of constitutional freedoms and rights.",
    full: "Through constitutional interpretation, the Supreme Court protects citizens' fundamental rights and freedoms from infringement by the government or other parties, making it the ultimate guardian of individual liberties.",
    h: "What does constitutional review by a supreme court primarily protect?"
  },
  {
    yr: 1997,
    q: "Judicial independence in a modern democracy can be ensured by",
    o: [
      "the confirmation of the appointment of judges by the legislature.",
      "the provision that judges can only be removed from office by the president-in-council.",
      "making judges independent of the ministry of justice.",
      "safeguarding the security of tenure of judges."
    ],
    a: 3,
    e: "Security of tenure protects judges from political pressure and ensures their independence.",
    full: "Security of tenure — ensuring that judges cannot be arbitrarily removed from office — is one of the most critical safeguards of judicial independence. It protects judges from political interference in their decision-making.",
    h: "What protects a judge from being pressured or removed for delivering unpopular judgments?"
  },
  {
    yr: 2004,
    q: "Independence of the judiciary is pertinent because it accords the judiciary the power to",
    o: [
      "dismiss any judge who has breached the judicial code of conduct.",
      "determine a fixed salary for judges.",
      "determine a fixed term of office for the judges.",
      "enable the judges to try and decide cases without bias."
    ],
    a: 3,
    e: "Judicial independence ensures judges decide cases without external bias or interference.",
    full: "The independence of the judiciary is essential because it allows judges to hear and determine cases based purely on the law and facts, without fear of reprisal or external pressure from the government or other powerful interests.",
    h: "What is the ultimate purpose of protecting the judiciary from political interference?"
  },
  {
    yr: 2009,
    q: "In order to dispense justice impartially, the judiciary primarily needs",
    o: ["discipline.", "logistics.", "motivation.", "independence."],
    a: 3,
    e: "Independence is the most essential requirement for impartial justice.",
    full: "For a judiciary to dispense justice impartially, it must be independent of the executive and legislature. Without independence, judges may be susceptible to political pressure, undermining fair adjudication.",
    h: "What single quality ensures a court can rule fairly regardless of who the parties are?"
  },
  {
    yr: 2014,
    q: "The court that has ultimate power to interpret the constitution is the",
    o: ["High Court.", "Court of Appeal.", "Supreme Court.", "Magistrate Court."],
    a: 2,
    e: "The Supreme Court is the apex court with final authority on constitutional interpretation.",
    full: "In Nigeria and most federal systems, the Supreme Court is the highest judicial authority and has the final say on the interpretation of the constitution. Its decisions are binding on all lower courts.",
    h: "Which court sits at the apex of the judicial hierarchy?"
  },
  {
    yr: 1978,
    q: "The executive performs legislative functions such as",
    o: [
      "approval of annual budgets.",
      "assenting bills into laws.",
      "formulating policies.",
      "screening of ministerial nominees."
    ],
    a: 1,
    e: "Assenting to bills — giving them presidential or royal approval — is a legislative function performed by the executive.",
    full: "While lawmaking is primarily a legislative function, the executive participates by assenting to (signing) bills passed by the legislature, thereby giving them the force of law.",
    h: "What final step does the executive take that formally turns a bill into law?"
  },
  {
    yr: 1980,
    q: "The executive arm of government includes the",
    o: ["police.", "courts.", "national assembly.", "senate."],
    a: 0,
    e: "The police are part of the executive arm, being instruments of law enforcement.",
    full: "The executive arm of government includes the President/Head of State, Cabinet, Ministries, the Civil Service, and enforcement agencies such as the police and military, which carry out executive decisions.",
    h: "Which institution enforces laws and maintains order as part of the executive function?"
  },
  {
    yr: 1985,
    q: "The executive arm of government is mainly concerned with the",
    o: ["approval of appointments.", "approval of budgets.", "implementation of policies.", "implementation of policies."],
    a: 2,
    e: "Policy implementation is the primary concern of the executive.",
    full: "The executive branch is primarily responsible for implementing and enforcing laws and government policies. While the legislature makes laws, it is the executive that carries them out through its ministries and agencies.",
    h: "What does the 'executive' arm of government actually 'execute'?"
  },
  {
    yr: 1983,
    q: "The arm of government mainly responsible for the implementation of law in Nigeria is the",
    o: ["judiciary.", "police.", "legislature.", "executive."],
    a: 3,
    e: "The executive is responsible for implementing laws in Nigeria.",
    full: "In Nigeria's constitutional framework, the executive arm — comprising the President, Governors, Ministers, and civil service — is primarily responsible for the implementation and enforcement of laws made by the legislature.",
    h: "Which arm of government 'executes' or carries out the laws?"
  },
  {
    yr: 1978,
    q: "To raise funds, local governments can levy",
    o: ["import duties.", "income taxes.", "excise duties.", "rates."],
    a: 3,
    e: "Rates are the primary form of taxation available to local governments.",
    full: "Local governments in Nigeria are empowered to levy rates on property and residents within their jurisdiction. Import duties, income taxes, and excise duties are reserved for federal and state governments.",
    h: "Which form of levy is specifically within the jurisdiction of local government authorities?"
  },
  {
    yr: 1982,
    q: "The transfer of authority to local government councils is known as",
    o: ["demarcation.", "delegation.", "devolution.", "fusion."],
    a: 2,
    e: "Devolution refers to the transfer of powers from central to local government.",
    full: "Devolution is the process by which the central or state government transfers certain powers, responsibilities, and resources to local government authorities, enabling them to govern their localities more effectively.",
    h: "What term describes the transfer of governmental power downwards to lower tiers?"
  },
  {
    yr: 1983,
    q: "Local governments in Nigeria are created by",
    o: [
      "the Inland Revenue.",
      "the Local Government Council.",
      "the State Ministry of Finance.",
      "Federal Military Government."
    ],
    a: 3,
    e: "Local governments in Nigeria are created by the state or federal government.",
    full: "In Nigeria, local government areas are created by the state governments, subject to approval by the National Assembly. During military rule, the Federal Military Government exercised this power directly.",
    h: "Which level of government has the authority to create or dissolve local government areas?"
  },
  {
    yr: 1985,
    q: "The term Chief-in-Council in Nigeria means that the",
    o: [
      "Chief is elected by the council.",
      "is superior to the council.",
      "cannot oppose the decision of the council.",
      "is nominated by the government."
    ],
    a: 0,
    e: "Chief-in-Council implies the chief governs with and through a council.",
    full: "The concept of Chief-in-Council in Nigerian traditional governance means that the traditional ruler (chief) exercises authority in conjunction with a council. The council's role means the chief is in effect chosen and constrained by it.",
    h: "What does the phrase 'in council' suggest about the relationship between a chief and the council?"
  },
  {
    yr: 1991,
    q: "The primary function of a pressure group is to",
    o: [
      "win elections.",
      "elect their officials.",
      "organize and fight corrupt officials.",
      "influence the Legislature and the Executive to make decisions favourable to them."
    ],
    a: 3,
    e: "Pressure groups aim to influence government policy and decisions in their favour.",
    full: "Pressure groups are organizations that seek to influence the policies and decisions of government without seeking direct control of political power. Their primary tool is lobbying the legislature and executive to act in their members' interests.",
    h: "What distinguishes a pressure group from a political party in its relationship to government?"
  },
  {
    yr: 1992,
    q: "The major distinguishing factor between a pressure group and a political party is that while the former",
    o: [
      "is effectively organized, the latter is not.",
      "influences the policies of the government, the latter does not.",
      "does not form a government, the latter does.",
      "seeks power, the latter influences it."
    ],
    a: 2,
    e: "Pressure groups influence government but do not seek to form one; political parties aim to govern.",
    full: "The fundamental distinction is that political parties contest elections and seek to control government, while pressure groups only seek to influence those in power without themselves seeking office or forming a government.",
    h: "Does a pressure group ever field candidates to actually run the government?"
  },
  {
    yr: 1987,
    q: "The major aim of pressure groups is to",
    o: ["influence government policy.", "form a government.", "win elections.", "capture political power."],
    a: 0,
    e: "Influencing government policy is the core aim of pressure groups.",
    full: "Pressure groups exist primarily to influence government policy in favor of their members or causes. They employ various strategies such as lobbying, public campaigns, and strikes, but unlike political parties, they do not aim to capture or exercise political power themselves.",
    h: "What is the difference between 'influencing' power and 'capturing' power?"
  },
  {
    yr: 1991,
    q: "The primary function of a pressure group is to",
    o: [
      "win elections.",
      "elect their officials.",
      "organize and fight corrupt government.",
      "influence government policy."
    ],
    a: 3,
    e: "Pressure groups seek to influence, not capture, government.",
    full: "The primary purpose of pressure groups is to advocate for their interests by influencing the decisions and policies of government. They achieve this through lobbying, public campaigns, media engagement, and other forms of advocacy.",
    h: "Does a pressure group seek to replace the government or just influence it?"
  },
  {
    yr: 1987,
    q: "Groups which seek to bring about changes in government policies without actually controlling the government are known as",
    o: ["trade unions.", "pressure groups.", "secret societies.", "elite groups."],
    a: 1,
    e: "Pressure groups aim to change policies without seeking governmental control.",
    full: "Pressure groups are defined as organizations that seek to influence government policy without seeking to capture governmental power. This distinguishes them from political parties, which actively compete for control of government.",
    h: "What is the defining feature of a group that wants policy change but not political office?"
  },
  {
    yr: 1995,
    q: "The feature which best differentiates pressure groups from political parties is that they do not",
    o: [
      "lack of an acceptable revenue allocation formula.",
      "inability to conduct a successful census.",
      "high cost of administration.",
      "frequent change of government."
    ],
    a: 0,
    e: "Pressure groups do not seek to capture political power, unlike political parties.",
    full: "The most fundamental distinction between pressure groups and political parties is that pressure groups do not contest elections or seek to form a government. They only seek to influence those who hold power.",
    h: "What is the one thing a pressure group never does that a political party always does?"
  },
  {
    yr: 2000,
    q: "A major issue that distinguishes pressure groups from political parties is",
    o: ["membership.", "ideology.", "the objective.", "articulation."],
    a: 2,
    e: "The objective — influencing vs. controlling government — is the key distinction.",
    full: "While both pressure groups and political parties may have ideologies and memberships, the critical distinguishing factor is their objective. Political parties seek to control government; pressure groups only seek to influence it.",
    h: "In comparing the two types of organizations, which characteristic is most definitively different?"
  },
  {
    yr: 1998,
    q: "The feature which best differentiates pressure groups from political parties is that they do not",
    o: [
      "have interest in politics.",
      "have permanent organization.",
      "seek to influence public opinion.",
      "seek to capture government power."
    ],
    a: 3,
    e: "Pressure groups do not seek to capture government power, unlike political parties.",
    full: "The defining characteristic that sets pressure groups apart from political parties is that pressure groups do not contest elections or seek to hold governmental office. Their goal is solely to influence those who govern.",
    h: "What single ambition does a political party have that a pressure group deliberately avoids?"
  },
  {
    yr: 1999,
    q: "Pressure groups harmonize different individual concerns through",
    o: [
      "Have interest in politics.",
      "Seek to influence public opinion.",
      "Have permanent organization.",
      "articulation."
    ],
    a: 3,
    e: "Pressure groups harmonize individual interests through the articulation of collective demands.",
    full: "One of the key functions of pressure groups is interest articulation — aggregating and expressing the diverse concerns of their members in a coherent form that can be effectively presented to government decision-makers.",
    h: "What political process involves gathering and expressing members' interests to government?"
  },
  {
    yr: 2011,
    q: "In a unitary system of government, power is concentrated at the centre",
    o: ["with devolution.", "without residual functions.", "without devolution.", "with residual functions."],
    a: 2,
    e: "In a unitary system, power is centralized without devolution to constituent units.",
    full: "A unitary state centralizes all significant governmental powers at the national level. There is no constitutionally guaranteed devolution of power to regions or localities — any powers held by lower units are granted by the centre and can be revoked.",
    h: "What happens to power in a unitary state — is it spread out or concentrated?"
  },
  {
    yr: 2000,
    q: "One main weakness of a unitary system of government is that",
    o: [
      "it facilitates the domination of minority groups.",
      "the constitution can be amended easily.",
      "it is run as a single entity.",
      "carpet-crossing and opposition are made difficult."
    ],
    a: 0,
    e: "Unitary systems can allow majority groups to dominate minorities due to centralized power.",
    full: "A major criticism of unitary government is that concentration of power at the center can allow majority ethnic, regional, or political groups to dominate and marginalize minorities, as there are no constitutionally protected regional power bases for minority groups.",
    h: "How might centralized power disadvantage groups that are not in the political majority?"
  },
  {
    yr: 2011,
    q: "Which of the following countries is a unitary state?",
    o: ["United States of America.", "Ghana.", "Nigeria.", "India."],
    a: 1,
    e: "Ghana operates as a unitary state with centralized governance.",
    full: "Ghana is a unitary republic where governmental authority is centralized. The USA, Nigeria, and India are all federal states where power is constitutionally divided between central and regional governments.",
    h: "Which of these countries does not have a federal constitution dividing power between central and regional governments?"
  },
  {
    yr: 1997,
    q: "Federalism was adopted in Nigeria as a",
    o: [
      "educational imbalance.",
      "national identity.",
      "constitutional response to the problem of ethnic pluralism.",
      "manpower and resources."
    ],
    a: 2,
    e: "Nigeria adopted federalism to manage its ethnic diversity and prevent domination.",
    full: "Nigeria adopted federalism as the appropriate constitutional response to its enormous ethnic diversity. With hundreds of ethnic groups, a federal structure allowed for the accommodation of different regional identities while maintaining national unity.",
    h: "What problem was federalism specifically designed to solve in the Nigerian context?"
  },
  {
    yr: 2009,
    q: "Nigeria's foreign policy is primarily influenced by",
    o: ["boundary disputes.", "fiscal allocation.", "national interest.", "population and geographical location."],
    a: 2,
    e: "Nigeria's foreign policy, like that of every state, is primarily driven by national interest.",
    full: "Nigeria's foreign policy is fundamentally shaped by her national interest, which includes economic development, regional security, continental leadership in Africa, and the welfare of her citizens abroad.",
    h: "What is the universal primary driver of any state's foreign policy?"
  },
  {
    yr: 2019,
    q: "The focus of Nigeria's foreign policy is",
    o: [
      "Commonwealth as its centerpiece.",
      "African Union as its centerpiece.",
      "African as its centerpiece.",
      "ECOWAS as its centerpiece."
    ],
    a: 2,
    e: "Africa is the centerpiece of Nigeria's foreign policy.",
    full: "Nigeria's foreign policy has consistently identified Africa as its centerpiece. This Afrocentric posture means Nigeria prioritizes African affairs, pan-African solidarity, and the welfare of African peoples in its international relations.",
    h: "Nigeria identifies itself as a 'giant' of which continent, making it central to her foreign policy?"
  },
  {
    yr: 2021,
    q: "The policy that encapsulates the actions of a state towards others is",
    o: ["International policy.", "Foreign policy.", "Foreign relations.", "Diplomatic policy."],
    a: 1,
    e: "Foreign policy is the term for a state's guidelines governing its actions towards other states.",
    full: "Foreign policy is the set of principles, strategies, and decisions that guide a country's interactions with other nations and international organizations. It encapsulates how a state pursues its interests on the international stage.",
    h: "What is the general term for the strategies a country uses to interact with the rest of the world?"
  },
  {
    yr: 2021,
    q: "The decision and actions taken by a state to pursue her interests in relation to other states is referred to as",
    o: ["Non-alignment.", "proto-nationalism.", "foreign policy.", "decolonization."],
    a: 2,
    e: "Foreign policy encompasses all decisions and actions a state takes in pursuit of its international interests.",
    full: "Foreign policy refers to the totality of a government's decisions and actions that shape its relationships and interactions with foreign states and international organizations in pursuit of national interests.",
    h: "What two-word term describes how a state manages its external relationships?"
  },
  {
    yr: 2006,
    q: "Nigeria became a frontline state in the Southern African liberation struggle because of her",
    o: [
      "influence on African proxy wars.",
      "commitment to end colonialism.",
      "anti-apartheid stance.",
      "nations south of the equator."
    ],
    a: 2,
    e: "Nigeria's strong anti-apartheid stance made her a frontline state in the liberation struggle.",
    full: "Nigeria was recognized as a frontline state in the struggle against apartheid and colonialism in Southern Africa due to her strong and consistent anti-apartheid stance, financial support for liberation movements, and diplomatic pressure against South Africa's racist regime.",
    h: "What specific policy of the South African government did Nigeria most actively oppose?"
  },
  {
    yr: 2005,
    q: "Nigeria's commitment to the liberation of Africa could best be seen in her policy towards South Africa",
    o: [
      "influence on African proxy wars.",
      "commitment to end colonialism.",
      "anti-apartheid stance.",
      "nations south of the equator."
    ],
    a: 2,
    e: "Nigeria's anti-apartheid policy was the clearest expression of her commitment to African liberation.",
    full: "Nigeria's opposition to apartheid in South Africa — including supporting sanctions, liberation movements, and boycotting the 1976 Olympics — was the most concrete demonstration of her policy of supporting the liberation of Africa from racial oppression.",
    h: "Which specific South African policy did Nigeria most vigorously oppose on the world stage?"
  },
  {
    yr: 2014,
    q: "Nigeria is regarded as a frontline state because",
    o: [
      "she assisted ECOMOG troops in Liberia.",
      "she sent policemen to Somalia.",
      "she sent troops to Southern Africa.",
      "she promoted peace in Liberia."
    ],
    a: 2,
    e: "Nigeria sent troops and provided material support to liberation struggles in Southern Africa.",
    full: "Nigeria earned frontline state status primarily because of her active material, military, and diplomatic support for liberation movements in Southern Africa, particularly against apartheid South Africa, in the struggle for African independence and dignity.",
    h: "In which part of Africa was Nigeria most actively involved in supporting liberation movements?"
  },
  {
    yr: 2009,
    q: "The granting of asylum to Charles Taylor by Nigeria was to",
    o: [
      "defy the western powers.",
      "protect Nigerians in Liberia.",
      "promote peace in Liberia.",
      "control the liberation struggle."
    ],
    a: 2,
    e: "Nigeria granted Taylor asylum as part of its role in promoting peace in Liberia.",
    full: "Nigeria's decision to grant asylum to former Liberian president Charles Taylor in 2003 was part of the peace process brokered to end the Liberian civil war. The offer of asylum was intended to facilitate Taylor's departure from power and bring peace to Liberia.",
    h: "What broader peace objective was Nigeria trying to achieve by granting Taylor asylum?"
  },
  {
    yr: 2004,
    q: "The concept of non-alignment means that Nigeria should A",
    o: [
      "have nothing to do with the super-powers.",
      "not take sides in international issues.",
      "avoid dealing with any country with ideological considerations.",
      "relate only with member countries of the Non-Aligned Movement."
    ],
    a: 1,
    e: "Non-alignment means not taking sides in Cold War bloc rivalries.",
    full: "Non-alignment, as practiced by Nigeria and other developing nations, means maintaining independence in international affairs by not formally aligning with either the Western or Eastern Cold War blocs, while reserving the right to engage with all nations based on national interest.",
    h: "What did 'non-aligned' countries refuse to do during the Cold War?"
  },
  {
    yr: 2007,
    q: "A self-articulated strategy chose by a state to protect national interest is it's",
    o: ["foreign diplomacy.", "foreign policy.", "foreign relation.", "foreign investment."],
    a: 1,
    e: "Foreign policy is the self-determined strategy through which a state protects and promotes its national interest.",
    full: "Foreign policy is the body of strategies, objectives, and actions that a state designs and implements to protect its national interest in its dealings with other states and international actors.",
    h: "What is the formal term for a country's self-designed international strategy?"
  },
  {
    yr: 2000,
    q: "Nigeria's quest for a leadership role in Africa hinges principally on her",
    o: ["military might.", "economic strength.", "size and population.", "generosity."],
    a: 2,
    e: "Nigeria's claim to African leadership is primarily grounded in her size and population.",
    full: "Nigeria's aspiration to lead Africa draws principally from her status as the most populous African nation and one of the largest in terms of territory, giving her a natural claim to continental leadership.",
    h: "What demographic and geographic features distinguish Nigeria on the African continent?"
  },
  {
    yr: 1988,
    q: "One of the functions of the ministry of external affairs is the",
    o: [
      "deportation of illegal aliens.",
      "issuance of passports.",
      "defence of the country's borders.",
      "promotion of national interest."
    ],
    a: 3,
    e: "The ministry of external/foreign affairs primarily works to promote national interest abroad.",
    full: "The Ministry of External Affairs (now Foreign Affairs) is responsible for formulating and implementing foreign policy. Its core mandate is the promotion and protection of Nigeria's national interest in its relations with other countries.",
    h: "What is the ultimate purpose behind all activities of a ministry responsible for foreign affairs?"
  },
  {
    yr: 1990,
    q: "In international relations, countries have a right to",
    o: ["export oil.", "create more states.", "diplomatic immunity of their envoys.", "own a police force."],
    a: 2,
    e: "Diplomatic immunity is a recognized right of states in international relations.",
    full: "Under the Vienna Convention on Diplomatic Relations, countries have the right to have their diplomatic envoys and representatives granted immunity from the jurisdiction of the receiving state, protecting them from prosecution while carrying out diplomatic duties.",
    h: "What internationally recognized protection do diplomats enjoy in foreign countries?"
  },
  {
    yr: 2008,
    q: "A virile foreign policy is one characterized by",
    o: [
      "a vibrant press, vibrant public opinion and a dynamic civil society.",
      "propaganda, espionage and economic embargoes.",
      "a stable polity, buoyant economy and visionary leadership.",
      "the nature and dynamics of the international system."
    ],
    a: 2,
    e: "A strong, effective foreign policy requires a stable home base, economic strength, and good leadership.",
    full: "A virile (strong and effective) foreign policy is characterized by domestic stability, a robust economy that provides resources and leverage, and visionary leadership capable of articulating and pursuing national interests on the world stage.",
    h: "What domestic conditions must exist for a country to project power internationally?"
  },
  {
    yr: 2021,
    q: "Nigeria chose Africa as the center piece of her foreign policy because",
    o: [
      "She wants to promote friendly relations among independent African states.",
      "She wants to sustain her dominance over other African states.",
      "Her economy cannot grow without the support of other African States.",
      "She wanted to promote sports and cultural relations among African states."
    ],
    a: 0,
    e: "Nigeria prioritizes Africa to promote solidarity and friendly relations among African states.",
    full: "Nigeria's Afrocentric foreign policy is rooted in the desire to foster unity, peace, and friendly relations among African states, reflecting the pan-African ideals that have guided Nigerian foreign policy since independence.",
    h: "What pan-African ideal motivates Nigeria's focus on the African continent in its foreign policy?"
  },
  {
    yr: 2005,
    q: "One of the following major problems of Nigerian federalism is majorly based on",
    o: [
      "national interest, population and landmass.",
      "derivation, school enrolment and geographical stability.",
      "landmass, school enrolment and geographical location.",
      "inadequate manpower to fill vacancies."
    ],
    a: 0,
    e: "Revenue allocation disputes in Nigerian federalism are largely based on national interest, population, and landmass.",
    full: "Nigeria's revenue allocation formula controversies primarily revolve around the principles of national interest, population, and landmass/terrain as bases for distributing federally collected revenue among states and the federal government.",
    h: "What three criteria are central to revenue allocation disputes in Nigeria's federalism?"
  },
  {
    yr: 2008,
    q: "One of the features of a sovereign state is that it",
    o: [
      "practises the presidential system.",
      "has a large number of soldiers.",
      "is not indebted to other countries.",
      "is not indebted to other countries."
    ],
    a: 2,
    e: "A sovereign state is not subject to external authority or control.",
    full: "A key feature of state sovereignty is that the state is not answerable to any external authority in its internal governance. A sovereign state has the supreme right to govern itself without external interference.",
    h: "What does 'sovereign' mean in terms of a state's relationship with other states?"
  },
  {
    yr: 1994,
    q: "The most distinguishing characteristic of the state is",
    o: ["government.", "more organized system.", "well-defined territory.", "population."],
    a: 2,
    e: "A defined territory is what most distinctly characterizes a state.",
    full: "Among all the elements of a state (population, government, sovereignty, territory), a well-defined territory is the most distinctive characteristic because without territory there can be no state — it is the physical foundation upon which the state is built.",
    h: "Which element of statehood is most uniquely physical and geographical?"
  },
  {
    yr: 2002,
    q: "The principle of federal character was adopted in order to promote equitable allocation of",
    o: ["Ashby Commission.", "Adedeji Commission.", "Udoji Commission.", "Phillipson Commission."],
    a: 3,
    e: "The Phillipson Commission was an ad hoc Revenue Allocation Commission.",
    full: "The Phillipson Commission of 1946 was an early ad hoc body set up to recommend a revenue allocation formula for Nigeria. It was one of several commissions established to address the complex question of revenue sharing in the Nigerian federation.",
    h: "Which of these commissions predated Nigerian independence and was among the earliest revenue allocation bodies?"
  },
  {
    yr: 2013,
    q: "The intergovernmental relationship between the tiers of government where taxing powers are defined is",
    o: [
      "promote sectional interests.",
      "address minorities.",
      "ensure equitable relations.",
      "consolidate federal system of government."
    ],
    a: 2,
    e: "Cooperative/dual federalism describes the relationship between tiers of government regarding taxation.",
    full: "In Nigerian federalism, the intergovernmental relationship between federal, state, and local governments regarding taxation is defined through constitutional provisions and fiscal federalism arrangements that aim to ensure equitable distribution of revenue.",
    h: "What type of federalism describes the formal relationship between different tiers of government?"
  },
  {
    yr: 2021,
    q: "One of the reasons for creating states in Nigeria is",
    o: [
      "promote sectional interests.",
      "address minorities.",
      "ensure equitable relations.",
      "consolidate federal system of government."
    ],
    a: 1,
    e: "State creation in Nigeria was partly motivated by the need to address minority concerns.",
    full: "State creation in Nigeria has been driven largely by the demands of minority ethnic groups who felt dominated within larger regions. Creating more states was seen as a way to address minority grievances and give smaller groups greater political representation.",
    h: "What political problem were minority groups experiencing that state creation was meant to solve?"
  },
  {
    yr: 1982,
    q: "Federal Military Government Reforms were carried out in",
    o: ["1970.", "1976.", "1979.", "1967."],
    a: 0,
    e: "Major local government reforms were carried out in 1976 under the military.",
    full: "The comprehensive local government reforms in Nigeria were carried out in 1976 under the Murtala-Obasanjo military regime. These reforms standardized the structure of local government across the country and gave local councils greater autonomy.",
    h: "Under which military administration were the landmark local government reforms conducted?"
  },
  {
    yr: 2024,
    q: "NEPAD stands for",
    o: [
      "New Economic Programmes for Africa.",
      "New Economic Partnerships for Africa.",
      "New Partnerships for Africa's Development.",
      "New Economic Programmes for African Development."
    ],
    a: 2,
    e: "NEPAD stands for New Partnership for Africa's Development.",
    full: "NEPAD — New Partnership for Africa's Development — is a development program of the African Union launched in 2001 to promote sustainable development, eradicate poverty, and integrate Africa into the global economy.",
    h: "The 'P' in NEPAD stands for 'Partnership' — which option reflects this accurately?"
  },
  {
    yr: 2012,
    q: "NEPAD stands for",
    o: [
      "reliance on Western donors for youth.",
      "New Economic Partnerships for Africa.",
      "New Partnerships for Africa's Development.",
      "New Economic Programmes for African Development."
    ],
    a: 2,
    e: "NEPAD stands for New Partnership for Africa's Development.",
    full: "NEPAD is the African Union's strategic framework for pan-African development, aiming to promote socioeconomic development, democracy, and good governance across the continent.",
    h: "Remember: NEPAD is a 'Partnership' for 'Development' — not a 'Programme' or 'Economic Partnership'."
  },
  {
    yr: 2006,
    q: "NEPAD was adopted during the OAU summit held in",
    o: ["Tunis.", "Lusaka.", "Cairo.", "Abuja."],
    a: 1,
    e: "NEPAD was formally adopted at the OAU summit in Lusaka, Zambia in 2001.",
    full: "NEPAD was formally adopted by African heads of state at the 37th OAU Summit held in Lusaka, Zambia in July 2001, consolidating earlier African development initiatives into one framework.",
    h: "Which Zambian capital hosted the OAU summit where NEPAD was formally adopted?"
  },
  {
    yr: 2007,
    q: "A major drawback to the NEPAD initiative is",
    o: [
      "articulation by few African leaders.",
      "affiliation.",
      "inability to empower the African Union.",
      "failure."
    ],
    a: 0,
    e: "NEPAD's major drawback has been its promotion by only a few African leaders without broad grassroots ownership.",
    full: "Critics of NEPAD have argued that it was driven by a small group of African leaders without sufficient consultation with civil society or ordinary Africans, giving it a top-down character that limited popular ownership and effectiveness.",
    h: "What organizational weakness made NEPAD difficult to implement broadly across Africa?"
  },
  {
    yr: 2024,
    q: "The body established by the federal government of Nigeria with the responsibility to promote, monitor and enforce compliance with the principles of proportional sharing of all bureaucratic, economic, media and political posts at all levels of government is the",
    o: [
      "Corporate Affairs Commission.",
      "National Planning Commission.",
      "Nigeria Investment Promotion Commission.",
      "Federal Character Commission."
    ],
    a: 3,
    e: "The Federal Character Commission enforces the federal character principle in appointments.",
    full: "The Federal Character Commission was established to ensure that the composition of federal institutions, government agencies, and parastatals reflects Nigeria's federal character by ensuring equitable representation of all states and ethnic groups.",
    h: "Which commission specifically monitors appointments to ensure they reflect Nigeria's diversity?"
  },
  {
    yr: 2013,
    q: "The rationale behind the adoption of a federal system of government in Nigeria is to",
    o: [
      "Promote unity in diversity.",
      "Establish a powerful central government.",
      "Create more states.",
      "Unification for natural resources."
    ],
    a: 0,
    e: "Federalism in Nigeria is designed to promote unity while accommodating diversity.",
    full: "Nigeria adopted federalism to reconcile its enormous ethnic, cultural, and religious diversity with the need for national unity. The federal structure allows different groups to maintain their identities while cooperating under a common national framework.",
    h: "What is the classic justification for adopting federalism in a diverse multi-ethnic country?"
  },
  {
    yr: 2023,
    q: "Which of the following is a major reason for the adoption of Nigerian Federalism?",
    o: [
      "Availability of natural resources.",
      "Size of the country.",
      "Heterogeneous ethnic diversity.",
      "Unification for natural resources."
    ],
    a: 2,
    e: "Ethnic heterogeneity is the primary reason Nigeria adopted federalism.",
    full: "Nigeria's adoption of federalism was fundamentally driven by the need to accommodate its extraordinary ethnic heterogeneity. With hundreds of distinct ethnic groups, a federal structure provided the mechanism to distribute power and prevent domination.",
    h: "What aspect of Nigeria's population made centralized unitary government impractical?"
  },
  {
    yr: 2008,
    q: "The Nigeria-Cameroun crisis over the Bakassi peninsula occurred owing to the interpretation of the treaty of 1913 and the",
    o: ["Maroua Accord.", "Treaty of Lagos.", "ECOWAS Treaty.", "Anglo-Nigerian Defence Pact."],
    a: 0,
    e: "The Bakassi crisis was linked to the interpretation of the 1913 treaty and the Maroua Accord.",
    full: "The territorial dispute between Nigeria and Cameroon over the Bakassi Peninsula arose from competing interpretations of colonial-era agreements, including the Anglo-German treaty of 1906/1913 and the Maroua Declaration of 1975 signed by Gowon and Ahidjo.",
    h: "Which bilateral accord, signed in 1975, was central to the Bakassi territorial dispute?"
  },
  {
    yr: 1986,
    q: "Traditional rulers under the 1976 Local Government Reforms had",
    o: ["executive powers.", "Chief-in-council status.", "limited powers.", "legislative powers."],
    a: 2,
    e: "Under the 1976 reforms, traditional rulers had only limited and advisory powers.",
    full: "The 1976 local government reforms in Nigeria significantly curtailed the powers of traditional rulers. They were given only limited, primarily ceremonial and advisory roles, with executive powers transferred to elected local government councils.",
    h: "Did the 1976 reforms strengthen or weaken the position of traditional rulers?"
  },
  {
    yr: 1990,
    q: "The most important challenge facing the Fourth Republic is",
    o: [
      "ethnicity.",
      "politicization.",
      "lopsided size of the component units.",
      "rigging of elections."
    ],
    a: 3,
    e: "Electoral rigging was identified as the most pressing challenge facing Nigeria's Fourth Republic.",
    full: "Nigeria's Fourth Republic, which began in 1999, has been persistently challenged by the problem of electoral malpractice and rigging. Free, fair, and credible elections have been a recurring challenge threatening the stability and legitimacy of democratic governance.",
    h: "What electoral problem has most directly threatened the credibility of Nigeria's Fourth Republic?"
  },
  {
    yr: 1984,
    q: "One of the general features of a totalitarian state is the existence of",
    o: [
      "a government that aspires to control every aspect of a citizen's life.",
      "the rule of the few.",
      "the elimination of all forms of competition.",
      "privately owned."
    ],
    a: 0,
    e: "Totalitarianism seeks total control over all aspects of citizens' lives.",
    full: "A totalitarian state is characterized by the government's aspiration to control all aspects of public and private life — including politics, economy, culture, and personal behavior — leaving no sphere of life outside state authority.",
    h: "What does the word 'total' in 'totalitarianism' tell you about the scope of government control?"
  },
  {
    yr: 1982,
    q: "Fascism is a system of government which",
    o: [
      "encourages political dissent and opposition.",
      "promotes the international brotherhood of man.",
      "promotes equality.",
      "encourages opposition."
    ],
    a: 0,
    e: "Fascism suppresses political dissent and opposition, not encourages it.",
    full: "Fascism is an authoritarian and nationalistic political ideology that suppresses opposition and dissent. It is characterized by dictatorial power, forcible suppression of opposition, and strong regimentation of society and the economy.",
    h: "Is fascism compatible with political opposition and free expression?"
  },
  {
    yr: 2000,
    q: "A political ideology that advocates extreme nationalism and suppression of individual liberties is",
    o: ["socialism.", "communism.", "feudalism.", "totalitarianism."],
    a: 3,
    e: "Fascism (totalitarianism) advocates extreme nationalism and suppression of individual liberties.",
    full: "Fascism is a political ideology characterized by extreme nationalism, authoritarianism, and the suppression of individual liberties in the interest of the state. It rejects liberal democracy, socialism, and communism in favor of totalitarian national unity.",
    h: "Which ideology combines extreme nationalism with the forceful suppression of individual freedom?"
  },
  {
    yr: 2007,
    q: "A characteristic of a fascist state is the existence of a",
    o: ["zero-party system.", "two-party system.", "multi-party system.", "one-party system."],
    a: 3,
    e: "Fascist states typically operate with a single party controlling all political power.",
    full: "Fascist states are characterized by a one-party system in which the ruling fascist party monopolizes political power, banning or suppressing all opposition parties. This is a hallmark of fascism's totalitarian nature.",
    h: "How many political parties does a fascist state typically permit?"
  },
  {
    yr: 1989,
    q: "Which of the following is NOT a member of ECOWAS?",
    o: ["Nigeria.", "Burkina Faso.", "Senegal and South Africa.", "Tanzania."],
    a: 2,
    e: "South Africa is a Southern African country and is not a member of ECOWAS.",
    full: "ECOWAS membership is restricted to West African nations. South Africa is a Southern African country and is not a member of ECOWAS. Tanzania is an East African nation also outside ECOWAS.",
    h: "Which of these countries is located outside the West African subregion?"
  },
  {
    yr: 2019,
    q: "Centralization of state authority is closely associated with",
    o: ["Unitary system.", "Presidential system.", "Parliamentary system.", "Federal system."],
    a: 0,
    e: "A unitary system centralizes state authority at the national level.",
    full: "The unitary system of government is defined by the centralization of governmental authority in one supreme national government. Unlike federalism, there is no constitutional division of powers between the national and sub-national governments.",
    h: "Which system of government concentrates power at a single central point?"
  },
  {
    yr: 2024,
    q: "Absence of Red-tape is a merit of",
    o: [
      "federal government structure.",
      "unitary structure.",
      "confederal structure.",
      "republican structure."
    ],
    a: 1,
    e: "The unitary system avoids bureaucratic duplication, reducing red tape.",
    full: "In a unitary system, because there is only one tier of government making decisions, there is less bureaucratic complexity and duplication compared to a federal system where multiple layers of government may be involved. This makes administration more streamlined, reducing red tape.",
    h: "Which system of government has fewer layers of bureaucracy — unitary or federal?"
  },
  {
    yr: 2002,
    q: "The body set up to review the revenue allocation formula in 1980 was the",
    o: ["Udoji Commission.", "Dina Commission.", "Okigbo Commission.", "Adebo Commission."],
    a: 2,
    e: "The Okigbo Commission was set up to review the revenue allocation formula in 1980.",
    full: "The Okigbo Commission (Presidential Commission on Revenue Allocation) was established in 1980 under President Shehu Shagari to review and recommend a new revenue allocation formula for Nigeria.",
    h: "Which commission, named after a famous Nigerian economist, reviewed revenue allocation in 1980?"
  },
  {
    yr: 2003,
    q: "A problem of Nigerian federalism that was resolved by the Supreme Court between the federal government and the littoral states centered on resource",
    o: ["maximization.", "generation.", "derivation.", "control."],
    a: 2,
    e: "The Supreme Court ruled on revenue derivation and resource control between the federal government and littoral states.",
    full: "The Supreme Court of Nigeria adjudicated a major dispute between the federal government and oil-producing coastal states regarding the ownership and derivation benefits from offshore oil resources, affirming federal ownership of offshore resources beyond certain limits.",
    h: "What revenue principle was at the heart of the dispute between the federal government and oil-producing coastal states?"
  },
  {
    yr: 1998,
    q: "The sovereignty of a state is determined by",
    o: ["sovereignty.", "the rule of law.", "legitimacy.", "obedience."],
    a: 0,
    e: "Sovereignty is the supreme power of a state over its territory and people.",
    full: "Sovereignty is the defining characteristic of a state's supreme authority. It encompasses both internal sovereignty (supreme power within the territory) and external sovereignty (independence from foreign control).",
    h: "What single concept captures a state's ultimate supreme authority?"
  },
  {
    yr: 1992,
    q: "Sovereignty is limited by",
    o: ["the legal system.", "Legitimate.", "Sovereign.", "international law."],
    a: 3,
    e: "International law places limits on the exercise of state sovereignty.",
    full: "While sovereignty implies supreme authority, it is constrained in practice by international law, treaties, and the obligations states assume as members of the international community.",
    h: "What body of law governs how sovereign states relate to and constrain each other?"
  },
  {
    yr: 2008,
    q: "An indispensable feature of any government is",
    o: [
      "a written constitution.",
      "the independence of the judiciary.",
      "the separation of powers.",
      "political power."
    ],
    a: 3,
    e: "Political power is the one indispensable feature of any government.",
    full: "Every government, regardless of its form or type, must possess and exercise political power. Without power, a government cannot enforce decisions, maintain order, or govern effectively. All other features may vary across systems.",
    h: "What is the one element without which no government can function?"
  },
  {
    yr: 1984,
    q: "One of the greatest advocates of socialism was",
    o: ["Adam Smith.", "Karl Marx.", "A.V. Dicey.", "Baron de Montesquieu."],
    a: 1,
    e: "Karl Marx is the most famous advocate and theorist of socialism and communism.",
    full: "Karl Marx, together with Friedrich Engels, laid the intellectual foundations of scientific socialism and communism. His works, particularly the Communist Manifesto and Das Kapital, remain the most influential texts in socialist thought.",
    h: "Which 19th century German philosopher wrote the Communist Manifesto?"
  },
  {
    yr: 2005,
    q: "Fascism originated from",
    o: ["Italy.", "Greece.", "Germany.", "China."],
    a: 0,
    e: "Fascism originated in Italy under Benito Mussolini.",
    full: "Fascism as an organized political movement originated in Italy after World War I, led by Benito Mussolini who founded the Fascist Party and became Italy's dictator. The term 'fascism' itself derives from the Italian word 'fascio'.",
    h: "Which European country did Mussolini rule and where did fascism first emerge as a formal movement?"
  },
  {
    yr: 2006,
    q: "Serfs are the dominated class under",
    o: ["fascism.", "capitalism.", "feudalism.", "socialism."],
    a: 2,
    e: "Serfs were the dominated laboring class under the feudal system.",
    full: "In the feudal system, serfs were peasants bound to the land owned by lords. They formed the lowest and most exploited class, required to work the lord's land in exchange for protection and the use of a small plot for their own subsistence.",
    h: "Under which historical economic system were peasants bound to the land as serfs?"
  },
  {
    yr: 2012,
    q: "An ideology is essentially",
    o: [
      "a guide to political action.",
      "a manual for revolution.",
      "a curse on political actors.",
      "a non-political concept."
    ],
    a: 0,
    e: "An ideology is fundamentally a guide to political action and decision-making.",
    full: "A political ideology is a coherent set of beliefs, values, and ideas that provides a framework for understanding society and a guide for political action. It shapes how individuals and groups perceive political reality and what policies they advocate.",
    h: "What practical purpose does a political ideology serve for those who hold it?"
  },
  {
    yr: 2015,
    q: "Capitalism is an economic system in which",
    o: [
      "market forces are allowed to determine prices.",
      "there is strong individual motive to make profit.",
      "priority is given to the needs of the people.",
      "there is freedom for economic competition."
    ],
    a: 0,
    e: "Capitalism is characterized by market forces determining prices through supply and demand.",
    full: "Capitalism is an economic system in which private individuals own the means of production and market forces — the interaction of supply and demand — determine prices, production, and the distribution of goods and services with minimal government interference.",
    h: "What mechanism, rather than central planning, determines prices in a capitalist system?"
  },
  {
    yr: 2013,
    q: "One of the essential principles of communism is",
    o: ["Plutocracy.", "Capitalism.", "Socialism.", "Aristocracy."],
    a: 2,
    e: "Socialism is the transitional stage and an essential principle within communist theory.",
    full: "In Marxist theory, socialism is the intermediate stage between capitalism and full communism. It is an essential principle of communism, representing the period of collective ownership and state control that precedes the eventual classless communist society.",
    h: "In Marxist theory, what stage must society pass through before reaching full communism?"
  },
  {
    yr: 2011,
    q: "In a feudal system, the two major classes are the",
    o: ["masses.", "vassals.", "lords.", "elite."],
    a: 2,
    e: "The two major classes in feudalism were the lords (nobles) and serfs (peasants).",
    full: "Feudalism was organized around a hierarchical system of land ownership. The two principal classes were the lords (nobles and clergy) who owned the land, and the serfs (peasants) who were bound to the land and obligated to work for the lords.",
    h: "In a feudal system, who owned the land and who worked it?"
  },
  {
    yr: 1983,
    q: "A social system in which power is derived from control over land is called",
    o: ["oligarchy.", "feudalism.", "proletariat.", "feudal lords."],
    a: 1,
    e: "Feudalism is the system where power is derived from land ownership and control.",
    full: "Feudalism is a social, economic, and political system in which power and status are derived from the ownership of land. Lords who controlled large estates wielded political and economic power over the peasants and serfs who worked that land.",
    h: "In which historical system was land the primary basis of political and economic power?"
  },
  {
    yr: 1986,
    q: "A social system in which power is derived from control over land is called. Those who live by selling their labour are referred to as the",
    o: ["bourgeoisie.", "proletariats.", "feudal lords.", "slaves."],
    a: 1,
    e: "In Marxist theory, the proletariat are those who sell their labor to survive.",
    full: "In Marxist class analysis, the proletariat (working class) are those who do not own the means of production and must sell their labor power to the bourgeoisie (capitalist class) in exchange for wages in order to survive.",
    h: "What does Marx call the working class who must sell their labor to earn a living?"
  },
  {
    yr: 1990,
    q: "Marxism is directed against",
    o: [
      "state ownership of the means of production.",
      "materialism.",
      "the means of production is based on agriculture.",
      "socialism."
    ],
    a: 1,
    e: "Marxism is directed against capitalism and the material exploitation it produces.",
    full: "Marxism is fundamentally a critique of capitalism and its exploitative material conditions. Marx argued that capitalism generates class conflict through the bourgeoisie's exploitation of the proletariat, and called for the revolutionary overthrow of capitalist material relations.",
    h: "What economic system did Marx primarily critique and oppose?"
  },
  {
    yr: 1989,
    q: "Which of the following is the correct order in which societies progress, according to Marx?",
    o: [
      "Capitalism, feudalism, communism, socialism.",
      "Feudalism, capitalism, socialism, communism.",
      "Communism, capitalism, feudalism, socialism.",
      "Socialism, communism, capitalism, feudalism."
    ],
    a: 1,
    e: "Marx's historical materialism placed the order as feudalism → capitalism → socialism → communism.",
    full: "Karl Marx's theory of historical materialism proposed that human societies inevitably progress through stages: from primitive communism through slavery, feudalism, capitalism, and socialism, finally reaching the classless communist society.",
    h: "In Marx's view, which system comes before capitalism and which comes after it?"
  },
  {
    yr: 1994,
    q: "According to Marxist theory, those who live by selling their labour are referred to as the",
    o: ["feudal lords.", "proletariats.", "bourgeoisie.", "feudal lords."],
    a: 1,
    e: "The proletariat are wage laborers who sell their labor in Marxist theory.",
    full: "In Marxist terminology, the proletariat refers to the working class — those who own no means of production and must sell their labor power to capitalists (the bourgeoisie) in exchange for wages.",
    h: "What class name does Marx give to those who must work for wages because they own nothing else?"
  },
  {
    yr: 2002,
    q: "Capitalism is based on",
    o: [
      "a mixed economic system that takes all interests into consideration.",
      "individual ownership of the means of production.",
      "very fair distribution of items of trade.",
      "trading among people who own and control their items of trade."
    ],
    a: 1,
    e: "Capitalism is fundamentally based on private/individual ownership of the means of production.",
    full: "The defining feature of capitalism is the private ownership of the means of production — factories, land, machinery, and capital — by individuals or corporations. These private owners employ workers and produce goods for profit in competitive markets.",
    h: "Who owns the means of production in a capitalist system?"
  },
  {
    yr: 2019,
    q: "Capitalism is a system of economic organization that takes",
    o: ["Class interest.", "Public ownership.", "Collective ownership.", "national ownership."],
    a: 0,
    e: "Capitalism is organized around class interests, particularly those of the owning class.",
    full: "In Marxist analysis, capitalism is an economic system organized around and serving the class interests of the bourgeoisie (capitalist owning class), who control the means of production and accumulate surplus value from workers' labor.",
    h: "Whose interests does capitalism primarily serve according to political economy analysis?"
  },
  {
    yr: 2022,
    q: "Capitalism is a system of economic organization based on",
    o: ["communism.", "communalism.", "feudalism.", "capitalism."],
    a: 3,
    e: "Capitalism is based on private ownership and free market enterprise.",
    full: "Capitalism is an economic system characterized by private ownership of the means of production, free market competition, the profit motive, and wage labor. It is distinct from communism, communalism, and feudalism.",
    h: "Which option names the system itself, matching the question's subject?"
  },
  {
    yr: 2023,
    q: "An economic system that seeks complete control over the means of production by the state and its people is",
    o: ["A. socialism.", "B. communism.", "C. totalitarian state.", "D. unitary state."],
    a: 1,
    e: "Communism seeks total state and collective control over all means of production.",
    full: "Communism is the political and economic ideology that calls for the abolition of private property and complete collective or state control of the means of production, with the aim of creating a classless, stateless society where resources are distributed according to need.",
    h: "Which ideology advocates for complete collective ownership of all productive resources?"
  },
  {
    yr: 2024,
    q: "Socialism is",
    o: [
      "own and control their means of production.",
      "public ownership of means of production.",
      "means of production based on collective.",
      "individual ownership of the state."
    ],
    a: 1,
    e: "Socialism is characterized by public or collective ownership of the means of production.",
    full: "Socialism is an economic and political system in which the means of production — industries, factories, and resources — are owned collectively or by the state, rather than by private individuals, with the goal of producing for social need rather than private profit.",
    h: "Who owns the means of production under socialism — private individuals or the public/state?"
  },
  {
    yr: 2020,
    q: "A form of government which depended on land ownership is",
    o: ["Communism.", "Feudalism.", "Capitalism.", "Communalism."],
    a: 1,
    e: "Feudalism was the system where political and economic power depended on land ownership.",
    full: "Feudalism was a medieval political and economic system based on land tenure. Those who owned land (lords and nobles) held political power, while those who did not (serfs and peasants) were politically and economically subordinate.",
    h: "Which historical system made land ownership the basis of all power and status?"
  },
  {
    yr: 2021,
    q: "A form of government which ownership and control is",
    o: ["Communism.", "Socialism.", "Feudalism.", "Communalism."],
    a: 0,
    e: "Communism advocates for collective ownership and control of all means of production.",
    full: "Communism is the system in which productive property is collectively owned and controlled, with no private ownership of the means of production. All production is theoretically organized for the common good.",
    h: "Which system abolishes all private ownership in favor of collective control?"
  },
  {
    yr: 1979,
    q: "The highest legislative body in Nigeria is the",
    o: ["National Council of States.", "Senate.", "House of Representatives.", "National Assembly."],
    a: 3,
    e: "The National Assembly is the highest legislative body in Nigeria.",
    full: "Nigeria's National Assembly, comprising the Senate and the House of Representatives, is the supreme legislative body of the Federal Republic. It has the constitutional power to make laws for the peace, order, and good governance of the federation.",
    h: "What is the collective name for both chambers of Nigeria's federal legislature?"
  },
  {
    yr: 1980,
    q: "The legislative arm of a government is always",
    o: ["the Parliament.", "the Cabinet.", "the highest organ of government.", "the body that makes laws."],
    a: 3,
    e: "The legislature is always the body that makes laws.",
    full: "By definition and constitutional design, the legislative arm of government is the body vested with the power to make laws. This is its primary and universal function across all systems of government.",
    h: "What does the term 'legislative' itself tell you about what this arm of government does?"
  },
  {
    yr: 1980,
    q: "Which of the following governs a state in-between meetings of the legislature?",
    o: [
      "The Legislative Organ.",
      "a committee of the legislature.",
      "The Lower House.",
      "The Executive."
    ],
    a: 3,
    e: "The Executive governs continuously regardless of whether the legislature is in session.",
    full: "While the legislature meets periodically, the executive branch of government operates continuously, governing the state and implementing policies between legislative sessions.",
    h: "Which arm of government has continuous, day-to-day responsibility for running the state?"
  },
  {
    yr: 1985,
    q: "Which of the following is NOT a member of the Judiciary?",
    o: ["The chief justice.", "A high court judge.", "A magistrate.", "A lawyer."],
    a: 3,
    e: "A lawyer is a legal practitioner but is not a member of the judiciary.",
    full: "The judiciary comprises judicial officers — judges, magistrates, and justices — who sit and adjudicate cases. Lawyers are legal practitioners who appear before courts but are not themselves part of the judicial branch of government.",
    h: "Who argues cases before the judiciary versus who actually makes judicial decisions?"
  },
  {
    yr: 1990,
    q: "The pronouncement of judges which have the force of law are called",
    o: ["judgements.", "Judicial oaths.", "orders-in-council.", "judicial precedents."],
    a: 3,
    e: "Judicial precedents (case law) have the force of law and bind lower courts.",
    full: "Judicial precedents — also known as case law or judge-made law — are decisions of superior courts that establish legal principles binding on lower courts when deciding similar cases. They have the force of law through the doctrine of stare decisis.",
    h: "What legal doctrine makes past judicial decisions binding on future cases?"
  },
  {
    yr: 1991,
    q: "Which of the following undermines the independence of the judiciary?",
    o: [
      "The confirmation of the appointment of the chief justice by the legislature.",
      "Wide-spread use of tribunals.",
      "Payment of the salaries of judicial officers by government.",
      "Making the minister of justice the attorney-general."
    ],
    a: 2,
    e: "Government payment of judicial salaries creates potential dependence on the executive.",
    full: "When the government controls the payment of judges' salaries, it creates a potential financial dependency that could compromise judicial independence. Judges who fear salary cuts or delays may be reluctant to rule against government interests.",
    h: "How might financial control over judges affect their ability to rule impartially?"
  },
  {
    yr: 1998,
    q: "The Judiciary assigns clear meaning to the laws by",
    o: ["interpretation.", "enforcement.", "adjudication.", "Revision."],
    a: 0,
    e: "The judiciary interprets laws to give them clear and applicable meaning.",
    full: "One of the judiciary's core functions is the interpretation of laws — giving them precise meaning when applied to specific facts and circumstances. This interpretive function clarifies legislative intent and ensures consistent application of the law.",
    h: "What does a court do to a law when it applies it to a specific case?"
  },
  {
    yr: 2005,
    q: "In judicial administration, the term bench refers to the",
    o: ["judges.", "lawyers.", "litigants.", "registrars."],
    a: 0,
    e: "The 'bench' in judicial terminology refers to the judges.",
    full: "In legal parlance, the 'bench' refers collectively to judges and the judicial office. When lawyers are said to 'approach the bench,' they are approaching the judge. The phrase 'bench and bar' refers to judges and lawyers respectively.",
    h: "In the phrase 'bench and bar,' what does 'bench' refer to?"
  },
  {
    yr: 2013,
    q: "The appropriate bill is initiated by the",
    o: ["executive.", "legislature.", "speaker.", "chief justice."],
    a: 0,
    e: "The Prerogative (appropriation) bill is initiated by the executive.",
    full: "Appropriation bills — which authorize government spending — are initiated by the executive branch (specifically the presidency or ministry of finance) and then submitted to the legislature for approval as part of the budget process.",
    h: "Which arm of government prepares the budget and initiates spending proposals?"
  },
  {
    yr: 2023,
    q: "The executive branch of government is headed by the",
    o: ["speaker.", "senate president.", "chief justice.", "president."],
    a: 3,
    e: "The president heads the executive branch of government.",
    full: "In a presidential system like Nigeria's, the President is the head of the executive branch of government, serving as both head of state and head of government, and responsible for the implementation of laws and policies.",
    h: "Who is the constitutional head of the executive arm in a presidential system?"
  },
  {
    yr: 2024,
    q: "The power of Prerogative of mercy rests with the",
    o: ["executive.", "bureaucracy.", "judiciary.", "national assembly."],
    a: 0,
    e: "The prerogative of mercy — pardoning convicted persons — rests with the executive.",
    full: "The prerogative of mercy is an executive power that allows the President or Governor to grant pardons, commute sentences, or grant reprieves to convicted persons. In Nigeria, this power is exercised on the advice of the relevant Council of State.",
    h: "Which arm of government has the constitutional power to pardon convicted criminals?"
  },
  {
    yr: 1991,
    q: "The major function of the legislative assembly is to",
    o: [
      "debate on committee reports.",
      "represent the people.",
      "make laws.",
      "vote on bills."
    ],
    a: 2,
    e: "Making laws is the primary function of the legislative assembly.",
    full: "The legislature's fundamental purpose is lawmaking. All other activities — debating, scrutinizing the executive, and approving budgets — are secondary to and in service of this core constitutional mandate.",
    h: "What is the single most important purpose of a legislative assembly?"
  },
  {
    yr: 2013,
    q: "The major function of the legislature is to",
    o: ["win elections.", "elect their officials.", "organize government.", "make laws."],
    a: 3,
    e: "Making laws is the primary function of the legislature.",
    full: "The primary constitutional function of any legislature is to make laws for the governance of the state. This lawmaking mandate is the core purpose that distinguishes the legislature from the executive and judiciary.",
    h: "What function is unique to the legislature among all three arms of government?"
  },
  {
    yr: 2008,
    q: "Unicameralism is a feature of the legislature in",
    o: ["Ghana.", "Nigeria.", "Sierra Leone.", "the United Kingdom."],
    a: 0,
    e: "Ghana operates a unicameral legislature — the Parliament of Ghana.",
    full: "Ghana has a unicameral legislature, with a single chamber called the Parliament of Ghana. Nigeria, the United Kingdom, and Sierra Leone all have bicameral (two-chamber) legislatures.",
    h: "Which of these West African countries has a single-chamber parliament?"
  },
  {
    yr: 2004,
    q: "The Nigerian Federal Legislature is",
    o: ["Bicameral.", "Unicameral.", "Tricameral.", "Multicameral."],
    a: 0,
    e: "Nigeria's National Assembly is bicameral, consisting of the Senate and House of Representatives.",
    full: "Nigeria operates a bicameral legislature called the National Assembly, which consists of two chambers: the Senate (upper house with 109 senators) and the House of Representatives (lower house with 360 members).",
    h: "How many chambers does Nigeria's National Assembly have?"
  },
  {
    yr: 1982,
    q: "Bicameralism refers to",
    o: [
      "a one chamber legislature.",
      "the process of voting in the legislature.",
      "The House of Representatives.",
      "a two chamber legislature."
    ],
    a: 3,
    e: "Bicameralism means a legislature with two chambers.",
    full: "Bicameralism refers to a legislative system composed of two separate chambers or houses. Typically, these consist of an upper house (Senate) and a lower house (House of Representatives or Parliament), each with distinct roles in the legislative process.",
    h: "What does the prefix 'bi-' tell you about the number of chambers in this system?"
  },
  {
    yr: 2010,
    q: "An exception to the mandate of bicameral legislature is the",
    o: [
      "enactment of laws.",
      "representation of the citizenry.",
      "oversight of the executive.",
      "external relations."
    ],
    a: 3,
    e: "External relations (foreign affairs) are typically an executive, not a legislative, function.",
    full: "While bicameral legislatures are mandated to make laws, represent citizens, and oversee the executive, the conduct of foreign affairs and external relations is an executive function. The legislature may ratify treaties but does not conduct foreign policy.",
    h: "Which of these functions falls outside the core mandate of a legislature and belongs to the executive?"
  },
  {
    yr: 1997,
    q: "In 1979, the second republic in Nigeria, the branch of the legislature responsible for ratifying presidential nominees is the",
    o: ["Senate.", "Public Service Commission.", "House of States.", "House of Representatives."],
    a: 0,
    e: "The Senate ratifies presidential nominees in Nigeria's presidential system.",
    full: "Under Nigeria's 1979 constitution (Second Republic), the Senate was vested with the power to confirm presidential appointments, including ministers and other key government officials. This is analogous to the role of the US Senate.",
    h: "In a presidential system, which legislative chamber typically confirms executive appointments?"
  },
  {
    yr: 2009,
    q: "The committee that scrutinizes budget proposals in the legislature is the",
    o: [
      "Rules and Business Committee.",
      "Public Accounts Committee.",
      "Finance Committee.",
      "Appropriation Committee."
    ],
    a: 2,
    e: "The Finance Committee scrutinizes budget proposals in the Nigerian Federal Legislature.",
    full: "The Finance Committee of the National Assembly is responsible for scrutinizing and reviewing budget proposals and financial matters submitted to the legislature, ensuring fiscal accountability and proper appropriation of public funds.",
    h: "Which committee's name most directly relates to money and budget scrutiny?"
  },
  {
    yr: 1984,
    q: "With whom is fascism associated?",
    o: ["Adolf Hitler.", "Karl Marx.", "John Locke.", "Benito Mussolini."],
    a: 3,
    e: "Fascism is most directly associated with Benito Mussolini who coined the term.",
    full: "Benito Mussolini is the founding figure of fascism as a formal political movement. He established the first fascist party in Italy in 1919 and the word 'fascism' itself derives from his organization. While Hitler adopted similar ideas, Mussolini is the original architect of fascism.",
    h: "Who founded the original Fascist Party in Italy and coined the term 'fascism'?"
  },
  {
    yr: 2007,
    q: "In a feudal system, the two major classes are the",
    o: ["masses.", "vassals.", "lords.", "elite."],
    a: 2,
    e: "Feudalism was structured around lords who owned land and serfs who worked it.",
    full: "The feudal system was organized into a rigid hierarchy dominated by two main classes: the lords (landed nobility and clergy) who controlled the land, and the serfs or peasants who were bound to the land and obligated to provide labor and goods to their lords.",
    h: "In feudalism, who holds land (the source of power) and who is bound to work it?"
  },
  {
    yr: 1980,
    q: "The second republic in Nigeria began in the year",
    o: ["1960.", "1965.", "1979.", "1982."],
    a: 2,
    e: "Nigeria's Second Republic began in 1979 with the inauguration of President Shehu Shagari.",
    full: "Nigeria's Second Republic commenced on October 1, 1979 when Shehu Shagari was inaugurated as the first executive president under the new constitution, transitioning from military rule that had lasted since 1966.",
    h: "In which year did civilian presidential rule return to Nigeria after the first military era?"
  },
  {
    yr: 2020,
    q: "The second republic of Nigeria began in the year",
    o: ["1960.", "1965.", "1979.", "1984."],
    a: 2,
    e: "Nigeria's Second Republic began in 1979.",
    full: "The Second Republic of Nigeria was inaugurated on October 1, 1979 with the election of Shehu Shagari as executive president under a new presidential constitution modeled on the American system.",
    h: "When did President Shagari's elected civilian government begin in Nigeria?"
  },
  {
    yr: 1965,
    q: "The second republic of Nigeria began in the year",
    o: ["1979.", "1984.", "1990.", "1992."],
    a: 0,
    e: "Nigeria's Second Republic started in 1979.",
    full: "The Second Republic of Nigeria was established in 1979 when Shehu Shagari assumed the presidency, ending thirteen years of military rule that had begun after the coup of January 1966.",
    h: "Which year marked the transition from Nigeria's first post-independence military era to a new civilian government?"
  },
  {
    yr: 2021,
    q: "The most popular political party in Eastern Nigeria in the Second Republic was",
    o: ["APP.", "NPP.", "NRC.", "GDM."],
    a: 1,
    e: "The Nigeria People's Party (NPP) was most popular in Eastern Nigeria during the Second Republic.",
    full: "During the Second Republic (1979–1983), the Nigeria People's Party (NPP), led by Nnamdi Azikiwe, was the dominant political party in Eastern Nigeria, reflecting the Igbo political tradition and Azikiwe's historical leadership of the Igbo-speaking east.",
    h: "Which party was associated with Nnamdi Azikiwe and had its stronghold in Eastern Nigeria?"
  },
  {
    yr: 2004,
    q: "A major issue in the second republic was",
    o: ["A. Great Nigeria.", "C. Unity.", "B. National Party of Nigeria.", "D. diverse membership."],
    a: 1,
    e: "Sokoto and Bendel regions were contested areas during the Second Republic.",
    full: "During Nigeria's Second Republic, the contest for political control of states like Sokoto and Bendel (now Edo and Delta) was a major political issue, reflecting intense interparty rivalry between the NPN, NPP, and other parties.",
    h: "Which regions became politically contested flashpoints during the Second Republic elections?"
  },
  {
    yr: 1999,
    q: "The party that did not control any state in the Second Republic was",
    o: ["NAP.", "PRP.", "NPP.", "NPN."],
    a: 0,
    e: "The Nigeria Advance Party (NAP) did not control any state in the Second Republic.",
    full: "During the Second Republic, five main parties competed: NPN, NPP, UPN, GNPP, and PRP. The Nigeria Advance Party (NAP) did not control any state, while the other parties each had strongholds in different regions of Nigeria.",
    h: "Which of the smaller parties in the Second Republic failed to win gubernatorial control in any state?"
  },
  {
    yr: 1987,
    q: "The first state creation in Nigeria was done in",
    o: ["1958.", "1967.", "1979.", "1982."],
    a: 1,
    e: "The first major state creation exercise in Nigeria was in 1967 when 12 states were created.",
    full: "In May 1967, General Yakubu Gowon divided Nigeria's four regions into 12 states — the first major state creation exercise in the country's history. This was partly aimed at preventing the secession of the Eastern Region and accommodating minority groups.",
    h: "In which year did Gowon's military government dissolve Nigeria's regional structure into 12 states?"
  },
  {
    yr: 1995,
    q: "The component units of the Nigerian federation",
    o: ["1963.", "1966.", "1976.", "1979."],
    a: 2,
    e: "The comprehensive state restructuring of Nigeria into 19 states occurred in 1976.",
    full: "Under the Murtala Mohammed/Obasanjo military government, Nigeria was divided into 19 states in 1976, increasing from the 12 states created in 1967. This was another significant restructuring of the Nigerian federation.",
    h: "Under which military government was Nigeria divided into 19 states?"
  },
  {
    yr: 1990,
    q: "In the first republic, the major problem of the Nigerian federal structure was",
    o: ["ethnicity.", "politicization.", "lopsided size of the component units.", "rigging of elections."],
    a: 2,
    e: "The lopsided sizes of the three regions created structural imbalance in the First Republic.",
    full: "A fundamental structural problem of Nigeria's First Republic was the lopsided size of its three regions. The Northern Region was larger than the Eastern and Western regions combined, giving it an inherent political dominance that bred resentment and instability.",
    h: "What geographic-political imbalance made governance in the First Republic so contentious?"
  },
  {
    yr: 1983,
    q: "Local governments in Nigeria are created by",
    o: [
      "the Inland Revenue.",
      "the Local Government Council.",
      "the State Ministry of Finance.",
      "Federal Military Government."
    ],
    a: 3,
    e: "Local government areas are created by state governments (or federal military governments).",
    full: "In Nigeria, local government areas are created by state governments subject to National Assembly approval. During military rule, the Federal Military Government exercised this power. Local governments are the third tier of government in Nigeria's federal structure.",
    h: "Which level of government exercises the authority to create local government areas?"
  },
  {
    yr: 2015,
    q: "The most important challenge facing the Fourth Republic is",
    o: ["ethnicity.", "politicization.", "lopsided size of the component units.", "rigging of elections."],
    a: 3,
    e: "Electoral rigging has been the most persistent and damaging challenge of Nigeria's Fourth Republic.",
    full: "Electoral malpractice, particularly the rigging of elections, has been widely identified as the most important challenge confronting Nigeria's Fourth Republic since 1999. It undermines democratic legitimacy, fuels post-election violence, and weakens public trust in democratic institutions.",
    h: "What electoral problem most directly threatens the credibility of Nigeria's democratic process?"
  },
  {
    yr: 2009,
    q: "Revenue allocation in Nigeria is majorly based on",
    o: [
      "national interest, population and landmass.",
      "derivation, school enrolment and geographical stability.",
      "landmass, school enrolment and geographical location.",
      "inadequate manpower to fill vacancies."
    ],
    a: 0,
    e: "Nigeria's revenue allocation is primarily based on national interest, population, and landmass.",
    full: "Nigeria's revenue allocation formula uses several criteria including national interest (minimum responsibility of government), population, landmass/terrain, social development, and derivation. National interest, population, and landmass are among the most weighted factors.",
    h: "Which three demographic and geographic factors most heavily influence Nigeria's revenue sharing formula?"
  },
  {
    yr: 2013,
    q: "Which of the following is NOT a pressure group in Nigeria?",
    o: [
      "Farmers.",
      "The Nigerian Union of Teachers.",
      "The Catholic Church.",
      "Academic Staff Union of Universities (ASUU)."
    ],
    a: 2,
    e: "The Catholic Church is a religious institution, not a pressure group in the political sense.",
    full: "While the Catholic Church may occasionally take positions on public policy matters, it is primarily a religious institution rather than a pressure group. NUT, Farmers associations, and ASUU are organizations specifically constituted to influence government policy on behalf of their members.",
    h: "Which of these institutions exists primarily for religious rather than interest-group political purposes?"
  },
  {
    yr: 1983,
    q: "The most basic property of pressure groups which differentiates them from political parties is that",
    o: [
      "they do not form a government.",
      "they seek to influence public opinion.",
      "they do not nominate candidates.",
      "they are not interested in politics."
    ],
    a: 0,
    e: "Pressure groups do not form or seek to form a government.",
    full: "The most fundamental distinction is that pressure groups never seek to capture governmental power or form a government. They only seek to influence those who govern. Political parties, by contrast, are explicitly designed to contest elections and assume power.",
    h: "What governmental ambition does a political party have that a pressure group deliberately avoids?"
  },
  {
    yr: 2011,
    q: "The pressure groups through which concerns are expressed are known as",
    o: ["lobbying.", "memorandum.", "electioneering campaign.", "trade unions."],
    a: 0,
    e: "Lobbying is the primary method through which pressure groups express their concerns to government.",
    full: "Lobbying is the process by which pressure groups communicate their interests and concerns to legislators and government officials, seeking to influence policy decisions in their favor. It is the most recognized method of pressure group activity.",
    h: "What is the term for the direct communication of interests to government decision-makers?"
  },
  {
    yr: 2010,
    q: "The tactic employed by pressure groups to achieve their objectives is called",
    o: ["lobbying.", "memorandum.", "electioneering campaign.", "anomic."],
    a: 0,
    e: "Lobbying is the primary tactic used by pressure groups to achieve their objectives.",
    full: "Pressure groups primarily use lobbying as their main tactic — directly engaging with legislators, ministers, and government officials to advocate for policies favorable to their members' interests. Other tactics include strikes, protests, and media campaigns.",
    h: "What is the name given to the direct advocacy work pressure groups do with government officials?"
  },
  {
    yr: 2003,
    q: "The pressure group that resorts to unconventional methods to achieve its objectives is called",
    o: ["communal groups.", "trade unions.", "political groups.", "institutional groups."],
    a: 0,
    e: "Anomic or communal groups use unconventional and sometimes disruptive methods.",
    full: "Anomic pressure groups are those that use unconventional methods such as riots, demonstrations, or spontaneous protests to express their grievances. Communal groups often fall into this category when they resort to disruptive means outside normal political channels.",
    h: "Which type of group is least likely to use formal lobbying and most likely to use disruptive tactics?"
  },
  {
    yr: 2005,
    q: "The primary aim of pressure groups is to",
    o: ["attract members.", "protect the interests of its members.", "prepare the budget.", "nominate the president."],
    a: 1,
    e: "Protecting and advancing the interests of members is the primary aim of pressure groups.",
    full: "The fundamental purpose of a pressure group is to protect and promote the interests of its members by influencing government policy and public opinion. All activities of a pressure group — lobbying, strikes, campaigns — serve this core objective.",
    h: "Who do pressure groups primarily exist to serve and protect?"
  },
  {
    yr: 2012,
    q: "The main objective of pressure groups is to",
    o: [
      "attract members.",
      "nominate the president.",
      "articulate the opinion of their members.",
      "fight corrupt officials."
    ],
    a: 2,
    e: "Articulating and representing members' opinions is the core objective of pressure groups.",
    full: "Pressure groups exist to aggregate and articulate the interests and opinions of their members to government. Through this articulation function, they serve as intermediaries between citizens and the state, ensuring particular interests are heard in the policymaking process.",
    h: "What communication role do pressure groups play between their members and the government?"
  },
  {
    yr: 2013,
    q: "The main objective of pressure groups is to",
    o: [
      "nominate the president.",
      "protect the interest of the country against foreigners.",
      "articulate the opinion of their members.",
      "fight corrupt government officials."
    ],
    a: 2,
    e: "Articulating member interests is the primary objective of pressure groups.",
    full: "Pressure groups' main objective is to articulate and advance the interests of their members before government and the public. This interest articulation function is what gives pressure groups their political significance and justifies their existence.",
    h: "Whose interests and opinions are pressure groups specifically organized to represent?"
  },
  {
    yr: 2014,
    q: "The main objective of pressure groups is to",
    o: [
      "win elections.",
      "win elections for members.",
      "attract members.",
      "win favourable government decisions for members."
    ],
    a: 3,
    e: "Winning favorable government decisions for their members is the core aim of pressure groups.",
    full: "Pressure groups are formed to secure favorable government policies, decisions, and allocations for their members. Every activity of a pressure group — lobbying, strikes, campaigns — is ultimately aimed at achieving beneficial outcomes from the government.",
    h: "What specific outcome from government are pressure groups ultimately trying to achieve for their members?"
  },
  {
    yr: 2021,
    q: "The membership of pressure groups is limited because they",
    o: [
      "pursue specific and narrow interests.",
      "are mainly concerned with public objectives.",
      "promote other people's interests.",
      "are not friendly."
    ],
    a: 0,
    e: "Pressure groups have limited membership because they focus on specific, narrow interests.",
    full: "Unlike political parties which seek broad membership across society, pressure groups are limited in membership because they represent specific, narrow sectoral interests. Membership is typically restricted to those who share the particular interest the group represents.",
    h: "Why would someone who is not a teacher join the Nigerian Union of Teachers?"
  },
  {
    yr: 2019,
    q: "The anomic pressure groups usually adopt",
    o: ["strike.", "lobbying approach.", "petition option.", "spontaneous strategy."],
    a: 0,
    e: "Anomic pressure groups often resort to strikes and other disruptive spontaneous actions.",
    full: "Anomic pressure groups are characterized by their use of unconventional, often spontaneous methods of protest such as strikes, riots, and demonstrations rather than formal lobbying channels. Their actions tend to be reactive and disruptive.",
    h: "What disruptive industrial action is most commonly associated with anomic group tactics?"
  },
  {
    yr: 2009,
    q: "The anomic factor that hinders the operation of pressure groups in Nigeria is",
    o: ["Dialogue.", "Leadership.", "Objectives.", "spontaneous strategy."],
    a: 1,
    e: "Poor leadership has been an anomic factor hindering pressure group effectiveness in Nigeria.",
    full: "One of the major factors hindering the effective operation of pressure groups in Nigeria is poor and self-serving leadership. When pressure group leaders pursue personal interests rather than those of their members, the organization loses focus and effectiveness.",
    h: "What internal organizational problem most undermines a pressure group's ability to achieve its objectives?"
  },
  {
    yr: 2020,
    q: "The major aim of pressure group is to",
    o: [
      "to educate the electorate through campaigns.",
      "protect the interest of its members.",
      "interpret the law D. control the executive."
    ],
    a: 1,
    e: "Protecting member interests is the major aim of pressure groups.",
    full: "The fundamental reason pressure groups exist is to protect and advance the interests of their members in relation to government policies and decisions. All pressure group activities serve this primary purpose.",
    h: "What is the single most important purpose that motivates people to form and join pressure groups?"
  },
  {
    yr: 2024,
    q: "Pressure groups are more concerned with winning election, pressure groups are more concerned with",
    o: ["members' welfare.", "finance.", "aggregate interests.", "contest elections."],
    a: 0,
    e: "Pressure groups are primarily concerned with the welfare of their members.",
    full: "While political parties are concerned with winning elections, pressure groups are more concerned with the welfare and interests of their members. They seek to ensure that government policies are favorable to their members rather than seeking governmental power themselves.",
    h: "What do pressure groups prioritize if not winning elections?"
  },
  {
    yr: 2001,
    q: "An interest group that admits members and conducts its affairs according to stated rules is",
    o: [
      "further the interests of members.",
      "lobby the government.",
      "specifically support the government.",
      "achieve goals affecting other associations."
    ],
    a: 0,
    e: "An associational interest group formally admits members and operates by stated rules to advance member interests.",
    full: "An associational interest group is a formally organized pressure group with a constitution, stated rules, defined membership criteria, and structures. It focuses specifically on furthering the interests of its members through organized, institutionalized means.",
    h: "What term describes a formally organized interest group with membership rules and a constitution?"
  },
  {
    yr: 2009,
    q: "Nations join international organizations so that they could",
    o: ["advance their interests.", "get foreign aid.", "form alliances.", "become more developed."],
    a: 0,
    e: "Nations join international organizations primarily to advance their national interests.",
    full: "The primary motivation for nations to join international organizations is to advance their national interests — whether economic, security, or political. Membership provides platforms for cooperation, influence, and the achievement of goals that cannot be attained unilaterally.",
    h: "What fundamental principle of foreign policy explains why nations join any international body?"
  },
  {
    yr: 2012,
    q: "By Africa as the Centre Piece of Nigeria's foreign policy we mean",
    o: [
      "that Nigeria will financially support other Africa states.",
      "that Nigeria is ready to defend other African states.",
      "that Africa other African states legislature.",
      "that Nigeria will only trade with African countries."
    ],
    a: 0,
    e: "Nigeria's Africa-centred policy includes financial support for other African nations.",
    full: "Declaring Africa as the centrepiece of her foreign policy means Nigeria places the welfare, liberation, and development of Africa at the heart of her international engagements. This has included financial contributions to liberation movements, peacekeeping, and development assistance across the continent.",
    h: "In practical terms, what has Nigeria's Africa-centred foreign policy involved doing for other African states?"
  },
  {
    yr: 2014,
    q: "The fundamental objective guiding a nation's foreign policy is",
    o: ["national interest.", "foreign interest.", "African interest.", "colonial interest."],
    a: 0,
    e: "National interest is the fundamental objective guiding every nation's foreign policy.",
    full: "National interest is the ultimate objective and primary determinant of a state's foreign policy. Every foreign policy decision — from forming alliances to joining international organizations — is ultimately driven by what best serves the state's national interest.",
    h: "What concept, placed before the word 'interest', captures what any government primarily serves?"
  },
  {
    yr: 2023,
    q: "One of the most commonly used tool for foreign policy is",
    o: ["embassy.", "foreign aid.", "espionage.", "physical force."],
    a: 0,
    e: "Embassies are the primary institutional tool for conducting foreign policy.",
    full: "Embassies are the most commonly used instruments of foreign policy, serving as the official representative offices of a state in foreign countries. They facilitate diplomacy, protect citizens abroad, gather intelligence, and promote bilateral relations.",
    h: "What institution does a country establish in another country to conduct its day-to-day foreign relations?"
  },
  {
    yr: 2021,
    q: "Nigeria chose Africa as the centre piece of her foreign policy because",
    o: [
      "she wants to promote friendly relations among independent African states.",
      "she wants to sustain dominance over other African states.",
      "her economy cannot grow without the support of African states.",
      "she wants to promote sports and cultural relations among African states."
    ],
    a: 0,
    e: "Nigeria's Afrocentric policy is driven by the desire to promote unity and friendly relations among African states.",
    full: "Nigeria's choice of Africa as the centrepiece of her foreign policy is motivated by pan-African solidarity — the desire to promote cooperation, unity, and friendly relations among independent African states in the interest of collective African development and dignity.",
    h: "What pan-African ideal best explains Nigeria's commitment to prioritizing Africa in her foreign policy?"
  },
  {
    yr: 1998,
    q: "An indication that Africa is still the centre-piece of Nigeria's foreign policy",
    o: [
      "Nigerian Institute of Foreign Affairs.",
      "Ministry of Foreign Affairs.",
      "Nigeria Institute of Integration and Cooperation in Africa.",
      "Ministry of International Affairs."
    ],
    a: 2,
    e: "The Nigeria Institute of Integration and Cooperation in Africa demonstrates Nigeria's Afrocentric policy commitment.",
    full: "The Nigeria Institute of Integration and Cooperation in Africa was established as an institutional expression of Nigeria's commitment to African integration and cooperation, serving as evidence that Africa remains central to Nigeria's foreign policy framework.",
    h: "Which Nigerian institution's name most explicitly reflects a commitment to African cooperation?"
  },
  {
    yr: 2019,
    q: "One of the objectives of Nigerian foreign policy is",
    o: [
      "defending Nigeria's friends in Africa globally.",
      "promoting political instability globally.",
      "approving the annual budget of other African states.",
      "promoting world peace with justice."
    ],
    a: 3,
    e: "Promoting world peace with justice is a stated objective of Nigeria's foreign policy.",
    full: "Among the major objectives of Nigeria's foreign policy is the promotion of international peace and security with justice. This is reflected in Nigeria's active participation in UN peacekeeping missions and ECOWAS peace operations across Africa.",
    h: "What universal value, beyond just African affairs, does Nigeria's foreign policy also seek to advance globally?"
  },
  {
    yr: 2021,
    q: "Africa as the centre piece of Nigeria's foreign policy simply means that Nigeria's foreign policy will",
    o: [
      "involve other African states in the ideological rivalries between the socialist and capitalist states.",
      "foreign policy will protect the scientific and technological interests of African states only.",
      "cementing Nigeria's foreign relations.",
      "promoting world peace."
    ],
    a: 3,
    e: "Nigeria's Africa-centred policy aims to promote peace and development, not ideological rivalry.",
    full: "Making Africa the centrepiece of Nigeria's foreign policy means channeling diplomatic energy toward the promotion of peace, unity, development, and the interests of African peoples — not drawing African states into Cold War ideological conflicts.",
    h: "What positive goal for Africa does Nigeria's Afrocentric foreign policy prioritize?"
  },
  {
    yr: 2024,
    q: "The fundamental objective guiding a nation's foreign policy is",
    o: ["national interest.", "foreign interest.", "African interest.", "colonial interest."],
    a: 0,
    e: "National interest is the bedrock objective of every nation's foreign policy.",
    full: "National interest — the aggregate of a nation's goals and ambitions — is the fundamental and universal objective that drives foreign policy. All diplomatic, economic, and security decisions in the international arena are ultimately grounded in the pursuit of national interest.",
    h: "Before the word 'interest,' what adjective captures what a government is constitutionally meant to serve?"
  },
  {
    yr: 1984,
    q: "One of the features of capitalism sector is",
    o: [
      "that the major sectors of the economy are publicly owned.",
      "the predominance of the public sector in the economy.",
      "the elimination of all forms of competition.",
      "privately owned."
    ],
    a: 3,
    e: "Private ownership of the means of production is a defining feature of capitalism.",
    full: "Capitalism is characterized by the private ownership of the means of production — factories, land, and capital. The private sector dominates the economy, with market competition and the profit motive driving economic activity.",
    h: "Who owns the productive resources in a capitalist economy — the state or private individuals?"
  },
  {
    yr: 1997,
    q: "In 1975/76 Nigeria's foreign policy lacked real substance because of her",
    o: [
      "Afrocentrism.",
      "close ties with Britain.",
      "partnership with Asian countries.",
      "poor economic policy."
    ],
    a: 1,
    e: "Nigeria's close ties with Britain in the 1960s undermined the substance of her non-aligned and Afrocentric foreign policy.",
    full: "In the 1960s, Nigeria's non-alignment policy lacked real substance because of her strong economic and political ties with Britain, her former colonial power. These ties constrained Nigeria's ability to act independently in international affairs.",
    h: "Which country's lingering influence over Nigeria most undermined her declared independent foreign policy?"
  },
  {
    yr: 1994,
    q: "Nigeria's foreign policy during the civil war expressed moral support for",
    o: ["France.", "Britain.", "the United States.", "Great Britain."],
    a: 1,
    e: "Britain provided material support to the Nigerian federal government during the civil war.",
    full: "During the Nigerian Civil War (1967–1970), Britain provided military and diplomatic support to the Nigerian federal government against Biafra. This support was significant in the federal government's eventual victory.",
    h: "Which major Western power supplied arms to the Nigerian federal government during the Biafra war?"
  },
  {
    yr: 2001,
    q: "Which of the following principles does NOT govern Nigeria's foreign policy?",
    o: ["A. National Interests.", "B. Non-alignment.", "C. African Interests.", "D. International Interests."],
    a: 3,
    e: "International interest as a generic concept is not a stated principle of Nigeria's foreign policy.",
    full: "Nigeria's foreign policy is governed by principles including national interest, non-alignment, African centrepiece, respect for sovereignty, and peaceful resolution of conflicts. 'International interests' as a generic category is not among the stated governing principles.",
    h: "Which of these options is too vague and general to be a specific principle of Nigeria's foreign policy?"
  },
  {
    yr: 2014,
    q: "The Nigeria-Cameroun crisis over the Bakassi Peninsula occurred owing to the interpretation of the treaty of 1913 and the",
    o: ["Maroua Accord.", "Treaty of Lagos.", "ECOWAS Treaty.", "Non-Proliferation Treaty."],
    a: 0,
    e: "The Bakassi crisis involved disputed interpretation of the 1913 colonial treaty and the Maroua Accord.",
    full: "The Bakassi Peninsula dispute between Nigeria and Cameroon arose from competing claims based on the Anglo-German Agreement of 1906 and the subsequent 1913 treaty, as well as the Maroua Declaration of 1975 between Gowon and Ahidjo. The ICJ ultimately ruled in Cameroon's favour in 2002.",
    h: "Which bilateral 1975 agreement between Nigerian and Cameroonian leaders was central to the Bakassi dispute?"
  },
  {
    yr: 2000,
    q: "Nigeria's liberal posture to the communist bloc was a result of",
    o: ["the Murtala Mohammed regime.", "the Soviet Union.", "the Babangida Regime.", "the Shagari Regime."],
    a: 0,
    e: "The Murtala Mohammed regime shifted Nigeria's posture toward a more balanced engagement with the communist bloc.",
    full: "Under the Murtala Mohammed/Obasanjo administration (1975–1979), Nigeria took a more assertive and independent foreign policy stance, including recognizing the MPLA government in Angola against US wishes and adopting a more balanced approach toward communist bloc countries.",
    h: "Which military regime is associated with Nigeria's most assertive and independent foreign policy stance?"
  },
  {
    yr: 2003,
    q: "Nigeria's South-South cooperation",
    o: [
      "cultural affinities.",
      "economic considerations.",
      "expectations of political support from outside Africa.",
      "perceived political communities outside Africa."
    ],
    a: 0,
    e: "Nigeria's South-South relations are built on shared cultural affinities with other developing nations.",
    full: "Nigeria's South-South cooperation with other developing countries in Africa, Asia, and Latin America is grounded in shared historical experiences of colonialism, cultural affinities, and common development challenges rather than ideological alignment.",
    h: "What shared historical and cultural experiences bond Nigeria to other countries in the Global South?"
  },
  {
    yr: 2000,
    q: "Nigeria's foreign policy is essentially based and centred on issues and affairs affecting the",
    o: ["UN.", "Commonwealth.", "OAU.", "continent of Africa."],
    a: 3,
    e: "Nigeria's foreign policy is centred on African affairs.",
    full: "Nigeria's Afrocentric foreign policy places the affairs and interests of Africa at the centre of its international engagements. All of Nigeria's major foreign policy activities — peacekeeping, liberation support, diplomacy — have Africa as their primary focus.",
    h: "On which continent does Nigeria's foreign policy concentrate its primary attention?"
  },
  {
    yr: 2013,
    q: "Nigeria's opposition to apartheid was demonstrated in",
    o: ["South Africa.", "Tanzania.", "Zambia.", "Somalia."],
    a: 0,
    e: "Nigeria's opposition to apartheid was directed specifically at South Africa.",
    full: "Nigeria was one of the most vocal and active opponents of the apartheid system in South Africa, providing financial support to the ANC, lobbying for international sanctions, and boycotting events (like the 1976 Olympics) that included apartheid South Africa.",
    h: "In which country was the apartheid system practiced that Nigeria so strongly opposed?"
  },
  {
    yr: 2001,
    q: "Which of the following does NOT govern Nigeria's foreign policy?",
    o: [
      "African Interests.",
      "Non-alignment.",
      "National Interests.",
      "parliamentary system."
    ],
    a: 3,
    e: "Parliamentary system of government does not govern foreign policy — it is a domestic governmental structure.",
    full: "Nigeria's foreign policy is governed by principles such as national interest, non-alignment, respect for sovereignty, peaceful coexistence, and placing Africa as its centrepiece. The parliamentary system is a form of domestic government organization, not a foreign policy principle.",
    h: "Which option describes a system of internal government rather than a principle of international relations?"
  },
  {
    yr: 2021,
    q: "The first state creation was done in Nigeria in the year",
    o: ["1958.", "1967.", "1979.", "1982."],
    a: 1,
    e: "The first state creation in Nigeria occurred in 1967 under Gowon's government.",
    full: "In May 1967, General Yakubu Gowon created 12 states from Nigeria's existing four regions, marking the first exercise in state creation in Nigeria. This was done partly to forestall the secession of Eastern Nigeria.",
    h: "In which year did Nigeria transition from a regional to a state-based federal structure?"
  },
  {
    yr: 2021,
    q: "The first state creation was done in Nigeria in the year",
    o: ["36 states.", "20 states.", "19 states.", "21 states."],
    a: 1,
    e: "The 1999 constitution recognized 36 states in Nigeria.",
    full: "Nigeria currently has 36 states and the Federal Capital Territory of Abuja. This structure has been in place since 1996 when Abacha created 6 additional states from the existing 30, bringing the total to 36.",
    h: "How many states does Nigeria currently have under the 1999 constitution?"
  },
  {
    yr: 1978,
    q: "The new Local Government Reforms in Nigeria",
    o: [
      "directly elected.",
      "indirectly elected.",
      "appointed by the Head of State.",
      "appointed by the Governor."
    ],
    a: 0,
    e: "The 1976 reforms introduced direct elections for local government councils.",
    full: "A key feature of the 1976 local government reforms under the Murtala-Obasanjo regime was the introduction of direct elections for local government councils, democratizing grassroots governance for the first time in a systematic way.",
    h: "What democratic mechanism did the 1976 reforms introduce for selecting local government councillors?"
  },
  {
    yr: 1980,
    q: "The 1976 local government reforms in Nigeria provide for a term of office of",
    o: ["4-year.", "5-year.", "2-year.", "3-year."],
    a: 3,
    e: "The 1976 reforms provided for a 3-year term of office for local government councils.",
    full: "Under the 1976 Local Government Reforms, elected local government councils were to serve a term of three years. This was designed to ensure regular democratic renewal at the grassroots level while allowing sufficient time for councils to implement their programs.",
    h: "How long was the term of office prescribed for local government councillors by the 1976 reforms?"
  },
  {
    yr: 2019,
    q: "Which of the following is not a pressure group in Nigeria?",
    o: [
      "Nigeria Military.",
      "National Union of Nigeria.",
      "The Nigeria Union of Teachers.",
      "Academic Staff Union of Universities."
    ],
    a: 0,
    e: "The Nigeria Military is not a pressure group — it is an instrument of state power.",
    full: "The Nigerian military is an arm of the executive branch of government and an instrument of state power, not a pressure group. NUT, NANS, and ASUU are civil society organizations that seek to influence government policy through advocacy and collective action.",
    h: "Which of these organizations is part of government itself rather than a group trying to influence government?"
  },
  {
    yr: 2019,
    q: "The concept of Africa as the centre-piece of Nigeria's foreign policy implies that Nigeria A. should",
    o: [
      "should interfere in the internal affairs of other African states.",
      "support secessionist movements in Africa.",
      "lay more emphasis on African issues.",
      "participate in any peace-keeping operation in Africa."
    ],
    a: 2,
    e: "Africa as the centrepiece means Nigeria gives priority emphasis to African issues in her foreign policy.",
    full: "The concept of Africa as the centrepiece of Nigeria's foreign policy means that African affairs receive the highest priority in Nigeria's international engagements. Nigeria is expected to lead diplomatic efforts, provide resources, and champion African causes on the world stage.",
    h: "If Africa is the 'centrepiece,' what does that imply about its position relative to other foreign policy concerns?"
  },
    {
      yr: 2023,
      q: "A state that is governed by a single central authority is known as a:",
      o: ["Federal State", "Confederal State", "Unitary State", "Monarchical State"],
      a: 2,
      e: "In a Unitary system, all powers are concentrated in the central government.",
      full: "In a Unitary state (like Britain or France), the central government can create or abolish local governments at will. There is no constitutional sharing of power; the center is the only 'boss.' Nigeria was briefly unitary under Decree 34 of 1966.",
      h: "Does power 'flow from the center' or is it 'shared' with the states?"
    },
    {
      yr: 2023,
      q: "The 'Right to Life' is an example of a:",
      o: ["Political right", "Fundamental human right", "Economic right", "Social right"],
      a: 1,
      e: "Fundamental rights are basic entitlements every human should enjoy, often protected by the constitution.",
      full: "These are rights that are 'entrenched' in Chapter 4 of the Nigerian 1999 Constitution. They include the right to dignity, personal liberty, and fair hearing. They can only be suspended during a state of emergency.",
      h: "Is 'staying alive' a luxury or a basic human entitlement?"
    },
    {
      yr: 2023,
      q: "The process of depriving a person of their citizenship is called:",
      o: ["Deportation", "Expatriation", "Denaturalization", "Renunciation"],
      a: 2,
      e: "Denaturalization is the official act of stripping someone of their citizenship, usually for criminal acts or fraud.",
      full: "If a person gained citizenship by 'Naturalization' but was later found to be a spy or a threat to the state, the government can 'Denaturalize' them. This is different from 'Renunciation,' which is when the person gives it up voluntarily.",
      h: "If the government 'takes away' your passport as a punishment, what is that called?"
    },
    {
      yr: 2023,
      q: "In a 'Parliamentary' system, the 'Head of State' is usually:",
      o: ["The Prime Minister", "The President or Monarch", "The Speaker", "The Chief Justice"],
      a: 1,
      e: "The Head of State performs ceremonial duties, while the Prime Minister handles the actual governance.",
      full: "Think of the UK: King Charles is the 'Head of State' (ceremonial), but the Prime Minister is the 'Head of Government' (executive). In Nigeria's First Republic, Azikiwe was the ceremonial Head of State.",
      h: "Who represents the 'symbol' of the country but doesn't make the laws?"
    },
    {
      yr: 2023,
      q: "The principle of 'Separation of Powers' was popularized by:",
      o: ["A.V. Dicey", "Baron de Montesquieu", "John Locke", "Thomas Hobbes"],
      a: 1,
      e: "Montesquieu argued that the Executive, Legislature, and Judiciary must be independent to prevent tyranny.",
      full: "This is the 'Trinity' of Government. If one man (the President) makes the law, executes the law, and judges the law, he becomes a dictator. By separating them, we ensure 'Checks and Balances.'",
      h: "Who said power should be divided into three branches?"
    },
    {
      yr: 2023,
      q: "Which of these is a major function of the 'Legislature'?",
      o: ["Interpreting laws", "Executing policies", "Law-making", "Arresting criminals"],
      a: 2,
      e: "The primary duty of the Senate and House of Reps is to debate and pass bills into law.",
      full: "The Legislature is the 'Voice of the People.' They represent different constituencies. Aside from making laws, they also perform 'Oversight'—checking how the Executive is spending the budget.",
      h: "What is the main job of a Senator?"
    },
    {
      yr: 2023,
      q: "The head of the 'Judiciary' in Nigeria is the:",
      o: ["Attorney General", "President", "Chief Justice of Nigeria", "Senate President"],
      a: 2,
      e: "The CJN presides over the Supreme Court and the National Judicial Council.",
      full: "The Judiciary is the 'last hope of the common man.' The CJN ensures that the courts remain independent from the influence of the President or the Governors.",
      h: "Who is the 'number one' judge in Nigeria?"
    },
    {
      yr: 2023,
      q: "A 'Bicameral' legislature consists of:",
      o: ["One house", "Two houses", "Three houses", "A council of elders"],
      a: 1,
      e: "Bicameralism means there are two chambers, like the Senate and the House of Representatives.",
      full: "Nigeria and the USA use bicameralism at the federal level to ensure that both the population (House of Reps) and the states (Senate) are fairly represented. This prevents the 'Tyranny of the Majority.'",
      h: "Does Nigeria have 'one' or 'two' chambers in the National Assembly?"
    },
    {
      yr: 2023,
      q: "The policy of 'Indirect Rule' was introduced in Nigeria by:",
      o: ["Sir Hugh Clifford", "Lord Lugard", "Sir Arthur Richards", "John Macpherson"],
      a: 1,
      e: "Lugard used existing traditional rulers (Emirs and Obas) to govern on behalf of the British.",
      full: "The British didn't have enough men or money to govern Nigeria directly. So, Lugard used the 'Emirate System' in the North as a model. It was very successful in the North, partially successful in the West, and a failure in the East (Igboland).",
      h: "Who was the 'Father' of Indirect Rule in Nigeria?"
    },
    {
      yr: 2023,
      q: "The first political party in Nigeria was the:",
      o: ["NCNC", "NPC", "NNDP", "AG"],
      a: 2,
      e: "The Nigerian National Democratic Party (NNDP) was founded by Herbert Macaulay in 1923.",
      full: "Macaulay founded the NNDP specifically to contest the seats created by the Clifford Constitution of 1922. This is why Macaulay is called the 'Father of Nigerian Nationalism.'",
      h: "Which party did Herbert Macaulay start in 1923?"
    },
    {
      yr: 2023,
      q: "The 'Exclusive List' in a federation contains matters reserved for the:",
      o: ["State Government only", "Local Government only", "Federal Government only", "Both Federal and State"],
      a: 2,
      e: "Items like Defense, Currency, and Foreign Affairs are handled strictly by the center.",
      full: "If it's on the Exclusive List, a Governor cannot touch it. For example, the Lagos State Governor cannot print his own money or declare war on another country. These are purely Federal powers.",
      h: "Who handles 'External Affairs' and 'Defense' in Nigeria?"
    },
    {
      yr: 2023,
      q: "The 'Ombudsman' is also known as the:",
      o: ["Judicial Service Commission", "Public Complaints Commission", "Civil Service Commission", "Code of Conduct Bureau"],
      a: 1,
      e: "The PCC investigates grievances from citizens against government officials.",
      full: "The PCC protects the 'little man' from administrative 'bullying.' If a government agency refuses to pay your gratuity or unfairly dismisses you, the PCC is your free legal advocate.",
      h: "What is the 'Public Complaints' office called?"
    },
    {
      yr: 2023,
      q: "Which of the following is a 'Direct' form of democracy?",
      o: ["Parliamentary system", "Presidential system", "Referendum", "Representative government"],
      a: 2,
      e: "A referendum allows the entire population to vote directly on a specific policy or law.",
      full: "In most democracies, we vote for 'People' to speak for us. But in a Referendum (or Plebiscite), we vote on the 'Issue' itself. For example, if Nigeria wanted to decide whether to switch to a new constitution, they would hold a referendum.",
      h: "Is voting for a Senator 'direct' or 'representative' democracy?"
    },
    {
      yr: 2023,
      q: "The 'franchise' refers to the right of a citizen to:",
      o: ["Own a business", "Practice religion", "Vote in an election", "Freedom of speech"],
      a: 2,
      e: "Franchise (or Suffrage) is the legal right to participate in voting.",
      full: "Historically, only men with property could vote. Today, we have 'Universal Adult Suffrage,' meaning any adult (18+ in Nigeria) can vote regardless of wealth, gender, or status.",
      h: "What do you call the 'power to vote'?"
    },
    {
      yr: 2023,
      q: "Which of the following describes 'Gerrymandering'?",
      o: ["Counting votes fairly", "The manipulation of electoral boundaries to favor a party", "The registration of voters", "The use of thugs in elections"],
      a: 1,
      e: "Gerrymandering is a corrupt practice where district lines are redrawn to pack opposition voters into one area.",
      full: "It is named after Elbridge Gerry. It’s like a 'Cheat Code' in elections where a party draws a map that looks like a lizard just to make sure they win more seats than they deserve.",
      h: "Is 're-drawing the map to cheat' called Gerrymandering or Rigging?"
    },
    {
      yr: 2023,
      q: "The highest court of appeal in Nigeria is the:",
      o: ["Court of Appeal", "Federal High Court", "Supreme Court", "Customary Court of Appeal"],
      a: 2,
      e: "The Supreme Court is the final bus stop for all legal matters in the country.",
      full: "Once the Supreme Court makes a decision, it becomes the 'Law of the Land.' Only the Supreme Court itself can reverse its own decision later on.",
      h: "Where is the 'Final Bus Stop' for any court case?"
    },
    {
      yr: 2023,
      q: "A 'Public Corporation' is established by an:",
      o: ["Executive order", "Act of Parliament", "Memorandum of Understanding", "International treaty"],
      a: 1,
      e: "Public corporations (like the Water Board or NPA) are created through specific legislation (laws).",
      full: "Because they are created by law, they have a 'Legal Personality'—they can sue and be sued. They are funded by the government but are supposed to run like a business to provide essential services.",
      h: "Is a government agency like 'NEPA' created by a 'Contract' or a 'Law'?"
    },
    {
      yr: 2023,
      q: "The 'Civil Service' is expected to be 'Anonymous.' This means:",
      o: ["They must not have names", "They must not be seen in public", "They should not be praised or blamed in public for government success or failure", "They must work in secret"],
      a: 2,
      e: "Anonymity ensures that the Minister takes the political credit or blame, not the career civil servant.",
      full: "The Minister is the 'Face' of the Ministry. If the roads are good, the Minister gets the praise. If they are bad, the Minister is sacked. The civil servant behind the desk stays quiet and continues working for the next Minister.",
      h: "Who gets the 'blame' in public—the Politician or the Civil Servant?"
    },
    {
      yr: 2023,
      q: "One major source of 'Revenue' for Local Governments in Nigeria is:",
      o: ["Customs duties", "Statutory allocations from the Federation Account", "Printing of currency", "Corporate income tax"],
      a: 1,
      e: "Local governments rely heavily on money shared from the central government pool.",
      full: "Local governments are also supposed to generate 'Internally Generated Revenue' (IGR) from things like motor parks, markets, and tenement rates, but most survive on the 'Statutory Allocation' from the center.",
      h: "Does the Local Government get its big money from 'Motor Parks' or the 'Federation Account'?"
    },
    {
      yr: 2023,
      q: "The head of a 'Traditional' political system in Igboland was usually the:",
      o: ["Emir", "Oba", "Ofo/Elders", "Obi"],
      a: 2,
      e: "Pre-colonial Igboland was 'Acephalous' (headless), relying on a council of elders and titled men.",
      full: "Unlike the North (Emirs) or the West (Obas), the Igbos did not have a single powerful King over everyone. They were 'Segmentary' and republican, meaning power was shared among families and age-grades.",
      h: "Did the Igbos have 'one powerful King' or did 'Elders' share power?"
    },
    {
      yr: 2023,
      q: "The 'Judiciary' maintains its independence primarily through:",
      o: ["Executive control", "Security of tenure for judges", "Public voting for judges", "Political affiliation"],
      a: 1,
      e: "Security of tenure means a judge cannot be sacked easily for giving a judgment against the government.",
      full: "To ensure a judge is 'Fearless,' their salary is paid from a Consolidated Revenue Fund, and they can only be removed through a rigorous process involving the National Judicial Council (NJC). This prevents the President from bullying them.",
      h: "Can the President sack a judge just because he lost a court case?"
    },
    {
      yr: 2023,
      q: "The 'Non-Aligned Movement' (NAM) was formed to:",
      o: ["Support the USA during the Cold War", "Avoid taking sides between the Western and Eastern blocs", "Promote military coups in Africa", "Support the Soviet Union"],
      a: 1,
      e: "NAM allowed developing nations to remain neutral during the rivalry between the USA and the USSR.",
      full: "Nigeria joined NAM to maintain its sovereignty. It meant we could trade with both the 'Capitalist West' and the 'Communist East' without being a 'puppet' to either side. It was a strategy for 'Independence' in foreign policy.",
      h: "Did Nigeria want to join 'One side' or 'Stay Neutral' during the Cold War?"
    },
    {
      yr: 2023,
      q: "A bill that deals with government spending and taxation is called a/an:",
      o: ["Private bill", "Public bill", "Money bill", "Ordinary bill"],
      a: 2,
      e: "Money bills (Appropriation Bills) are specifically for the budget and national finances.",
      full: "In a democracy, the Executive (President) cannot just spend money. He must present a 'Money Bill' to the Legislature. If they don't pass it, he cannot touch the national treasury. This is the 'Power of the Purse.'",
      h: "Is the 'Budget' an Ordinary Bill or a Money Bill?"
    },
    {
      yr: 2023,
      q: "The 'Minority' report of the 1976 Constitution Drafting Committee was led by:",
      o: ["Chief Obafemi Awolowo", "Dr. Segun Osoba and Yusufu Bala Usman", "Nnamdi Azikiwe", "Murtala Muhammed"],
      a: 1,
      e: "Osoba and Usman disagreed with the 'Capitalist' direction of the main committee.",
      full: "While the majority of the committee wanted a Presidential system, the 'Minority' group argued for a more socialist-leaning document that favored the working class. Though their report wasn't adopted, it is a famous part of Nigerian political history.",
      h: "Which two scholars wrote the 'alternative' version of the constitution?"
    },
    {
      yr: 2023,
      q: "The 'Commonwealth of Nations' is an organization made up of:",
      o: ["All African countries", "Former colonies of the British Empire", "French-speaking countries", "Oil-producing nations"],
      a: 1,
      e: "It is a voluntary association of 56 independent countries, most of which were British colonies.",
      full: "Nigeria joined upon independence in 1960. The Queen (now the King) is the 'Symbolic Head.' It promotes democracy, human rights, and trade among member nations.",
      h: "Is the Commonwealth for 'Former British colonies' or 'French colonies'?"
    },
    {
      yr: 2023,
      q: "The main objective of 'Public Opinion' is to:",
      o: ["Overthrow the government", "Influence government policy and actions", "Support the ruling party", "Suppress the opposition"],
      a: 1,
      e: "Public opinion acts as a pressure tool to let leaders know what the people want.",
      full: "Through protests, polls, and media, the public communicates its feelings. A government that ignores public opinion risks losing the next election or facing civil unrest.",
      h: "Do the people use their 'voice' to 'help' or to 'influence' the government?"
    },
    {
      yr: 2023,
      q: "The 'Diplomatic Immunity' of an Ambassador means that:",
      o: ["They are above the law of their own country", "They cannot be arrested or prosecuted in their host country", "They don't need a passport", "They can do whatever they want"],
      a: 1,
      e: "Ambassadors are protected from local laws to ensure they can represent their country freely.",
      full: "Under the Vienna Convention, an Ambassador's 'Home' (the Embassy) is considered the 'Soil' of their home country. If they commit a crime, the host country can only declare them 'Persona Non-Grata' (unwelcome) and ask them to leave.",
      h: "Can a Nigerian Ambassador in the USA be jailed by American police for a traffic offense?"
    },
    {
      yr: 2023,
      q: "Which of the following is a disadvantage of a 'One-Party' system?",
      o: ["It promotes national unity", "It is very expensive to run", "It leads to dictatorship and limits choice", "It encourages political competition"],
      a: 2,
      e: "Without opposition, the single party often becomes corrupt and ignores the rights of citizens.",
      full: "In a one-party state (like China or North Korea), there is no 'Alternative.' You either support the party or you are an enemy of the state. This kills the spirit of democratic debate.",
      h: "Does having 'Only one party' give people more or less 'Choice'?"
    },
    {
      yr: 2023,
      q: "The 'Pressure Group' that represents the interest of workers in Nigeria is the:",
      o: ["ASUU", "NLC", "NBA", "NMA"],
      a: 1,
      e: "The Nigeria Labour Congress (NLC) is the umbrella body for all trade unions.",
      full: "Pressure groups differ from political parties because they don't want to 'Rule'; they only want to 'Influence.' The NLC uses strikes and negotiations to get better wages for workers.",
      h: "What is the biggest union for 'Workers' (Labour) in Nigeria?"
    },
    {
      yr: 2023,
      q: "The 'Pre-colonial' Hausa/Fulani political system was described as:",
      o: ["Democratic", "Highly Centralized", "Acephalous", "Segmentary"],
      a: 1,
      e: "The Emir held absolute power over the administration, religion, and the military.",
      full: "Under the Caliphate system established by Uthman Dan Fodio, the Emir was the supreme leader. He appointed 'District Heads' (Hakimi) and 'Village Heads' (Dagaci) to collect taxes and keep order.",
      h: "Was the Emirate system 'Loose' or 'Highly organized and Centralized'?"
    },
    {
      yr: 2023,
      q: "The 'ECOWAS' was established in 1975 to promote:",
      o: ["Military cooperation", "Economic integration in West Africa", "A common religion", "The overthrow of colonial masters"],
      a: 1,
      e: "The main goal was to create a 'Single Market' for West African countries to trade freely.",
      full: "Nigeria and Togo were the 'architects' of ECOWAS. While it now deals with 'Security' (ECOMOG), its primary founding goal was 'Economic' development for the 15 member states.",
      h: "Is ECOWAS for 'All of Africa' or just 'West Africa'?"
    },
    {
      yr: 2023,
      q: "A 'Written Constitution' is one that is:",
      o: ["Handwritten by the President", "Contained in a single formal document", "Found in the hearts of the people", "Made of only oral traditions"],
      a: 1,
      e: "A written constitution (like Nigeria's) is a single book that outlines all laws and structures.",
      full: "The opposite is an 'Unwritten' constitution (like Britain's), where the laws are found in many different documents, court cases, and traditions. Written constitutions are usually 'Rigid,' meaning they are hard to change.",
      h: "Is the Nigerian Constitution a 'Single Document' or a 'Collection of many books'?"
    },
    {
      yr: 2023,
      q: "The 'Rule of Law' is often limited by:",
      o: ["Freedom of the press", "An independent judiciary", "Diplomatic immunity and state of emergency", "Fair hearing"],
      a: 2,
      e: "In certain situations, the law is 'suspended' or doesn't apply to certain officials.",
      full: "Dicey said everyone is equal, but in reality, 'Diplomatic Immunity' protects foreign leaders from local laws, and during a 'State of Emergency,' the President can temporarily suspend certain human rights for security.",
      h: "Can a President 'suspend' some rights during a 'War' or 'Emergency'?"
    },
    {
      yr: 2023,
      q: "The 'Judicial Service Commission' is responsible for the:",
      o: ["Execution of criminals", "Appointment and discipline of judges", "Making of laws", "Collection of court fees"],
      a: 1,
      e: "They recommend qualified lawyers to be appointed as judges by the President.",
      full: "This body ensures that 'Politicians' don't just put their friends in court. They vet the character and knowledge of potential judges to ensure the judiciary remains professional.",
      h: "Who 'hires and fires' judges based on their behavior?"
    },
    {
      yr: 2023,
      q: "The 'First Republic' of Nigeria was brought to an end by a military coup in:",
      o: ["October 1960", "January 1966", "July 1975", "December 1983"],
      a: 1,
      e: "The January 15, 1966 coup led by Nzeogwu ended civilian rule.",
      full: "This coup led to the death of the Prime Minister (Balewa) and the Premier of the North (Sardauna). It introduced the first military Head of State, Aguiyi-Ironsi, and began a long era of military intervention.",
      h: "Did the first coup happen in '1960' or '1966'?"
    },
    {
      yr: 2023,
      q: "What is the main function of 'Political Parties'?",
      o: ["To cause trouble in the street", "To contest elections and gain political power", "To arrest criminals", "To manage the civil service"],
      a: 1,
      e: "Parties exist to organize voters and win the right to govern the country.",
      full: "Unlike 'Pressure Groups' (who just want favors), a Political Party (like APC or PDP) wants to 'Sit on the Throne.' They provide a platform for candidates to sell their 'Manifesto' (promises) to the people.",
      h: "What is the 'goal' of a party: to 'Negotiate' or to 'Rule'?"
    },
    {
      yr: 2023,
      q: "The 'Secretary-General' of the United Nations (UN) is appointed for a term of:",
      o: ["2 years", "4 years", "5 years", "10 years"],
      a: 2,
      e: "The term of office is 5 years, and it can be renewed for a second term.",
      full: "The Secretary-General is the 'World's Top Diplomat.' They are appointed by the General Assembly upon the recommendation of the Security Council. They represent the voice of the world's 193 nations.",
      h: "Is the UN leader's term 'Four' or 'Five' years?"
    },
    {
      yr: 2023,
      q: "The 'Statutory' members of the 'Security Council' (Permanent members) are how many?",
      o: ["5", "10", "15", "20"],
      a: 0,
      e: "The 'P5' includes USA, UK, France, Russia, and China.",
      full: "These five countries have 'Veto Power,' meaning if any one of them says 'NO' to a resolution, it cannot pass—even if all other 192 countries say 'YES.' This is the highest power in the UN.",
      h: "How many countries have the 'Veto Power'?"
    },
    {
      yr: 2023,
      q: "The 'Warrant Chiefs' were introduced in Eastern Nigeria during the colonial era because:",
      o: ["The Igbos had powerful kings", "The Igbos lacked a centralized political authority", "The British wanted to support the elders", "The chiefs were popular with the people"],
      a: 1,
      e: "The British needed 'leaders' to collect taxes, so they 'invented' chiefs where there were none.",
      full: "Because Igboland was republican (Acephalous), the British couldn't find an 'Emir' or 'Oba' to use. So they gave 'Warrants' (certificates) to random people. This led to corruption and the famous 1929 Aba Women's Riot.",
      h: "Did the British 'find' Chiefs in the East or 'create' them?"
    },
    {
      yr: 2023,
      q: "Which organization was the predecessor of the 'African Union' (AU)?",
      o: ["ECOWAS", "OAU", "ECA", "SADC"],
      a: 1,
      e: "The Organization of African Unity (OAU) was transformed into the AU in 2002.",
      full: "The OAU was focused on 'Ending Colonialism.' Once Africa was free, the leaders felt they needed a new body (the AU) to focus on 'Economic Integration' and 'Peace-keeping.'",
      h: "Did the 'AU' start as the 'OAU' or 'ECOWAS'?"
    },
    {
      yr: 2022,
      q: "The 'Theory of Sovereignty' was first formulated by:",
      o: ["Jean Bodin", "A.V. Dicey", "Karl Marx", "Baron de Montesquieu"],
      a: 0,
      e: "Jean Bodin defined sovereignty as the absolute and perpetual power of a state.",
      full: "In his book 'Six Books of the Commonwealth' (1576), Bodin argued that for a state to be stable, there must be a 'Supreme Power' that makes laws but is not subject to them. This power is what we now call Sovereignty.",
      h: "Who is the 'Father of Sovereignty'?"
    },
    {
      yr: 2022,
      q: "A system of government where power is shared between the central and component units is:",
      o: ["Unitary", "Confederal", "Federal", "Monarchical"],
      a: 2,
      e: "Federalism involves a constitutional division of power between different levels of government.",
      full: "In Nigeria, the 1999 Constitution clearly defines what the Federal Government can do (Exclusive List) and what the State Governments can do (Residual List). This prevents one level from swallowing the other.",
      h: "Does Nigeria share power or keep it all at the top?"
    },
    {
      yr: 2022,
      q: "The 'Clifford Constitution' of 1922 was significant because it introduced the:",
      o: ["Federal System", "Elective Principle", "Veto Power", "Direct Rule"],
      a: 1,
      e: "It allowed Nigerians to vote for representatives in the Legislative Council for the first time.",
      full: "Before 1922, Nigerians were just 'nominated' by the Governor. Sir Hugh Clifford changed this by allowing 4 elected seats (3 for Lagos, 1 for Calabar). This triggered the birth of political parties like the NNDP.",
      h: "Did Clifford give Nigerians the right to 'Vote' or 'Independence'?"
    },
    {
      yr: 2022,
      q: "The 'Macpherson Constitution' of 1951 was described as:",
      o: ["Unitary", "Quasi-federal", "Rigid", "Unwritten"],
      a: 1,
      e: "It was 'Quasi-federal' because it introduced regional legislatures but kept a strong central link.",
      full: "Under Macpherson, Nigeria was split into three regions (North, West, East), each with its own House of Assembly. However, the Central Legislative Council still had significant control, hence it wasn't 'Full' Federalism yet.",
      h: "Was it 'Partially Federal' or 'Fully Federal'?"
    },
    {
      yr: 2022,
      q: "The main purpose of 'Pressure Groups' is to:",
      o: ["Win elections", "Form a government", "Influence government policies", "Create chaos"],
      a: 2,
      e: "Pressure groups seek to protect the interests of their members by lobbying the government.",
      full: "Unlike political parties, pressure groups (like ASUU or the NBA) do not want to rule the country. They only want to 'Push' the government to do something specific, like increase salaries or change a law.",
      h: "Do they want 'Power' or 'Influence'?"
    },
    {
      yr: 2022,
      q: "The concept of 'Collective Responsibility' is a feature of the:",
      o: ["Presidential System", "Parliamentary System", "Monarchy", "Military Rule"],
      a: 1,
      e: "In a Parliamentary system, the entire cabinet must support a government decision or resign together.",
      full: "This means 'Sink or Swim together.' If the Parliament passes a 'Vote of No Confidence' against one Minister on a major policy, the Prime Minister and the whole Cabinet are usually expected to resign.",
      h: "Do Ministers 'stand alone' or 'sink together' in Parliament?"
    },
    {
      yr: 2022,
      q: "Which of the following is an 'Exclusive' power of the Federal Government in Nigeria?",
      o: ["Health", "Education", "Defense", "Agriculture"],
      a: 2,
      e: "Defense is strictly handled by the Federal Government to ensure national security.",
      full: "States can build schools (Education) or hospitals (Health), but a State Governor is not allowed to have his own Army or Air Force. Defense, Currency, and Customs are strictly for the 'Big Boss' in Abuja.",
      h: "Can a Governor buy 'Fighter Jets' for his state?"
    },
    {
      yr: 2022,
      q: "The 'Udoji Commission' of 1972-74 was primarily set up to review:",
      o: ["The Constitution", "State creation", "Public service salaries and structure", "Boundary disputes"],
      a: 2,
      e: "It recommended a massive overhaul of the civil service and a huge salary increase.",
      full: "The 'Udoji Award' gave civil servants a massive 'Back-pay' (Arrears). While it made workers happy, it caused massive inflation because too much money was suddenly chasing too few goods in the market.",
      h: "Did Udoji deal with 'New States' or 'Teacher/Civil Servant salaries'?"
    },
    {
      yr: 2022,
      q: "The 'Ombudsman' (Public Complaints Commission) was established in Nigeria in:",
      o: ["1960", "1975", "1988", "1999"],
      a: 1,
      e: "The PCC was established by the Murtala/Obasanjo military regime in 1975.",
      full: "It was created to give the common man a platform to report 'Administrative Injustice.' If a government official is bullying you or withholding your file, you report them to the PCC/Ombudsman.",
      h: "Was the PCC created in '1960' or '1975'?"
    },
    {
      yr: 2022,
      q: "In pre-colonial 'Yoruba' political systems, the King (Oba) was checked by the:",
      o: ["Oyo Mesi", "Ogboni Society", "Emeso", "Age Grades"],
      a: 0,
      e: "The Oyo Mesi was the council of seven kingmakers who could depose a tyrannical Oba.",
      full: "The Bashorun (head of Oyo Mesi) could present an 'Empty Calabash' or 'Parrot Eggs' to the Oba, signaling that the people and the gods have rejected him, forcing the Oba to commit suicide.",
      h: "Which group could tell the Oba to 'Go to sleep' (Suicide)?"
    },
    {
      yr: 2022,
      q: "The 'Delegated Legislation' is law made by:",
      o: ["The Judiciary", "The Legislature", "Administrative bodies/The Executive", "The Police"],
      a: 2,
      e: "Parliament 'delegates' the power to make minor rules to Ministers or Local Authorities.",
      full: "The National Assembly is too busy to make laws about every tiny detail (like 'Dog License Fees' in a local area). So, they pass an 'Act' and let a Minister or Council make 'Bye-laws' to fill in the gaps.",
      h: "Is this law made by 'Senators' or 'Government Agencies'?"
    },
    {
      yr: 2022,
      q: "The 'First Military Coup' in Nigeria took place on:",
      o: ["January 15, 1966", "July 29, 1966", "July 29, 1975", "December 31, 1983"],
      a: 0,
      e: "Led by Major Chukwuma Kaduna Nzeogwu, it ended the First Republic.",
      full: "This coup was the 'Beginning of the End' for the First Republic. It led to the assassination of leaders like Tafawa Balewa and Ahmadu Bello, and eventually paved the way for the Civil War.",
      h: "Was the first coup in 'January' or 'July' of 1966?"
    },
    {
      yr: 2022,
      q: "The 'Organization of African Unity' (OAU) was founded in:",
      o: ["Lagos, 1960", "Addis Ababa, 1963", "Accra, 1957", "Cairo, 1964"],
      a: 1,
      e: "It was established on May 25, 1963, in Ethiopia.",
      full: "The OAU was formed by 32 independent African states. Its main goal at the time was 'Decolonization'—making sure every inch of Africa was free from European rule. It was later replaced by the AU in 2002.",
      h: "Did the OAU start in 'Nigeria' or 'Ethiopia'?"
    },
    {
      yr: 2022,
      q: "Which of the following describes 'Naturalization'?",
      o: ["Citizenship by birth", "Citizenship granted to a foreigner after meeting legal requirements", "Citizenship by marriage", "Citizenship by honor"],
      a: 1,
      e: "Naturalization is the process where a non-citizen acquires citizenship after living in a country for a set time.",
      full: "In Nigeria, you must have lived here for at least 15 years, be of good character, and be willing to contribute to the country before the President can grant you citizenship by naturalization.",
      h: "Is this 'Birth' citizenship or 'Applied' citizenship?"
    },
    {
      yr: 2022,
      q: "The 'Judiciary' performs the function of:",
      o: ["Executing laws", "Making laws", "Interpreting laws", "Arresting offenders"],
      a: 2,
      e: "The courts explain what the law means and apply it to specific cases.",
      full: "If the Legislature makes a law that is confusing, it is the Judge who 'interprets' it in court. This ensures that the law is applied fairly to everyone, including the government.",
      h: "Who 'explains' the law in a court case?"
    },
    {
      yr: 2022,
      q: "A 'Secret Ballot' system of voting is one where:",
      o: ["Votes are cast in public", "Voters' choices are known only to themselves", "Only top officials can vote", "Votes are sold to the highest bidder"],
      a: 1,
      e: "It ensures privacy and prevents intimidation of voters.",
      full: "The secret ballot (also called the Australian Ballot) is a pillar of democracy. It allows a citizen to vote for who they *really* want without fearing that their boss or a political thug will punish them for it.",
      h: "Is your vote 'Hidden' or 'Public'?"
    },
    {
      yr: 2022,
      q: "The 'Lagos Youth Movement' was renamed the 'Nigerian Youth Movement' (NYM) in:",
      o: ["1934", "1936", "1944", "1951"],
      a: 1,
      e: "It was renamed in 1936 to give it a more national outlook.",
      full: "The NYM was the first 'Truly National' movement in Nigeria. It brought together people like Nnamdi Azikiwe and H.O. Davies to challenge the dominance of Herbert Macaulay's NNDP.",
      h: "Did the name change in '1934' or '1936'?"
    },
    {
      yr: 2022,
      q: "The 'Head of the Civil Service' is responsible for:",
      o: ["Making political speeches", "Ensuring the efficiency and discipline of the civil service", "Winning elections for the President", "Arresting corrupt ministers"],
      a: 1,
      e: "The HOS is the 'Permanent' professional head of all government workers.",
      full: "While a 'Minister' is a politician who comes and goes, the Head of Service is a career professional who ensures that the 'engine' of government (the workers) keeps running smoothly regardless of which party is in power.",
      h: "Is the HOS a 'Politician' or a 'Professional Worker'?"
    },
    {
      yr: 2022,
      q: "Which of the following is a 'Direct' tax?",
      o: ["Value Added Tax (VAT)", "Customs duties", "Personal Income Tax", "Excise duties"],
      a: 2,
      e: "Direct taxes are paid directly by the individual to the government based on their income.",
      full: "Direct tax is 'Visible'—it is taken from your salary (PAYE) or business profit. Indirect taxes (like VAT) are 'Hidden' in the price of things you buy, like recharge cards or bread.",
      h: "Is 'Income Tax' taken from your 'Salary' or your 'Bread'?"
    },
    {
      yr: 2022,
      q: "The 'Attlee Declaration' of 1946 was important because it:",
      o: ["Promised Nigeria total independence immediately", "Announced the British intention to leave their colonies", "Created the first Nigerian regions", "Stopped the use of Indirect Rule"],
      a: 1,
      e: "Clement Attlee declared that 'the wind of change' meant colonies would eventually be free.",
      full: "This was a major turning point after World War II. The British Prime Minister realized that Britain was too poor to keep holding onto its empires, and they started planning the 'Exit' strategy for countries like Nigeria and India.",
      h: "Did Attlee say Britain would 'Stay' or 'Eventually Leave'?"
    },
    {
      yr: 2022,
      q: "A system where the Head of State is also the Head of Government is:",
      o: ["Parliamentary", "Presidential", "Monarchical", "Feudal"],
      a: 1,
      e: "In a Presidential system, the President holds both ceremonial and executive powers.",
      full: "Unlike the UK where the King (Head of State) and PM (Head of Government) are different people, the Nigerian President is the 'All-in-One' leader. He performs the 'dignified' duties (hosting ambassadors) and the 'efficient' duties (running ministries).",
      h: "Does the President 'share' the top spot with a Prime Minister, or is he the 'only' boss?"
    },
    {
      yr: 2022,
      q: "The 'Judicial Review' refers to the power of the courts to:",
      o: ["Appoint new ministers", "Declare laws or executive actions unconstitutional", "Increase the salaries of judges", "Arrest members of the legislature"],
      a: 1,
      e: "Courts can strike down any law that contradicts the Constitution.",
      full: "This is a key part of 'Checks and Balances.' If the National Assembly passes a law that takes away your right to speak, the Supreme Court can use 'Judicial Review' to cancel that law and make it 'null and void.'",
      h: "Can a Judge 'cancel' a bad law made by the government?"
    },
    {
      yr: 2022,
      q: "The 'United Nations' (UN) was established in 1945 to replace the:",
      o: ["League of Nations", "OAU", "Commonwealth", "ECOWAS"],
      a: 0,
      e: "The League of Nations failed to prevent World War II, so the UN was created to ensure world peace.",
      full: "The League of Nations was too weak. The UN was built with more 'teeth' (like the Security Council) to handle international conflicts and prevent a third world war.",
      h: "What was the 'old' version of the UN called?"
    },
    {
      yr: 2022,
      q: "Which of these is a function of 'Local Government' in Nigeria?",
      o: ["Printing of currency", "Maintenance of cemeteries and markets", "Defense of the nation", "Conducting foreign policy"],
      a: 1,
      e: "Local governments handle grassroots matters like motor parks and waste disposal.",
      full: "Under the Fourth Schedule of the 1999 Constitution, the LG is responsible for things that touch everyday life directly—slaughterhouses, naming of streets, and small-scale community health centers.",
      h: "Does the 'Local Chairman' handle 'Army' matters or 'Market' matters?"
    },
    {
      yr: 2022,
      q: "The 'Zikist Movement' was known for its:",
      o: ["Support for British colonial rule", "Radical and militant approach to nationalism", "Focus on northern interests only", "Religious objectives"],
      a: 1,
      e: "They were young radicals who used protests and strikes to demand immediate independence.",
      full: "The Zikist Movement (named after Nnamdi Azikiwe) believed that the older nationalists were being too 'soft' on the British. They wanted 'Action Now' and were often arrested for their revolutionary speeches.",
      h: "Were the Zikists 'Peaceful' or 'Radical' in their methods?"
    },
    {
      yr: 2022,
      q: "The 'General Assembly' of the UN is often described as the:",
      o: ["World Cabinet", "World Parliament", "World Court", "World Police"],
      a: 1,
      e: "It is the main deliberative body where every member nation has one vote.",
      full: "In the General Assembly, small countries like The Gambia have the same voting power as big countries like the USA. They meet every September to discuss world issues, though their decisions are mostly 'recommendations.'",
      h: "Is the General Assembly like a 'Court' or a 'Big Debate House'?"
    },
    {
      yr: 2022,
      q: "A 'Provisional' government is a:",
      o: ["Permanent government", "Military government", "Temporary government for a transition period", "Religious government"],
      a: 2,
      e: "It is a short-term administration set up after a crisis or before a new election.",
      full: "For example, after a long military rule, a 'Provisional Ruling Council' might take over just to organize elections and hand over to civilians. It is never meant to stay in power forever.",
      h: "Is this government 'For Life' or just 'For Now'?"
    },
    {
      yr: 2022,
      q: "The 'Pre-colonial' Yoruba system allowed the 'Ogboni' to:",
      o: ["Elect the Oba", "Check the powers of the Oyo Mesi", "Lead the army into battle", "Collect taxes from farmers"],
      a: 1,
      e: "The Ogboni acted as a secret society that mediated between the King and the Oyo Mesi.",
      full: "The Ogboni was a religious and judicial body. If the King (Oba) and the Council (Oyo Mesi) were fighting, the Ogboni would step in to settle the dispute and maintain the spiritual balance of the land.",
      h: "Did the Ogboni help 'Keep the Peace' between the King and his Council?"
    },
    {
      yr: 2022,
      q: "The 'Bill of Rights' is primarily intended to:",
      o: ["Empower the police", "Protect the fundamental rights of citizens", "Increase taxes", "Allow the government to censor the news"],
      a: 1,
      e: "It outlines the basic freedoms that the government cannot legally violate.",
      full: "In Nigeria, Chapter 4 of the Constitution is our 'Bill of Rights.' It protects your right to life, freedom of worship, and right to property. Without it, the government could do whatever it wanted to you.",
      h: "Is a 'Bill of Rights' for 'The People' or 'The Government'?"
    },
    {
      yr: 2022,
      q: "Which of the following describes 'Gerrymandering'?",
      o: ["Registration of voters", "Redrawing of constituency boundaries to favor a party", "Counting of votes", "Selection of party candidates"],
      a: 1,
      e: "It is a form of electoral fraud where map boundaries are manipulated.",
      full: "It's like a 'Cheat Code' where a party draws a map that looks like a snake just to make sure they have a majority of their supporters in every district. It’s legal in some places but considered very unfair.",
      h: "Is this 'Drawing a Map fairly' or 'Drawing it to cheat'?"
    },
    {
      yr: 2022,
      q: "The 'Statutory Allocation' refers to:",
      o: ["The money shared among the three tiers of government", "The number of laws passed by parliament", "The appointment of ministers", "The collection of bribes"],
      a: 0,
      e: "It is the monthly distribution of national revenue from the Federation Account.",
      full: "Every month, the 36 states and 774 local governments meet in Abuja to get their 'Share' of the oil money. This process is called 'FAAC' (Federation Account Allocation Committee).",
      h: "Is this 'Oil Money sharing' or 'Law making'?"
    },
    {
      yr: 2022,
      q: "The 'Rule of Law' is a concept popularized by:",
      o: ["Montesquieu", "A.V. Dicey", "Jean Bodin", "Thomas Hobbes"],
      a: 1,
      e: "Dicey identified three pillars: Supremacy of the law, Equality before the law, and Protection of rights.",
      full: "Dicey’s principle says that no matter how rich or powerful you are, you are not 'Above' the law. Also, the government cannot punish you unless you have actually broken a specific law in the book.",
      h: "Who said 'No one is above the law'?"
    },
    {
      yr: 2022,
      q: "The 'ECOMOG' was a military force created by:",
      o: ["AU", "UN", "ECOWAS", "OPEC"],
      a: 2,
      e: "The ECOWAS Monitoring Group was formed to restore peace in Liberia and Sierra Leone.",
      full: "Nigeria was the main financier and troop contributor to ECOMOG. It was one of the first times a regional group in Africa formed its own 'Army' to stop a civil war in a neighboring country.",
      h: "Was ECOMOG for 'All of Africa' or just 'West Africa'?"
    },
    {
      yr: 2022,
      q: "A 'Plebiscite' is another name for a:",
      o: ["General Election", "Bye-election", "Referendum", "Primary election"],
      a: 2,
      e: "It is a direct vote by the people on a single political issue.",
      full: "In 1961, there was a plebiscite in the Southern Cameroons to decide whether they wanted to join Nigeria or Cameroon. It’s the ultimate way to let the 'People' decide their own fate directly.",
      h: "Is this 'Voting for a Person' or 'Voting on an Issue'?"
    },
    {
      yr: 2022,
      q: "Which of the following was a feature of the '1979 Constitution'?",
      o: ["Parliamentary system", "Presidential system", "Monarchy", "Unitary system"],
      a: 1,
      e: "Nigeria switched from the British Parliamentary style to the American Presidential style.",
      full: "This change meant we no longer had a Prime Minister. Instead, we had an Executive President (Shehu Shagari) who was both Head of State and Head of Government.",
      h: "Did 1979 bring 'A Prime Minister' or 'A President'?"
    },
    {
      yr: 2022,
      q: "The 'Public Service Commission' is responsible for the:",
      o: ["Collection of taxes", "Recruitment and promotion of civil servants", "Trial of criminals", "Making of the budget"],
      a: 1,
      e: "They ensure that civil service jobs are given based on merit, not just 'who you know.'",
      full: "To prevent politicians from filling the ministries with their cousins, the Commission handles the hiring, firing, and promotion of career government workers according to the 'Civil Service Rules.'",
      h: "Do they 'Hire Workers' or 'Arrest People'?"
    },
    {
      yr: 2022,
      q: "The 'Secretary-General' of the AU is now referred to as the:",
      o: ["President", "Chairman", "Chairperson of the AU Commission", "Director-General"],
      a: 2,
      e: "The administrative head of the AU is the Chairperson of the Commission.",
      full: "When the OAU became the AU in 2002, the structure changed. The Chairperson handles the daily running of the organization in Addis Ababa, Ethiopia.",
      h: "Is the leader called the 'Secretary' or the 'Chairperson'?"
    },
    {
      yr: 2022,
      q: "The 'Judicial Service Commission' recommends judges for appointment to the:",
      o: ["National Assembly", "President", "Chief Justice", "Police"],
      a: 1,
      e: "The President (or Governor) makes the final appointment based on the JSC’s recommendation.",
      full: "This process ensures a 'Separation of Powers.' The President doesn't just pick his own judges; he has to choose from a list of professionals vetted by other judges in the JSC.",
      h: "Does the JSC give their list to the 'President' or the 'Senator'?"
    },
    {
      yr: 2022,
      q: "Which pre-colonial system was famously 'Acephalous' (headless)?",
      o: ["Hausa/Fulani", "Yoruba", "Igbo", "Benin"],
      a: 2,
      e: "The Igbos had a decentralized system without a central king.",
      full: "In Igboland, power was distributed among Age Grades, Ozo Titled men, and the Village Assembly (Oha-na-eze). This made 'Indirect Rule' very difficult for the British because there was no 'one person' to command.",
      h: "Did the Igbos have 'One Big King' or 'Many Council Leaders'?"
    },
    {
      yr: 2022,
      q: "The 'Aba Women’s Riot' of 1929 was caused by:",
      o: ["The election of a new King", "The introduction of direct taxation on women", "Boundary disputes", "The lack of schools"],
      a: 1,
      e: "Women protested against the colonial government’s plan to tax them through 'Warrant Chiefs.'",
      full: "This was a major anti-colonial protest. The women felt the Warrant Chiefs were corrupt and that the taxes were unfair. It forced the British to rethink how they governed the Eastern part of Nigeria.",
      h: "Was the riot about 'Education' or 'Taxes'?"
    },
    {
      yr: 2021,
      q: "The 'Judiciary' is often called the 'last hope of the common man' because it:",
      o: ["Makes laws for the poor", "Executes government projects", "Protects the rights of citizens against the state", "Arrests corrupt politicians"],
      a: 2,
      e: "The courts provide a fair hearing and legal protection when a citizen's rights are violated.",
      full: "This is the essence of 'Equity.' Even if the President or a wealthy billionaire sues a common citizen, the Judge is expected to follow the law strictly, ensuring that the 'smaller' person isn't crushed by the 'bigger' person.",
      h: "Does the Court 'protect' the people or 'rule' the people?"
    },
    {
      yr: 2021,
      q: "The 'United Nations Charter' was signed in:",
      o: ["London, 1944", "San Francisco, 1945", "New York, 1946", "Geneva, 1945"],
      a: 1,
      e: "The UN was officially formed at the San Francisco Conference after World War II.",
      full: "50 countries met to draft the document that would replace the failed League of Nations. They wanted to create a global body that could 'save succeeding generations from the scourge of war.'",
      h: "Was the UN 'born' in 'San Francisco' or 'New York'?"
    },
    {
      yr: 2021,
      q: "A 'Unitary' system of government is most suitable for a country that is:",
      o: ["Large and culturally diverse", "Small and geographically compact", "Highly populated", "Rich in natural resources"],
      a: 1,
      e: "Unitary systems work best where there are no deep ethnic or regional divisions needing separate powers.",
      full: "In a small, homogenous country (like Great Britain), you don't need 'State Governments' fighting with the center. One central government can easily manage the whole territory without confusing layers of bureaucracy.",
      h: "Is a 'Unitary' system for 'Big, diverse' countries or 'Small, simple' ones?"
    },
    {
      yr: 2021,
      q: "The 'Richard's Constitution' of 1946 was criticized because:",
      o: ["It gave too much power to Nigerians", "It was drafted without consulting the Nigerian people", "It abolished the regions", "It introduced a single house of assembly"],
      a: 1,
      e: "Sir Arthur Richards 'imposed' the constitution, leading to nationalist protests.",
      full: "Nationalists like Nnamdi Azikiwe felt the constitution was 'arbitrary.' Even though it introduced the concept of 'Regions' (North, West, East), the fact that Nigerians weren't asked for their input made it unpopular.",
      h: "Was the problem 'The contents of the book' or 'How the book was made'?"
    },
    {
      yr: 2021,
      q: "The 'Executive' branch of government is responsible for:",
      o: ["Making laws", "Interpreting laws", "Implementing and enforcing laws", "Settling disputes"],
      a: 2,
      e: "The President and the Cabinet carry out the day-to-day administration of the state.",
      full: "If the Legislature passes a law saying 'Every child must go to school,' it is the Executive (the Ministry of Education and the Police) that ensures the schools are built and the law is followed.",
      h: "Who 'does the actual work' of running the country?"
    },
    {
      yr: 2021,
      q: "In 'Pre-colonial' Hausa/Fulani systems, the 'Galadima' was the:",
      o: ["Commander of the Army", "Chief of the Palace", "Administrator of the capital city", "Market supervisor"],
      a: 2,
      e: "The Galadima was a high-ranking official who managed the affairs of the Emir’s capital.",
      full: "The Emirate system had a very clear 'Hierarchy.' While the Emir was the supreme head, he had 'Portfolio' holders like the Madawaki (Army), Waziri (Prime Minister), and Galadima (City Admin) to help him rule.",
      h: "Is the Galadima the 'General' or the 'City Mayor'?"
    },
    {
      yr: 2021,
      q: "The 'Cold War' was a period of tension between:",
      o: ["China and Japan", "The UK and France", "The USA and the Soviet Union", "Germany and Italy"],
      a: 2,
      e: "It was an ideological struggle between Capitalism (USA) and Communism (USSR).",
      full: "It was called 'Cold' because there was no 'Hot' (direct) war between the two superpowers. Instead, they fought through 'Proxy Wars' in Africa and Asia and competed in the 'Space Race' and nuclear weapons.",
      h: "Was the struggle between 'USA vs Russia' or 'China vs Japan'?"
    },
    {
      yr: 2021,
      q: "The 'Judicial Committee of the Privy Council' was the highest court for Nigeria until:",
      o: ["1960", "1963", "1979", "1999"],
      a: 1,
      e: "Nigeria abolished appeals to the Privy Council when it became a Republic in 1963.",
      full: "Under the 1960 Independence Constitution, you could still take a case from Nigeria to London for a final judgment. But the 1963 Republican Constitution made the Supreme Court of Nigeria the 'Final Bus Stop.'",
      h: "Did we stop taking cases to London in '1960' or '1963'?"
    },
    {
      yr: 2021,
      q: "The 'Franchise' is limited in most countries to citizens who have reached the:",
      o: ["Age of 15", "Age of maturity (usually 18)", "Level of University education", "Status of property owners"],
      a: 1,
      e: "Universal Adult Suffrage gives the right to vote to all adults regardless of wealth or gender.",
      full: "In Nigeria, the 'Magic Number' is 18. Once you are 18, the constitution assumes you are mature enough to decide who should lead the country. This is called 'Universal' because it applies to everyone.",
      h: "At what age do you get your 'Voter's Card' in Nigeria?"
    },
    {
      yr: 2021,
      q: "The 'Merit System' in the civil service is designed to prevent:",
      o: ["High salaries", "Nepotism and favoritism", "Efficiency", "Anonymity"],
      a: 1,
      e: "It ensures people are hired based on their qualifications and performance.",
      full: "Without a Merit System, a Minister might fire all the experts and hire his village people who don't know the job. This would destroy the 'Civil Service Commission's' goal of a professional workforce.",
      h: "Does 'Merit' help hire 'The Best Person' or 'The Minister's Brother'?"
    },
    {
      yr: 2021,
      q: "A 'Confederation' is different from a 'Federation' because in a confederation:",
      o: ["The center is stronger", "The units are supreme and can secede", "There is no central government", "Only one person rules"],
      a: 1,
      e: "Confederations are loose unions where the states keep most of their power.",
      full: "In a Federation (like Nigeria), the states cannot just pack their bags and leave. In a Confederation (like the early US or Senegambia), the central government is 'weak,' and the states are the 'real bosses.'",
      h: "In which system can a state 'Say goodbye' to the union more easily?"
    },
    {
      yr: 2021,
      q: "The 'Aba Women's Riot' of 1929 is also known as:",
      o: ["The Ogu Umunwanyi", "The Egba Uprising", "The Agbekoya Revolt", "The Enugu Miners Strike"],
      a: 0,
      e: "Ogu Umunwanyi is the Igbo name for the historic 'Women's War.'",
      full: "This wasn't just a small protest; it was a well-organized resistance by women across the Eastern regions against the 'Warrant Chiefs' and the 'Census' which they feared would lead to taxing women.",
      h: "Is the Igbo name 'Ogu Umunwanyi' or 'Agbekoya'?"
    },
    {
      yr: 2021,
      q: "The 'Electoral Commission' is expected to be 'Autonomous.' This means:",
      o: ["It must have its own army", "It must be independent of executive or political control", "It must be based in Abuja", "It must be headed by a judge"],
      a: 1,
      e: "Autonomy ensures that the body conducting elections is neutral and fair.",
      full: "If the President 'owns' the Electoral Commission (INEC), he will always win. To have a true democracy, the Commission's funding and leadership must be protected from the influence of the people running for office.",
      h: "Should the 'Referee' be 'Friends with the Captain' or 'Independent'?"
    },
    {
      yr: 2021,
      q: "The 'Pre-colonial' Yoruba 'Kingmakers' were the:",
      o: ["Ogboni", "Oyo Mesi", "Emeso", "Are-Ona-Kakanfo"],
      a: 1,
      e: "The Oyo Mesi was the council of seven senior chiefs who selected the Alaafin.",
      full: "Led by the Bashorun, the Oyo Mesi acted as a 'Senate.' They had the power to appoint the King and, if the King became a tyrant, they could force him to 'open the calabash' (commit suicide).",
      h: "Which group 'made' the King and could 'unmake' him?"
    },
    {
      yr: 2021,
      q: "A 'Bi-party' system is a political system where:",
      o: ["There are no political parties", "There is only one legal party", "Two major parties dominate the political landscape", "There are over 100 parties"],
      a: 2,
      e: "Countries like the USA and the UK (mostly) follow a two-party (Bi-party) dominance.",
      full: "Even if there are small parties, in a Bi-party system, only two have a 'Real Chance' of winning the Presidency or forming a government. It usually provides a very stable but less diverse choice for voters.",
      h: "Does a 'Bi-party' system have 'Two major' or 'Ten major' players?"
    },
    {
      yr: 2021,
      q: "The 'Sovereignty' of a state refers to its:",
      o: ["Wealth and natural resources", "Supreme and independent power to govern itself", "Number of military tanks", "Religious affiliation"],
      a: 1,
      e: "A sovereign state has the final authority over its territory without external interference.",
      full: "If a country is 'Sovereign,' no other country can tell it what laws to make. It has 'Internal Sovereignty' (control over its people) and 'External Sovereignty' (independence from foreign control).",
      h: "Does 'Sovereignty' mean 'Money' or 'Supreme Authority'?"
    },
    {
      yr: 2021,
      q: "The 'Public Complaints Commission' (Ombudsman) cannot investigate:",
      o: ["A corrupt clerk in a ministry", "Cases that are already before a court of law", "A teacher who refuses to release results", "A local government chairman"],
      a: 1,
      e: "The PCC must not interfere with the Judiciary (cases sub-judice).",
      full: "The Ombudsman is for 'Administrative' errors. If you have already sued someone in a 'Real Court,' the PCC must stay out of it to avoid 'Contempt of Court' and to respect the Separation of Powers.",
      h: "Can the 'Ombudsman' take over a case that is already with a 'Judge'?"
    },
    {
      yr: 2021,
      q: "The 'African Union' (AU) headquarters is located in:",
      o: ["Lagos, Nigeria", "Accra, Ghana", "Addis Ababa, Ethiopia", "Cairo, Egypt"],
      a: 2,
      e: "Addis Ababa has been the seat of African unity since the days of the OAU.",
      full: "Ethiopia was chosen because it was one of the few African countries that was never fully colonized. It serves as the 'Diplomatic Capital' of the continent.",
      h: "Is the AU 'office' in 'Ethiopia' or 'South Africa'?"
    },
    {
      yr: 2021,
      q: "The 'Rule of Law' principle of 'Equality before the Law' means:",
      o: ["All citizens must have equal money", "The law applies equally to all citizens regardless of status", "Everyone must be a lawyer", "Judges are more important than doctors"],
      a: 1,
      e: "No one, including the President, is above the law.",
      full: "If a Governor steals money and a poor man steals a goat, the law should treat both as 'Criminals.' In practice, this is hard to achieve, but it is the 'Golden Goal' of any true democracy.",
      h: "Should a 'Big Man' and a 'Small Man' be judged by the 'Same Law'?"
    },
    {
      yr: 2021,
      q: "The 'Macpherson Constitution' of 1951 introduced regional:",
      o: ["Emirs", "Houses of Assembly", "Kings", "Political Parties"],
      a: 1,
      e: "It created the regional legislatures that gave Nigerians more local power.",
      full: "This was the constitution that really started the 'Regionalism' trend. It allowed the North, West, and East to have their own mini-parliaments, though they still reported to the Central Legislative Council in Lagos.",
      h: "Did Macpherson create 'Regional Armies' or 'Regional Houses of Assembly'?"
    },
    {
      yr: 2021,
      q: "The 'Judiciary' maintains its independence through the 'Consolidated Revenue Fund' by:",
      o: ["Allowing the President to pay them directly", "Ensuring their salaries are not subject to annual legislative debate", "Making judges pay their own salaries", "Collecting money from lawyers"],
      a: 1,
      e: "Charging salaries to the Consolidated Revenue Fund prevents the Executive from using 'pay cuts' to threaten judges.",
      full: "If the President could reduce a Judge's salary every time he lost a case, the Judge would be afraid to give fair judgments. By making the salary 'Automatic' from the national fund, the Judge remains 'Fearless'.",
      h: "Does the 'President' control the Judge's pay, or is it 'Protected by Law'?"
    },
    {
      yr: 2021,
      q: "The 'United Nations Security Council' has how many 'Non-Permanent' members?",
      o: ["5", "10", "15", "20"],
      a: 1,
      e: "While there are 5 Permanent members (P5), there are 10 Non-Permanent members elected for two-year terms.",
      full: "The 10 non-permanent seats are distributed geographically (Africa gets 3, Asia 2, Latin America 2, etc.). This ensures that different regions of the world have a voice in global security decisions.",
      h: "Is the number of 'Temporary' members 'Five' or 'Ten'?"
    },
    {
      yr: 2021,
      q: "A 'Delegated Legislation' made by a 'Local Government' is called a:",
      o: ["Decree", "Act", "Bye-law", "Edict"],
      a: 2,
      e: "Bye-laws are rules made by local authorities to govern their specific areas.",
      full: "Since the National Assembly cannot make laws for every market in Onitsha or every motor park in Kano, they delegate that power to the Local Government Council. These small laws are 'Bye-laws'.",
      h: "Is a law made by a 'Local Chairman' an 'Act' or a 'Bye-law'?"
    },
    {
      yr: 2021,
      q: "The 'National Congress of British West Africa' (NCBWA) was led by:",
      o: ["Herbert Macaulay", "Casely Hayford", "Nnamdi Azikiwe", "Obafemi Awolowo"],
      a: 1,
      e: "Casely Hayford, a Ghanaian lawyer, was the main engine behind this early West African movement.",
      full: "Founded in 1920, the NCBWA brought together elite Africans from Nigeria, Ghana, Sierra Leone, and Gambia. They traveled to London to demand more representation for Africans in the colonial government.",
      h: "Was the leader from 'Nigeria' or was he 'Casely Hayford' from Ghana?"
    },
    {
      yr: 2021,
      q: "The 'Executive' power in a 'Parliamentary' system is exercised by the:",
      o: ["Monarch", "Cabinet led by the Prime Minister", "Chief Justice", "Senate President"],
      a: 1,
      e: "The Prime Minister and their Cabinet are the 'Real' executive chosen from the Parliament.",
      full: "In this system, there is a 'Fusion of Powers.' The Prime Minister is both a member of Parliament (Legislature) and the leader of the Cabinet (Executive). This is the 'Westminster' style.",
      h: "Is the 'Boss' the 'King' or the 'Prime Minister'?"
    },
    {
      yr: 2021,
      q: "The 'Pre-colonial' Kanem-Borno Empire was headed by the:",
      o: ["Emir", "Mai", "Oba", "Obi"],
      a: 1,
      e: "The 'Mai' was the supreme ruler of the Kanem-Borno Empire.",
      full: "The Mai was assisted by a council of twelve called the 'Nkenkena.' This system was highly organized long before the Fulani Jihad and the British arrival.",
      h: "Is the leader called the 'Emir' or the 'Mai'?"
    },
    {
      yr: 2021,
      q: "The 'Veto Power' in the UN Security Council belongs to:",
      o: ["All member nations", "The 10 non-permanent members", "The 5 permanent members only", "Only the Secretary-General"],
      a: 2,
      e: "Only the USA, UK, China, Russia, and France (the P5) have the power to block any resolution.",
      full: "If 190 countries agree on a resolution but Russia or the USA says 'No,' the entire resolution dies. This is often criticized as being undemocratic, but it's how the UN is structured.",
      h: "How many countries have the 'Special No' power?"
    },
    {
      yr: 2021,
      q: "The 'Code of Conduct Bureau' (CCB) was established to:",
      o: ["Increase taxes", "Ensure public officers maintain high standards of morality", "Arrest common thieves", "Organize elections"],
      a: 1,
      e: "The CCB ensures that public officials declare their assets and don't take bribes.",
      full: "When a Minister or Governor takes office, they must list everything they own (houses, cars, bank accounts). When they leave office, the CCB checks to see if they 'suddenly' became too rich, which suggests corruption.",
      h: "Do they check 'Voter cards' or 'Asset declaration' of big officials?"
    },
    {
      yr: 2021,
      q: "A 'Civil Service' is 'Neutral' when it:",
      o: ["Refuses to work", "Works only for the opposition", "Serves any government in power without political bias", "Has no opinion on anything"],
      a: 2,
      e: "Neutrality means the civil servant serves the PDP today and the APC tomorrow with the same loyalty.",
      full: "The Civil Service is a 'Permanent' structure. While politicians change every 4 or 8 years, the 'engine' of government remains the same. A neutral worker doesn't care about the party; they only care about the job.",
      h: "Does the worker 'Change' with the party, or 'Stay loyal' to the office?"
    },
    {
      yr: 2021,
      q: "The 'Universal Declaration of Human Rights' (UDHR) was adopted in:",
      o: ["1918", "1945", "1948", "1960"],
      a: 2,
      e: "The UN adopted the UDHR on December 10, 1948.",
      full: "After the horrors of World War II (the Holocaust), the world decided to write down the 'Minimum Rights' every human deserves, like freedom from torture and the right to education.",
      h: "Was it '1945' (when UN started) or '1948'?"
    },
    {
      yr: 2021,
      q: "The 'Indirect Rule' system failed in 'Eastern Nigeria' because of the:",
      o: ["Lack of traditional rulers with centralized power", "Presence of many schools", "Wealth of the people", "Influence of the French"],
      a: 0,
      e: "The 'Acephalous' (headless) nature of Igbo society meant there were no 'Kings' to use for Indirect Rule.",
      full: "In the North, the British just talked to the Emir. In the East, there was no 'one person' to talk to. The British 'invented' Warrant Chiefs, which the people hated and eventually revolted against.",
      h: "Was the problem 'Too many Kings' or 'No central Kings'?"
    },
    {
      yr: 2021,
      q: "The 'OPEC' was formed to:",
      o: ["Stop the use of oil", "Regulate and stabilize oil prices globally", "Provide military aid", "Create a common currency"],
      a: 1,
      e: "The Organization of Petroleum Exporting Countries manages the supply of oil to ensure fair prices.",
      full: "Nigeria joined OPEC in 1971. By working together with other oil nations (like Saudi Arabia), Nigeria can ensure that the price of its crude oil doesn't drop too low in the international market.",
      h: "Does OPEC handle 'Military' or 'Oil Prices'?"
    },
    {
      yr: 2021,
      q: "The 'Rule of Law' principle of 'Supremacy of the Law' means:",
      o: ["The President is more important than the law", "No one can be punished unless for a breach of a known law", "Only lawyers can make decisions", "The military can ignore the law during a coup"],
      a: 1,
      e: "It means the law is the highest authority and must be followed by everyone.",
      full: "This pillar prevents 'Arbitrary Power.' A policeman cannot just arrest you because he 'doesn't like your face.' He must point to a specific law in the book that you have broken.",
      h: "Is the 'Law' the boss, or is the 'President' the boss?"
    },
    {
      yr: 2021,
      q: "The 'First Political Party' in Nigeria was founded by:",
      o: ["Nnamdi Azikiwe", "Herbert Macaulay", "Obafemi Awolowo", "Ahmadu Bello"],
      a: 1,
      e: "Herbert Macaulay founded the NNDP in 1923.",
      full: "Macaulay is called the 'Father of Nigerian Nationalism.' He used the NNDP to fight for the rights of Lagosians and to contest the elections created by the Clifford Constitution.",
      h: "Who is the 'Father' of the first party?"
    },
    {
      yr: 2021,
      q: "Which of the following is an 'Indirect' form of Democracy?",
      o: ["Referendum", "Representative Democracy", "Plebiscite", "Town Hall meeting"],
      a: 1,
      e: "Representative democracy involves choosing others to make laws on your behalf.",
      full: "Instead of every Nigerian going to Abuja to argue about the budget, we choose 'Representatives' (Senators) to do it for us. This is 'Indirect' because the people don't make the laws themselves.",
      h: "Is 'Voting for a Senator' Direct or Indirect?"
    },
    {
      yr: 2021,
      q: "The 'Secretary-General' of the UN is the head of the:",
      o: ["General Assembly", "Security Council", "Secretariat", "Trusteeship Council"],
      a: 2,
      e: "The Secretariat is the administrative 'office' of the United Nations.",
      full: "The Secretariat does all the 'paperwork' and research for the UN. The Secretary-General is the 'Manager' of this entire global administrative system.",
      h: "Is the leader the head of the 'Auditorium' or the 'Secretariat'?"
    },
    {
      yr: 2021,
      q: "The 'Judiciary' uses the 'Writ of Habeas Corpus' to:",
      o: ["Sack a minister", "Ensure a person in detention is brought before a court", "Pass the budget", "Declare war"],
      a: 1,
      e: "Habeas Corpus literally means 'Produce the Body'; it prevents illegal detention by the police.",
      full: "If the police arrest you and keep you in a cell for weeks without a trial, your lawyer can ask a Judge for a 'Writ of Habeas Corpus.' The Judge will then order the police to bring you to court immediately.",
      h: "Is this for 'Illegal detention' or 'Illegal voting'?"
    },
    {
      yr: 2021,
      q: "The 'Gowon' regime was overthrown in a coup in:",
      o: ["1966", "1975", "1976", "1983"],
      a: 1,
      e: "General Yakubu Gowon was ousted on July 29, 1975, while he was attending an OAU meeting.",
      full: "Murtala Muhammed took over after this coup. The reason given was that Gowon’s government had become 'indecisive' and had postponed the return to civilian rule indefinitely.",
      h: "Did the Gowon era end in '1966' or '1975'?"
    },
    {
      yr: 2021,
      q: "The 'Public Service' includes which of the following?",
      o: ["Political parties", "Government-owned companies and the Civil Service", "The Judiciary only", "Private businesses"],
      a: 1,
      e: "The Public Service is broader than the Civil Service; it includes corporations like NNPC and NPA.",
      full: "While 'Civil Servants' work in the Ministries, 'Public Servants' work in any body funded by the government (like Universities, Hospitals, and Agencies). All civil servants are public servants, but not all public servants are civil servants.",
      h: "Is a 'University Lecturer' a Civil Servant or a Public Servant?"
    },
    {
      yr: 2021,
      q: "The 'Lagos Youth Movement' was formed primarily to:",
      o: ["Support the British", "Oppose the NNDP in Lagos elections", "Promote farming", "Start a war"],
      a: 1,
      e: "It was formed in 1934 to challenge Herbert Macaulay’s dominance and the education policies of the time.",
      full: "They were angry about the quality of the Yaba Higher College. Later, they became the 'Nigerian Youth Movement' (NYM) to show they represented the whole country, not just Lagos.",
      h: "Did they want to 'Help' Macaulay or 'Challenge' him?"
    },

    {
      yr: 2020,
      q: "A system of government where the head of state is elected for a fixed term is a:",
      o: ["Monarchy", "Republic", "Theocracy", "Oligarchy"],
      a: 1,
      e: "A Republic is a state where supreme power is held by the people and their elected representatives.",
      full: "Unlike a Monarchy where leadership is hereditary (passed from father to son), a Republic (like Nigeria or the USA) requires an election. Even if the leader is a 'President,' if he wasn't elected by the people or their reps, it isn't a true Republic.",
      h: "Is the leader 'Born' into power or 'Elected' for a set time?"
    },
    {
      yr: 2020,
      q: "The 'Judiciary' is independent when:",
      o: ["Judges are members of the ruling party", "The President can dismiss judges at will", "Judges are appointed and disciplined by an independent body", "The legislature reviews all court judgments"],
      a: 2,
      e: "Independence is guaranteed when the executive cannot easily influence the tenure or pay of judges.",
      full: "In Nigeria, the National Judicial Council (NJC) handles the recommendation and discipline of judges. This 'buffer' ensures that a judge doesn't have to please the President to keep their job.",
      h: "Should the 'President' or an 'Independent Council' manage the judges?"
    },
    {
      yr: 2020,
      q: "The 'Lyttelton Constitution' of 1954 is famous for being the first to:",
      o: ["Introduce the elective principle", "Establish a fully federal system of government in Nigeria", "Create the first region", "Grant total independence"],
      a: 1,
      e: "It formally divided powers between the center and the regions (Federalism).",
      full: "Before Lyttelton, Nigeria was 'Quasi-federal.' Lyttelton made it 'Fully Federal' by creating the Exclusive and Concurrent lists, and making the regional governors the heads of their respective regions.",
      h: "Was Lyttelton 'Semi-federal' or 'Fully Federal'?"
    },
    {
      yr: 2020,
      q: "The 'United Nations Security Council' consists of how many total members?",
      o: ["5", "10", "15", "20"],
      a: 2,
      e: "The Council has 15 members: 5 permanent (P5) and 10 non-permanent members.",
      full: "While the P5 have the 'Veto,' the 10 non-permanent members are elected by the General Assembly for two-year terms. To pass a resolution, you need 9 'Yes' votes and ZERO 'No' votes from the P5.",
      h: "Is the total 'Ten' or 'Fifteen'?"
    },
    {
      yr: 2020,
      q: "Which of the following is a 'Civil Right'?",
      o: ["Right to vote", "Right to fair trial", "Right to hold public office", "Right to join a political party"],
      a: 1,
      e: "Civil rights protect individual freedom from infringement by governments and social organizations.",
      full: "While 'Political Rights' (like voting) allow you to participate in government, 'Civil Rights' (like a fair trial) protect your personal liberty. Even a non-citizen has the right to a fair trial, but they don't have the right to vote.",
      h: "Is this right for 'Everyone' or just for 'Voters'?"
    },
    {
      yr: 2020,
      q: "In 'Pre-colonial' Benin, the 'Uzama' were the:",
      o: ["Chief priests", "Kingmakers and senior chiefs", "Army generals", "Tax collectors"],
      a: 1,
      e: "The Uzama N'Ihinron was the body of seven hereditary chiefs who installed the Oba.",
      full: "Led by the Oliha, the Uzama were very powerful. Unlike the Oyo Mesi who could depose an Oba, the Uzama's main role was the installation and preservation of the Oba's divinity.",
      h: "Were they 'Priests' or 'Kingmakers'?"
    },
    {
      yr: 2020,
      q: "A 'Confederation' usually has a weak:",
      o: ["Regional government", "Central government", "Military", "Judiciary"],
      a: 1,
      e: "In a confederation, the center is weak because the units (states) retain their sovereignty.",
      full: "Think of a 'Loose Alliance.' The central government can't even tax citizens directly or raise an army without the states' permission. This is why most confederations eventually fail or become federations.",
      h: "Is the 'Center' or the 'State' the boss in a confederation?"
    },
    {
      yr: 2020,
      q: "The 'Richards Constitution' of 1946 introduced:",
      o: ["Direct Rule", "Regionalism", "The first Prime Minister", "Universal Suffrage"],
      a: 1,
      e: "It divided Nigeria into the Northern, Western, and Eastern regions.",
      full: "Sir Arthur Richards created these regions to 'promote the unity of Nigeria' and provide for its diverse elements. However, nationalists hated it because they weren't consulted during the drafting.",
      h: "Did Richards create 'States' or 'Regions'?"
    },
    {
      yr: 2020,
      q: "The 'Rule of Law' is limited by 'Prerogative Writ,' which means:",
      o: ["The President can ignore the law", "Courts have special powers to command government officials", "Only lawyers can vote", "The military can take over"],
      a: 1,
      e: "Writs like 'Mandamus' or 'Habeas Corpus' are special court orders used to protect rights.",
      full: "While the Rule of Law says everyone is equal, these 'Writs' give Judges a special 'Sword' to force the government to do its duty. It’s an 'exception' because it gives the Judiciary a direct command over the Executive.",
      h: "Is a 'Writ' a 'Law' or a 'Special Court Order'?"
    },
    {
      yr: 2020,
      q: "The 'ECOWAS' treaty was first signed in:",
      o: ["Lagos, 1975", "Abuja, 1991", "Lome, 1975", "Accra, 1963"],
      a: 0,
      e: "The Treaty of Lagos was signed on May 28, 1975.",
      full: "Nigeria and Togo led the move to integrate West African economies. Today, ECOWAS includes 15 countries working toward a common market and regional stability.",
      h: "Was ECOWAS born in 'Lagos' or 'Lome'?"
    },
    {
      yr: 2020,
      q: "A 'Pressure Group' that uses 'Sabotage' or 'Strikes' is called a/an:",
      o: ["Economic group", "Professional group", "Anomic group", "Religious group"],
      a: 2,
      e: "Anomic groups are unorganized and often use unconventional or violent methods.",
      full: "While 'Interest Groups' (like NBA) use letters and lobbying, 'Anomic' groups (like rioters or underground cells) use sudden action, strikes, or even sabotage to force the government to listen.",
      h: "Are they 'Peaceful Professionals' or 'Spontaneous/Radical'?"
    },
    {
      yr: 2020,
      q: "The 'Civil Service' principle of 'Permanence' means:",
      o: ["Workers never go home", "The office remains even when the government changes", "Salaries are fixed forever", "The Minister stays in power forever"],
      a: 1,
      e: "Civil servants remain in their jobs even after the political party in power loses an election.",
      full: "If every worker was sacked when a new President arrived, the government would collapse. Permanence ensures that the 'Memory' and 'Skills' of the state continue across different administrations.",
      h: "Does the 'Worker' stay or 'Leave with the President'?"
    },
    {
      yr: 2020,
      q: "The 'Macpherson Constitution' was unique because it was the first to:",
      o: ["Be made by a military man", "Involve wide consultation with Nigerians at village and regional levels", "Abolish the regions", "Introduce the Naira"],
      a: 1,
      e: "Macpherson organized 'Village Meetings' to ask Nigerians what they wanted.",
      full: "Unlike the Richards Constitution which was 'imposed,' Macpherson tried to be 'Democratic' in the drafting process. This made it much more acceptable to the Nigerian nationalists of the time.",
      h: "Did Macpherson 'Consult' the people or 'Force' the law on them?"
    },
    {
      yr: 2020,
      q: "The 'Separation of Powers' is most effective in a:",
      o: ["Parliamentary system", "Presidential system", "Monarchy", "Unitary system"],
      a: 1,
      e: "The Presidential system has a clear 'Wall' between the Executive and the Legislature.",
      full: "In a Parliamentary system, the PM is *in* the Parliament (Fusion). In a Presidential system (Nigeria), the President is *not* allowed to be a Senator. This makes it easier for one branch to 'Check' the other.",
      h: "Is power 'Separated' or 'Fused' in the Presidential system?"
    },
    {
      yr: 2020,
      q: "The 'Sovereignty' of the UN resides in the:",
      o: ["Secretary-General", "General Assembly", "Security Council", "International Court of Justice"],
      a: 1,
      e: "The General Assembly is the only body where all 193 sovereign states are represented equally.",
      full: "While the Security Council has the 'Might' (Military), the General Assembly has the 'Moral Sovereignty.' It is the 'World Parliament' where every nation has a voice.",
      h: "Which body has 'Every Country' inside it?"
    },
    {
      yr: 2020,
      q: "The 'First Military Coup' in Nigeria was led by:",
      o: ["Major Isaac Boro", "Major Chukwuma Nzeogwu", "General Aguiyi Ironsi", "Lt. Col. Yakubu Gowon"],
      a: 1,
      e: "Nzeogwu led the January 15, 1966 coup that killed the Prime Minister and Premiers.",
      full: "Though Nzeogwu led the 'action,' Ironsi eventually took power as the Head of State. The coup was a reaction to the corruption and chaos of the First Republic (Wild Wild West).",
      h: "Who was the 'Major' that started it all?"
    },
    {
      yr: 2020,
      q: "The 'Ombudsman' (PCC) in Nigeria can investigate cases of:",
      o: ["Murder and Armed Robbery", "Administrative injustice and unfair dismissal", "Breach of contract in private business", "Electoral fraud"],
      a: 1,
      e: "The PCC is for 'Bureaucratic' complaints within the government or large firms.",
      full: "If your boss at a government ministry refuses to sign your leave form or stops your promotion without a reason, you go to the PCC. They don't handle 'Criminal' cases; that's for the Police.",
      h: "Is it for 'Crimes' or 'Bad Office Management'?"
    },
    {
      yr: 2020,
      q: "The 'Electoral College' is a system where:",
      o: ["Students vote in colleges", "Citizens vote for electors who then choose the leader", "Only the educated can vote", "Voting is done by secret ballot"],
      a: 1,
      e: "It is an 'Indirect' election system used in countries like the USA.",
      full: "In an Electoral College, the 'Total Votes' of the people don't decide the winner. Instead, states have 'Points' (Electors). This is why a person can win the 'Popular Vote' but still lose the election.",
      h: "Is this a 'Direct' vote or an 'Indirect' vote through others?"
    },
    {
      yr: 2020,
      q: "Which of the following is an 'Indirect' tax?",
      o: ["Company Tax", "Personal Income Tax", "Excise Duty", "Capital Gains Tax"],
      a: 2,
      e: "Excise duties are taxes on goods produced within the country, paid by the consumer in the price.",
      full: "Indirect taxes are 'Hidden.' When you buy a bottle of soda, the tax is already inside the price. You pay it 'indirectly' to the government through the manufacturer.",
      h: "Is it taken from your 'Salary' or from the 'Goods' you buy?"
    },
    {
      yr: 2020,
      q: "The 'Aba Women's Riot' of 1929 started in the town of:",
      o: ["Aba", "Oloko", "Owerri", "Calabar"],
      a: 1,
      e: "The trouble began in Oloko when a census taker named Mark Emereuwa tried to count a woman's property.",
      full: "Although it is named after 'Aba' because the biggest protests happened there, the spark was in 'Oloko.' A woman named Nwanyeruwa led the initial resistance against the 'Warrant Chiefs.'",
      h: "Did it start in 'Aba' or 'Oloko'?"
    },

    {
      yr: 2020,
      q: "The 'Judiciary' uses the 'Writ of Mandamus' to:",
      o: ["Release a prisoner", "Compel a public official to perform their legal duty", "Stop a lower court from hearing a case", "Sentence a criminal"],
      a: 1,
      e: "Mandamus is a court order issued to a government official to do what they are legally required to do.",
      full: "If a Minister refuses to issue a license that you have already qualified for and paid for, your lawyer can seek a 'Writ of Mandamus.' It is Latin for 'We Command.' It forces the 'lazy' or 'stubborn' official to act.",
      h: "Does the court 'Command' the official or 'Release' a person?"
    },
    {
      yr: 2020,
      q: "The 'Organization of African Unity' (OAU) was mainly criticized for its policy of:",
      o: ["Non-interference in the internal affairs of member states", "Support for European trade", "Creating a single African currency", "Promoting military coups"],
      a: 0,
      e: "The OAU often looked away while dictators mistreated their citizens because of the 'Non-interference' rule.",
      full: "This policy meant that if a King or President was killing his own people, other African leaders would say, 'It is their internal problem.' This 'Old Boys' Club' approach was one of the reasons the OAU was replaced by the AU in 2002.",
      h: "Did the OAU 'Interfere' or 'Stay out' of a country's private business?"
    },
    {
      yr: 2020,
      q: "The 'Delegated Legislation' is often criticized because it:",
      o: ["Is made by elected representatives", "Violates the principle of Separation of Powers", "Is too slow to implement", "Is always written in French"],
      a: 1,
      e: "It allows the Executive (Ministers/Agencies) to make laws, which is normally the job of the Legislature.",
      full: "Since a Minister is part of the Executive, critics argue that giving them power to make 'Statutory Instruments' or 'Orders' gives them too much power. However, it is necessary because the Parliament doesn't have time for every small detail.",
      h: "Does it 'Mix' the roles of the Lawmaker and the Executive?"
    },
    {
      yr: 2020,
      q: "The '1979 Constitution' of Nigeria introduced the:",
      o: ["Parliamentary system", "Presidential system", "Unicameral legislature", "Indirect Rule"],
      a: 1,
      e: "Nigeria moved from the British-style Prime Minister to an American-style Executive President.",
      full: "The 1979 Constitution was the first to separate the 'Head of State' from the 'Head of Government' roles and combine them into one person: The President. Shehu Shagari became the first person to hold this office.",
      h: "Did 1979 bring 'A Prime Minister' or 'A President'?"
    },
    {
      yr: 2020,
      q: "The 'Commonwealth of Nations' head is currently the:",
      o: ["British Prime Minister", "British Monarch", "President of Nigeria", "Secretary-General of the UN"],
      a: 1,
      e: "The Monarch of the United Kingdom serves as the symbolic head of the association.",
      full: "Although the British Monarch is the head, the role is purely ceremonial. The actual 'work' of the Commonwealth is done by the Secretariat in London, led by an elected Secretary-General.",
      h: "Is the head a 'Politician' or a 'King/Queen'?"
    },
    {
      yr: 2020,
      q: "The 'Public Service' is funded mainly through:",
      o: ["Donations from NGOs", "The Consolidated Revenue Fund (Taxpayer money)", "Private bank loans", "Lottery winnings"],
      a: 1,
      e: "Public servants are paid by the state using national revenue like taxes and oil royalties.",
      full: "Because the Public Service is funded by the people (Taxpayers), it is expected to be accountable. This is why the 'Auditor-General' must check the books of every government department annually.",
      h: "Does the money come from 'Private gifts' or 'Government taxes'?"
    },
    {
      yr: 2020,
      q: "The 'National Party of Nigeria' (NPN) was the ruling party during the:",
      o: ["First Republic", "Second Republic", "Third Republic", "Fourth Republic"],
      a: 1,
      e: "The NPN won the 1979 and 1983 elections, led by President Shehu Shagari.",
      full: "The Second Republic (1979-1983) was dominated by the NPN. Their main rival was the UPN (Unity Party of Nigeria) led by Obafemi Awolowo. The NPN's logo was a 'Mize/Corn' plant.",
      h: "Was the NPN in power in '1960' or '1979'?"
    },
    {
      yr: 2020,
      q: "A 'Unitary' constitution is one that is usually:",
      o: ["Rigid", "Flexible", "Unwritten", "Confederal"],
      a: 1,
      e: "Because there is only one central authority, the constitution can often be changed easily by that authority.",
      full: "In a Unitary system (like the UK), the Parliament is supreme. If they want to change a law, they just pass a new one. In a Federal system (like Nigeria), you need 2/3 of the states to agree, making it 'Rigid'.",
      h: "Is it 'Hard' or 'Easy' to change a Unitary constitution?"
    },
    {
      yr: 2020,
      q: "The 'Pre-colonial' Igbo system of government was:",
      o: ["Monarchical", "Highly Centralized", "Fragmented and Decentralized", "Theocratic"],
      a: 2,
      e: "Igbo society was republican and organized around villages and age-grades.",
      full: "This 'Acephalous' (headless) system meant that decisions were reached through 'Consensus' at the village square. No one person had the power to make a law for everyone else.",
      h: "Was power held by 'One King' or 'The whole Community'?"
    },
    {
      yr: 2020,
      q: "The 'UN General Assembly' meets once a year in:",
      o: ["January", "May", "September", "December"],
      a: 2,
      e: "The annual regular session starts in September at the UN headquarters in New York.",
      full: "This is when you see all the world leaders (Presidents and Prime Ministers) traveling to New York to give speeches. It is the biggest gathering of diplomats in the world.",
      h: "Do they meet in the 'Early year' or 'September'?"
    },
    {
      yr: 2020,
      q: "The 'Rule of Law' principle of 'Individual Liberty' ensures that:",
      o: ["The police can arrest anyone at any time", "Citizens can only be punished for a breach of law proven in court", "Everyone can do whatever they like", "Only the rich are free"],
      a: 1,
      e: "A person's freedom cannot be taken away without a legal reason and a fair trial.",
      full: "This is the protection against 'Arbitrary Arrest.' Even if the President thinks you are a criminal, he cannot jail you forever without taking you before a Judge to prove his case.",
      h: "Does 'Liberty' mean 'Total freedom' or 'Freedom protected by Law'?"
    },
    {
      yr: 2020,
      q: "The 'Gerrymandering' practice is most common in which branch of government?",
      o: ["Executive", "Legislature (Electoral boundaries)", "Judiciary", "Civil Service"],
      a: 1,
      e: "It involves redrawing electoral districts to give one political party an unfair advantage.",
      full: "By 'packing' or 'cracking' certain areas, a party can win more seats even if they have fewer total votes. It is a way of 'rigging' the map before the election even starts.",
      h: "Does this affect 'Courtrooms' or 'Electoral Districts'?"
    },
    {
      yr: 2020,
      q: "The 'First Political Party' in Nigeria (NNDP) was founded to contest elections in:",
      o: ["Lagos and Calabar", "Kano and Kaduna", "Enugu and Port Harcourt", "Ibadan and Akure"],
      a: 0,
      e: "The 1922 Clifford Constitution allowed for 3 elected members from Lagos and 1 from Calabar.",
      full: "Herbert Macaulay’s NNDP dominated these elections for years. Because the rest of the country couldn't vote yet, the party was mostly focused on the interests of Lagos people.",
      h: "Was the first vote for the 'Whole Country' or just 'Lagos and Calabar'?"
    },
    {
      yr: 2020,
      q: "The 'National Assembly' in Nigeria consists of the:",
      o: ["President and the Cabinet", "Senate and the House of Representatives", "Governors and the Speakers", "Judges and the Lawyers"],
      a: 1,
      e: "Nigeria has a bicameral legislature at the federal level.",
      full: "The Senate has 109 members (3 per state + 1 for FCT), and the House of Representatives has 360 members. Together, they make up the 'Legislative Branch' of the federal government.",
      h: "Is it 'One' or 'Two' chambers in Abuja?"
    },
    {
      yr: 2020,
      q: "The 'Secretariat' of the UN is headed by the:",
      o: ["President of the General Assembly", "Secretary-General", "Chief Justice of the World Court", "Permanent Representative of the USA"],
      a: 1,
      e: "The Secretary-General is the 'Chief Administrative Officer' of the United Nations.",
      full: "The Secretariat is like the 'Engine Room.' It does all the research, translation, and administrative work. The Secretary-General leads this staff and acts as the world's top diplomat.",
      h: "Is the leader called the 'President' or the 'Secretary-General'?"
    },
    {
      yr: 2020,
      q: "The 'Universal Adult Suffrage' was first introduced in Nigeria in:",
      o: ["1922", "1951", "1979", "1999"],
      a: 2,
      e: "The 1979 Constitution was the first to give every adult Nigerian (including Northern women) the right to vote.",
      full: "Before 1979, the North did not allow women to vote (only men). The 1979 Constitution removed this barrier, making voting 'Universal' for every adult citizen across the entire country.",
      h: "Did 'Everyone' get to vote in '1922' or '1979'?"
    },
    {
      yr: 2020,
      q: "The 'Diplomatic Corps' refers to:",
      o: ["A group of soldiers", "The body of foreign ambassadors and diplomats in a country", "A political party", "A secret society"],
      a: 1,
      e: "It represents all the international diplomats officially sent to represent their countries.",
      full: "The Diplomatic Corps is headed by a 'Doyen' (usually the longest-serving ambassador). They enjoy 'Diplomatic Immunity,' which protects them from being arrested by the local police of the host country.",
      h: "Is this for 'Soldiers' or 'Foreign Ambassadors'?"
    },
    {
      yr: 2020,
      q: "The 'Pre-colonial' Yoruba system, the 'Are-Ona-Kakanfo' was the:",
      o: ["Chief Priest", "Generalissimo (Field Marshal) of the Army", "King's messenger", "Treasurer"],
      a: 1,
      e: "The Kakanfo was the supreme military commander of the Oyo Empire.",
      full: "Tradition dictated that the Are-Ona-Kakanfo must never be defeated. If he lost a war, he was expected to commit suicide rather than return home in shame. This ensured the army was always brave.",
      h: "Was he the 'Head of Religion' or the 'Head of the Army'?"
    },
    {
      yr: 2020,
      q: "The 'Pressure Group' called 'ASUU' stands for:",
      o: ["All Students Union of Universities", "Academic Staff Union of Universities", "Association of Senior University Users", "Academic Standard for United Universities"],
      a: 1,
      e: "ASUU is the trade union representing lecturers in Nigerian public universities.",
      full: "ASUU is a professional pressure group. They use 'Industrial Action' (strikes) to put pressure on the Federal Government to increase funding for education and improve their welfare.",
      h: "Is this for 'Students' or for 'Lecturers'?"
    },
    {
      yr: 2020,
      q: "The 'Judiciary' is protected from political influence by the 'National Judicial Council' (NJC), which:",
      o: ["Makes laws for the courts", "Handles the appointment, promotion, and discipline of judges", "Collects fines from criminals", "Directs the police to arrest judges"],
      a: 1,
      e: "The NJC acts as a shield between the politicians and the judges.",
      full: "Because the NJC is mostly made up of senior judges, it ensures that if a judge is being 'punished' or 'promoted,' it is because of their performance, not because they refused to help a politician win a case.",
      h: "Does the NJC protect 'Judges' or 'Politicians'?"
    },

    {
      yr: 2019,
      q: "The ultimate power to make and enforce laws in a state is called:",
      o: ["Legitimacy", "Sovereignty", "Authority", "Influence"],
      a: 1,
      e: "Sovereignty is the supreme power of the state to rule itself without external control.",
      full: "A state can have authority and legitimacy, but without 'Sovereignty,' it is not truly independent. It means the state has the final 'say' over its territory, and no other power (like a former colonial master) can override its laws.",
      h: "Is it the 'Right to rule' or the 'Final Power' to rule?"
    },
    {
      yr: 2019,
      q: "A 'Federal' system of government is one where power is divided between the:",
      o: ["President and the Prime Minister", "Executive and the Judiciary", "Central government and the component units", "Senate and the House of Reps"],
      a: 2,
      e: "Federalism involves a constitutional sharing of power between the center and the states.",
      full: "In Nigeria, the 'Center' (Federal Government) handles things like Defense and Currency, while 'States' handle things like local roads and state schools. This allows diverse groups to stay together in one country.",
      h: "Does one person 'Have it all' or is power 'Shared' among levels?"
    },
    {
      yr: 2019,
      q: "The 'Macpherson Constitution' of 1951 introduced which of the following?",
      o: ["Unitary government", "Regional legislatures", "Total independence", "One-party system"],
      a: 1,
      e: "It created the regional houses of assembly for the North, West, and East.",
      full: "This was a major step toward modern Nigeria. It allowed Nigerians to participate in governance at the regional level, even though the central government still held a lot of 'Quasi-federal' control.",
      h: "Did Macpherson create 'States' or 'Regions'?"
    },
    {
      yr: 2019,
      q: "The 'Judiciary' maintains the 'Rule of Law' by:",
      o: ["Making new laws", "Interpreting laws and protecting rights", "Arresting criminals", "Managing the economy"],
      a: 1,
      e: "The courts explain what the law means and ensure it is applied fairly to everyone.",
      full: "The Judiciary is the 'Umpire' of the system. If the Executive or Legislature breaks the rules of the Constitution, the Judiciary 'blows the whistle' and strikes down those illegal actions.",
      h: "Who 'explains' the law when there is a dispute?"
    },
    {
      yr: 2019,
      q: "Which of these is a function of 'Political Parties'?",
      o: ["Arresting thieves", "Recruiting and training political leaders", "Making court judgments", "Printing money"],
      a: 1,
      e: "Parties act as a 'grooming ground' for people who want to lead the country.",
      full: "Beyond just winning elections, parties create 'Manifestos' (plans) and teach their members how to govern. They provide the 'Platform' for a citizen to move from being an ordinary person to a Governor or President.",
      h: "Do parties 'Hire' leaders or 'Arrest' them?"
    },
    {
      yr: 2019,
      q: "The 'Pre-colonial' Hausa/Fulani system, the 'Waziri' was the:",
      o: ["Head of the Army", "Chief Justice", "Prime Minister and Senior Adviser", "Market Master"],
      a: 2,
      e: "The Waziri was the Emir's right-hand man and the administrative head of the caliphate.",
      full: "Think of the Waziri as the 'Engine' of the Emirate. He managed the other officials and gave the Emir expert advice on how to run the territory according to Islamic law.",
      h: "Is he the 'General' or the 'Senior Adviser'?"
    },
    {
      yr: 2019,
      q: "The 'United Nations' (UN) headquarters is located in:",
      o: ["London", "Paris", "New York", "Geneva"],
      a: 2,
      e: "The UN is based in New York City, USA.",
      full: "The land the UN building sits on is considered 'International Territory,' meaning it doesn't belong to the USA. It is the center of world diplomacy where all 193 member states meet.",
      h: "Is the 'World Capital' in 'Switzerland' or 'USA'?"
    },
    {
      yr: 2019,
      q: "The 'Clifford Constitution' of 1922 introduced the 'Elective Principle' in:",
      o: ["Kano and Zaria", "Lagos and Calabar", "Enugu and Onitsha", "Ilorin and Ibadan"],
      a: 1,
      e: "It allowed for 3 elected members from Lagos and 1 from Calabar.",
      full: "This was the first time in West African history that Africans were allowed to 'Vote' for their leaders, even though it was only in two cities. This led to the formation of the first political parties.",
      h: "Was the first vote in 'The North' or in 'Lagos and Calabar'?"
    },
    {
      yr: 2019,
      q: "The 'Civil Service' is expected to be 'Apolitical.' This means:",
      o: ["They must not vote", "They must not be members of any political party", "They must hate politicians", "They must work only for the President"],
      a: 1,
      e: "Civil servants must remain neutral so they can serve any party that wins the election.",
      full: "If a civil servant is an active member of Party A, they might try to sabotage the work if Party B wins. To keep the 'government machine' running, they must stay out of active politics.",
      h: "Should a government worker 'Take sides' or 'Stay Neutral'?"
    },
    {
      yr: 2019,
      q: "A 'Written' constitution is one that is:",
      o: ["Written by hand", "Found in a single formal document", "Never changed", "Only for small countries"],
      a: 1,
      e: "Nigeria and the USA have written constitutions contained in one book.",
      full: "The benefit of a written constitution is 'Clarity.' Everyone can read the same book to know their rights. Usually, these constitutions are 'Rigid,' meaning they have a special, difficult process for making changes.",
      h: "Is it a 'Collection of traditions' or 'One single book'?"
    },
    {
      yr: 2019,
      q: "The 'Pressure Group' that represents the interest of doctors in Nigeria is the:",
      o: ["NBA", "NLC", "NMA", "ASUU"],
      a: 2,
      e: "The Nigerian Medical Association (NMA) is the professional body for doctors.",
      full: "Like all professional pressure groups, the NMA lobbies the government for better hospital equipment and better pay for doctors. They use 'Professional standards' to influence government health policy.",
      h: "What is the acronym for 'Medical Association'?"
    },
    {
      yr: 2019,
      q: "The 'Organization of Petroleum Exporting Countries' (OPEC) was founded in:",
      o: ["Lagos", "Baghdad", "Vienna", "Geneva"],
      a: 1,
      e: "OPEC was established in Baghdad, Iraq, in 1960.",
      full: "The founding members were Iran, Iraq, Kuwait, Saudi Arabia, and Venezuela. Nigeria joined much later in 1971. Their goal is to coordinate oil policies to ensure stable prices for producers.",
      h: "Was it founded in 'Nigeria' or 'Iraq'?"
    },
    {
      yr: 2019,
      q: "The 'Rule of Law' is most associated with which of the following thinkers?",
      o: ["Montesquieu", "A.V. Dicey", "John Locke", "Thomas Hobbes"],
      a: 1,
      e: "Dicey developed the three pillars of the Rule of Law in his 1885 book.",
      full: "Dicey argued that for a country to be 'Just,' the law must be Supreme, everyone must be Equal before it, and people's Rights must be protected by the courts.",
      h: "Who said 'Everyone is equal before the law'?"
    },
    {
      yr: 2019,
      q: "Which of the following describes 'Naturalization'?",
      o: ["Citizenship by birth", "Citizenship by marriage", "Citizenship granted to a foreigner by law", "Citizenship by honor"],
      a: 2,
      e: "It is the legal process where a non-citizen acquires citizenship of another country.",
      full: "In Nigeria, a foreigner must live here for 15 years, show good character, and be useful to the country to apply for 'Naturalization.' Once granted by the President, they become a full Nigerian citizen.",
      h: "Is this 'Birth' or 'Acquiring it later'?"
    },
    {
      yr: 2019,
      q: "The 'Ombudsman' (Public Complaints Commission) was first created in:",
      o: ["Nigeria", "Sweden", "USA", "Britain"],
      a: 1,
      e: "The concept of the Ombudsman originated in Sweden in 1809.",
      full: "Sweden created the office to protect citizens from the 'Abuse of Power' by the King's officials. Nigeria adopted the same model in 1975 to help regular people report 'Administrative injustice.'",
      h: "Did the 'Ombudsman' start in 'Africa' or 'Sweden'?"
    },
    {
      yr: 2019,
      q: "The 'Pre-colonial' Yoruba 'Oyo Mesi' had the power to:",
      o: ["Elect the Oba", "Dismiss the Oba (force suicide)", "Command the army", "Collect taxes"],
      a: 1,
      e: "The Oyo Mesi was a check on the powers of the Alaafin of Oyo.",
      full: "If the Alaafin became a dictator, the Bashorun (head of Oyo Mesi) could present him with an empty calabash, meaning 'The people and the gods have rejected you.' The Oba was then expected to commit suicide.",
      h: "Could they 'Fire' the King or just 'Advise' him?"
    },
    {
      yr: 2019,
      q: "The 'Separation of Powers' means that:",
      o: ["One person holds all power", "Power is divided among the Executive, Legislature, and Judiciary", "Power is shared between the North and South", "The military and civilians rule together"],
      a: 1,
      e: "This principle prevents tyranny by ensuring no single branch has total control.",
      full: "Montesquieu popularized this. The idea is that the Legislators make the law, the President executes it, and the Judges interpret it. They 'Check' each other like a game of Rock-Paper-Scissors.",
      h: "Does power 'Stay in one hand' or is it 'Divided into three'?"
    },
    {
      yr: 2019,
      q: "The 'African Union' (AU) replaced the 'Organization of African Unity' (OAU) in:",
      o: ["1960", "1999", "2002", "2015"],
      a: 2,
      e: "The AU was officially launched in Durban, South Africa, in 2002.",
      full: "The OAU was old and focused mostly on 'Political Freedom.' The AU was created to focus more on 'Economic Integration' and 'Security' (being able to intervene in countries where people are being killed).",
      h: "Did the AU start in '1963' or '2002'?"
    },
    {
      yr: 2019,
      q: "A 'Public Corporation' is established by an:",
      o: ["Act of Parliament", "Executive order", "Private agreement", "Religious decree"],
      a: 0,
      e: "Bodies like the NPA or Water Board are created by specific laws passed by the legislature.",
      full: "Because they are 'Created by Law,' they are separate from the Civil Service. They have 'Legal Personality,' meaning they can borrow money and even be sued in court like a private company.",
      h: "Is it created by a 'Contract' or a 'Law'?"
    },
    {
      yr: 2019,
      q: "The 'Franchise' refers to the legal right to:",
      o: ["Own land", "Vote in an election", "Speak in public", "Travel abroad"],
      a: 1,
      e: "Franchise (or Suffrage) is the fundamental right of a citizen to participate in voting.",
      full: "In Nigeria, 'Universal Adult Suffrage' means every citizen who is 18 years and above can vote. This is the foundation of 'Consent' in a democracy.",
      h: "Is it about 'Buying a business' or 'Voting'?"
    },
    {
      yr: 2019,
      q: "The 'Judiciary' uses the 'Writ of Certiorari' to:",
      o: ["Release a suspect", "Order a lower court to send up its records for review", "Sack a governor", "Arrest a senator"],
      a: 1,
      e: "Certiorari allows a higher court to review and potentially quash the decision of a lower court.",
      full: "If a High Court makes a judgment that seems legally wrong or outside its power, the Supreme Court can issue a 'Writ of Certiorari' to 'pull up' the file, review it, and cancel the wrong decision.",
      h: "Does the court 'Review a file' or 'Release a body'?"
    },
    {
      yr: 2019,
      q: "The 'United Nations Security Council' has how many 'Permanent' members?",
      o: ["5", "10", "15", "54"],
      a: 0,
      e: "The P5 consists of China, France, Russia, the UK, and the USA.",
      full: "These five nations were the victors of World War II. They hold 'Veto Power,' meaning they can stop any substantive resolution from passing, even if every other country in the world votes for it.",
      h: "Is the number of 'Forever' members 'Five' or 'Fifteen'?"
    },
    {
      yr: 2019,
      q: "A 'Confederation' is often described as a:",
      o: ["Strong union of states", "Loose association of independent states", "Military dictatorship", "One-party state"],
      a: 1,
      e: "In a confederation, the central government is weak and the component units are supreme.",
      full: "Unlike Nigeria (a Federation), in a Confederation, the states can usually leave the union whenever they want. The center cannot make laws that apply directly to citizens without the states' approval.",
      h: "Is the union 'Tight' or 'Loose'?"
    },
    {
      yr: 2019,
      q: "The 'Lyttelton Constitution' of 1954 gave 'Residual Powers' to the:",
      o: ["Federal Government", "Regional Governments", "Local Governments", "British Monarch"],
      a: 1,
      e: "Residual powers (matters not on the Exclusive or Concurrent lists) were handled by the regions.",
      full: "This constitution made Nigeria a 'True Federation.' It listed what the Center could do (Exclusive) and what both could do (Concurrent). Anything left over (Residual) belonged to the Regions.",
      h: "Did 'Leftover' powers go to the 'Center' or the 'Regions'?"
    },
    {
      yr: 2019,
      q: "The 'Public Service Commission' ensures 'Neutrality' by:",
      o: ["Hiring only party members", "Protecting civil servants from political dismissal", "Paying very high salaries", "Allowing workers to strike"],
      a: 1,
      e: "It acts as a buffer to prevent politicians from firing career workers for political reasons.",
      full: "Because the Commission (not the Minister) handles hiring and firing, a civil servant can tell a Minister 'No' if a request is illegal, without fearing they will lose their job the next day.",
      h: "Does the Commission protect 'Workers' or 'Politicians'?"
    },
    {
      yr: 2019,
      q: "The 'Pre-colonial' Igbo 'Oha-na-eze' refers to the:",
      o: ["Secret society", "Assembly of the whole village/people", "Council of war", "King's palace"],
      a: 1,
      e: "The Oha-na-eze was the supreme legislative body in the decentralized Igbo system.",
      full: "In this 'Village Democracy,' every adult male usually had the right to speak. Decisions were made by 'Consensus' (everyone agreeing) rather than a King simply giving an order.",
      h: "Is this a 'Secret Meeting' or a 'Village Assembly'?"
    },
    {
      yr: 2019,
      q: "The 'International Court of Justice' (ICJ) is located in:",
      o: ["New York", "Geneva", "The Hague", "Addis Ababa"],
      a: 2,
      e: "The ICJ (World Court) is based in The Hague, Netherlands.",
      full: "This is the only major UN organ not located in New York. It settles disputes between *countries* (like the Bakassi Peninsula dispute between Nigeria and Cameroon), not individuals.",
      h: "Is the 'World Court' in 'USA' or 'Netherlands'?"
    },
    {
      yr: 2019,
      q: "The 'Gerrymandering' practice is intended to:",
      o: ["Ensure fair representation", "Give an unfair advantage to a political party", "Increase voter turnout", "Simplify the ballot paper"],
      a: 1,
      e: "It is the manipulation of electoral boundaries for political gain.",
      full: "By drawing the map in a strange shape, a party can 'cluster' all their opponents into one small district while spreading their own supporters across many districts to win more seats.",
      h: "Is it 'Fair Map Drawing' or 'Cheating with Maps'?"
    },
    {
      yr: 2019,
      q: "The 'National Youth Service Corps' (NYSC) was established in 1973 to:",
      o: ["Train soldiers", "Promote national unity and integration", "Provide cheap labor", "Reduce university fees"],
      a: 1,
      e: "It was created after the Civil War to heal the country and encourage tribal mixing.",
      full: "General Yakubu Gowon started the scheme to 'Reconcile, Rehabilitate, and Reconstruct' Nigeria. It sends graduates to states other than their own to learn about different cultures.",
      h: "Was it for 'War' or for 'Unity'?"
    },
    {
      yr: 2019,
      q: "Which of the following is a 'Direct' Democracy method?",
      o: ["Voting for a Senator", "Referendum", "Appointing a Minister", "Reading the news"],
      a: 1,
      e: "A referendum allows citizens to vote directly on a specific law or policy.",
      full: "In a Referendum, the government asks the people: 'Yes or No?' The people's vote *is* the final decision. This is 'Direct' because there is no middle-man or representative making the choice for you.",
      h: "Is 'Voting on a Law' Direct or Indirect?"
    },
    {
      yr: 2019,
      q: "The 'Diplomatic Immunity' of an ambassador means they:",
      o: ["Don't have to follow any laws", "Cannot be prosecuted by the host country's courts", "Can vote in the host country's elections", "Are above their own country's laws"],
      a: 1,
      e: "Immunity ensures that foreign diplomats can work without fear of harassment by local police.",
      full: "Under international law, an ambassador cannot be jailed by the country they are visiting. If they commit a serious crime, the host country can only declare them 'Persona Non Grata' and deport them.",
      h: "Can the local police 'Arrest' an Ambassador?"
    },
    {
      yr: 2019,
      q: "The 'African Union' (AU) 'Commission' serves as the:",
      o: ["Highest court", "Administrative secretariat", "Military wing", "Legislative house"],
      a: 1,
      e: "The Commission handles the day-to-day running of the AU in Addis Ababa.",
      full: "Led by a Chairperson, the Commission implements the AU's policies, coordinates meetings, and manages the organization's budget and staff across Africa.",
      h: "Is the Commission the 'Engine Room' or the 'Judges'?"
    },
    {
      yr: 2019,
      q: "The 'Rule of Law' is often threatened by a 'State of Emergency' because:",
      o: ["Courts are closed forever", "The executive can suspend certain fundamental rights", "Taxes are abolished", "The constitution is burned"],
      a: 1,
      e: "During emergencies, the government may limit freedoms for the sake of national security.",
      full: "If there is a war or a major riot, the President can declare an emergency. This allows them to arrest people without trial or stop protests—actions that would normally be illegal under the Rule of Law.",
      h: "Can the government 'Pause' some rights during a 'Crisis'?"
    },
    {
      yr: 2019,
      q: "The 'Electoral Commission' is 'Neutral' when its funding comes from the:",
      o: ["Ruling Party", "Consolidated Revenue Fund", "Foreign NGOs", "Individual candidates"],
      a: 1,
      e: "Automatic funding from the national purse prevents the government from 'starving' the commission of money.",
      full: "If the President could 'cut the budget' of INEC whenever he was angry, the commission would be afraid to be fair. Independent funding ensures they can plan and run elections without political pressure.",
      h: "Should money come from the 'Party' or the 'National Fund'?"
    },
    {
      yr: 2019,
      q: "The 'Pre-colonial' Hausa 'Sarkin Pawa' was the head of:",
      o: ["The Army", "The Butchers", "The Palace", "The Market"],
      a: 1,
      e: "The Sarkin Pawa supervised the meat industry and the butchers in the Emirate.",
      full: "Traditional Hausa administration was very specific. Every trade (blacksmiths, weavers, butchers) had a 'Sarkin' (Head) who ensured standards were met and taxes were collected for the Emir.",
      h: "Is he the 'Head Butcher' or the 'Head General'?"
    },
    {
      yr: 2019,
      q: "The 'Murtala/Obasanjo' regime (1975-1979) was famous for:",
      o: ["Starting the Civil War", "Creating a transition program to return to civilian rule", "Abolishing the regions", "Joining the Commonwealth"],
      a: 1,
      e: "They kept their promise to hand over power to a democratically elected government in 1979.",
      full: "After over a decade of military rule, this regime created a clear 'Timetable' for elections. They oversaw the drafting of the 1979 Constitution and successfully handed over to Shehu Shagari.",
      h: "Did they 'Keep Power' or 'Plan to Leave'?"
    },
    {
      yr: 2019,
      q: "A 'Delegated Legislation' made by a 'Minister' is called a/an:",
      o: ["Act", "Statutory Instrument/Order", "Bye-law", "Decree"],
      a: 1,
      e: "Ministers use Statutory Instruments to add detail to laws passed by the Parliament.",
      full: "If Parliament passes a 'Health Act,' they might allow the Health Minister to release an 'Order' specifying which medicines are banned. This saves the Parliament's time.",
      h: "Is a Minister's law an 'Act' or an 'Order'?"
    },
    {
      yr: 2019,
      q: "The 'Universal Declaration of Human Rights' (UDHR) contains how many articles?",
      o: ["10", "20", "30", "50"],
      a: 2,
      e: "The UDHR consists of 30 specific articles outlining human rights.",
      full: "Adopted in 1948, these 30 points range from the 'Right to Life' (Article 3) to the 'Right to Education' (Article 26). It is the most translated document in the world.",
      h: "Is the number of rights 'Thirty' or 'Fifty'?"
    },
    {
      yr: 2019,
      q: "The 'Judiciary' uses the 'Writ of Prohibition' to:",
      o: ["Stop a lower court from exceeding its jurisdiction", "Command a person to come to court", "Release a suspect from jail", "Sack a corrupt judge"],
      a: 0,
      e: "Prohibition 'forbids' a lower court from continuing to hear a case it has no power over.",
      full: "If a Magistrate Court (which handles small crimes) suddenly tries to judge a Murder case (which only a High Court can do), the High Court issues a 'Writ of Prohibition' to tell them to 'Stop immediately'.",
      h: "Does it 'Command action' or 'Stop a lower court'?"
    },
    {
      yr: 2019,
      q: "The 'ECOWAS' headquarters is located in:",
      o: ["Lagos, Nigeria", "Abuja, Nigeria", "Lome, Togo", "Accra, Ghana"],
      a: 1,
      e: "The ECOWAS Commission is based in Abuja.",
      full: "While the original treaty was signed in Lagos in 1975, the headquarters (Secretariat) was later moved to the new capital, Abuja, where it manages West African integration.",
      h: "Is the 'Office' in 'Lagos' or 'Abuja'?"
    },
    {
      yr: 2018,
      q: "The 'Judiciary' is responsible for the 'Prerogative of Mercy,' which allows the:",
      o: ["Judge to take a bribe", "President or Governor to pardon a convicted criminal", "Police to release a suspect", "Lawyer to win a case automatically"],
      a: 1,
      e: "The Prerogative of Mercy is an executive power to grant a pardon (Amnesty).",
      full: "Although it involves a court sentence, the 'Mercy' part is actually an Executive function. On advice from a committee, a Governor can release a prisoner on Independence Day if they have shown good behavior.",
      h: "Is 'Mercy' given by the 'Judge' or the 'President/Governor'?"
    },
    {
      yr: 2018,
      q: "A 'Unitary' system of government is characterized by:",
      o: ["Concentration of power at the center", "Division of power between states", "Rule by a King only", "Lack of a constitution"],
      a: 0,
      e: "In a Unitary state, the central government is the supreme source of all authority.",
      full: "Countries like the UK or France use this. There are no 'State Governments' with their own independent powers. Any power a local council has is 'given' by the center and can be taken back at any time.",
      h: "Is power 'Scattered' or 'Concentrated at the top'?"
    },
    {
      yr: 2018,
      q: "The 'United Nations' (UN) 'Trusteeship Council' was established to:",
      o: ["Manage world finances", "Supervise territories not yet independent", "Arrest war criminals", "Protect the environment"],
      a: 1,
      e: "It was created to help 'Trust Territories' transition to self-government or independence.",
      full: "After World War II, some colonies were placed under UN care. Once the last territory (Palau) became independent in 1994, the Council suspended its main operations, but it still exists on paper.",
      h: "Was it for 'Money' or for 'Colonies waiting for freedom'?"
    },
    {
      yr: 2018,
      q: "The 'Gowon' administration (1966-1975) created how many states in 1967?",
      o: ["4", "12", "19", "21"],
      a: 1,
      e: "Gowon split the 4 regions into 12 states to weaken the secessionist movement.",
      full: "Just before the Civil War started, Gowon broke the old 'Regional' structure. This was a strategic move to give minority ethnic groups their own states and reduce the power of the three big regions.",
      h: "Did Gowon start with 'Four' or 'Twelve' states?"
    },
    {
      yr: 2018,
      q: "The 'Public Service' is characterized by 'Anonymity.' This means:",
      o: ["Workers must hide their faces", "The Minister takes the praise or blame for the department's work", "Workers have no names", "The office address is secret"],
      a: 1,
      e: "Civil servants work behind the scenes and are not publicly credited for government policy.",
      full: "If a policy is successful, the Minister gets the applause. If it fails, the Minister 'takes the hit' in Parliament. The civil servant who actually wrote the policy remains 'Anonymous' to the public.",
      h: "Who 'faces the public'—the 'Worker' or the 'Minister'?"
    },
    {
      yr: 2018,
      q: "In 'Pre-colonial' Hausa/Fulani systems, the 'Madawaki' was the:",
      o: ["Chief Justice", "Commander-in-Chief of the Army", "Head of the Police", "Treasurer"],
      a: 1,
      e: "The Madawaki was the senior military official and adviser to the Emir.",
      full: "While the Emir was the spiritual and political leader, the Madawaki handled the 'Hard Power.' He organized the cavalry and defended the borders of the Emirate from invaders.",
      h: "Is the Madawaki a 'Judge' or a 'General'?"
    },
    {
      yr: 2018,
      q: "The 'Commonwealth of Nations' is an association of:",
      o: ["African countries only", "Former British colonies and the UK", "Oil-producing countries", "European nations"],
      a: 1,
      e: "It is a voluntary association of 56 independent member states, mostly former British territories.",
      full: "Members share the English language and similar legal systems. Every two years, they hold the CHOGM (Commonwealth Heads of Government Meeting) to discuss trade, education, and human rights.",
      h: "Is this the 'Old British Empire' club or the 'OPEC' club?"
    },
    {
      yr: 2018,
      q: "The 'Elective Principle' was first introduced in Nigeria by the:",
      o: ["Richards Constitution", "Clifford Constitution", "Macpherson Constitution", "Lyttelton Constitution"],
      a: 1,
      e: "The 1922 Clifford Constitution allowed Nigerians to vote for the first time.",
      full: "This 'Principle' was the seed of democracy in Nigeria. It ended the era where the British simply 'appointed' whoever they liked to represent Nigerians in the Legislative Council.",
      h: "Who gave Nigerians the 'Vote' in '1922'?"
    },
    {
      yr: 2018,
      q: "A 'Rigid' constitution is one that:",
      o: ["Is printed on hard paper", "Requires a special and difficult procedure to amend", "Cannot be changed at all", "Is only used by the military"],
      a: 1,
      e: "Federal states usually have rigid constitutions to protect the powers of the component units.",
      full: "In Nigeria, to change the constitution, you need 2/3 of the National Assembly AND 2/3 of the 36 State Houses of Assembly. This makes it 'Hard' (Rigid) to change compared to a simple law.",
      h: "Is it 'Easy' or 'Difficult' to change?"
    },
    {
      yr: 2018,
      q: "The 'Rule of Law' principle of 'Supremacy of the Law' means:",
      o: ["The law is the highest authority in the land", "Only lawyers are supreme", "The President can make any law", "The military can suspend the law"],
      a: 0,
      e: "Everyone, including the government, must act within the limits of the law.",
      full: "This is the opposite of 'Arbitrary Power.' In a country where the law is supreme, a leader cannot punish you just because they are angry; they must find a law that you have actually broken.",
      h: "Is the 'Law' the boss or is the 'Man' the boss?"
    },
    {
      yr: 2018,
      q: "The 'Pressure Group' that uses 'Lobbying' is primarily trying to:",
      o: ["Overthrow the government", "Persuade legislators to pass laws in their favor", "Win an election", "Arrest corrupt officials"],
      a: 1,
      e: "Lobbying involves meeting with lawmakers to influence their decisions.",
      full: "Lobbyists are 'Professional Persuaders.' They provide information and arguments to Senators to show why a certain law (like a tax break or an environmental rule) should be passed or rejected.",
      h: "Do they want to 'Persuade' or 'Rule'?"
    },
    {
      yr: 2018,
      q: "The 'Judiciary' uses the 'Writ of Quo Warranto' to:",
      o: ["Release a prisoner", "Challenge a person's right to hold a public office", "Stop a war", "Pass a budget"],
      a: 1,
      e: "Quo Warranto means 'By what warrant?' It is used to remove someone from a position they are not entitled to.",
      full: "If a person starts acting as a Local Government Chairman without being properly elected or appointed, a citizen can ask the court for a 'Writ of Quo Warranto' to force them to prove they have the right to be there.",
      h: "Does the court ask 'Where is the body?' or 'What is your authority?'"
    },
    {
      yr: 2018,
      q: "The 'Organization of African Unity' (OAU) 'Liberation Committee' was based in:",
      o: ["Lagos, Nigeria", "Dar es Salaam, Tanzania", "Addis Ababa, Ethiopia", "Cairo, Egypt"],
      a: 1,
      e: "Tanzania was the headquarters for the committee that supported freedom fighters across Africa.",
      full: "This committee provided money, weapons, and training to groups fighting for independence in countries like South Africa (against Apartheid), Zimbabwe, and Angola.",
      h: "Was the 'Freedom Committee' in 'Ethiopia' or 'Tanzania'?"
    },
    {
      yr: 2018,
      q: "Which of the following is an 'Exclusive' power of the Federal Government?",
      o: ["Health", "Education", "External Affairs (Foreign Policy)", "Agriculture"],
      a: 2,
      e: "Only the Federal Government can manage relationships with other countries.",
      full: "A State Governor cannot go to the UN and represent Nigeria, nor can they sign a treaty with the USA. External Affairs, Defense, and Aviation are strictly for the 'Big Office' in Abuja.",
      h: "Can a 'Governor' or only the 'President' talk to foreign countries?"
    },
    {
      yr: 2018,
      q: "The 'Ombudsman' (PCC) in Nigeria was established by which regime?",
      o: ["Tafawa Balewa", "Murtala/Obasanjo", "Shehu Shagari", "Ibrahim Babangida"],
      a: 1,
      e: "The Public Complaints Commission was created in 1975 during military rule.",
      full: "The regime wanted to show they were against 'Corruption' and 'Inefficiency.' The PCC was designed to let the 'Common Man' complain about being mistreated by government officials.",
      h: "Was it created in '1960' or '1975'?"
    },
    {
      yr: 2018,
      q: "The 'Pre-colonial' Yoruba 'Ogboni' society performed primarily:",
      o: ["Military and police duties", "Judicial and religious functions", "Tax collection", "Educational services"],
      a: 1,
      e: "The Ogboni acted as a mediator and performed rituals to keep the society balanced.",
      full: "The Ogboni was a 'Secret Society' of elders. Because they were seen as the link between the living and the ancestors, they had the power to judge cases that were too difficult for the King or the Council.",
      h: "Were they 'Soldiers' or 'Judges/Priests'?"
    },
    {
      yr: 2018,
      q: "The 'Separation of Powers' was designed to avoid:",
      o: ["Democracy", "Efficiency", "Tyranny and the abuse of power", "Public voting"],
      a: 2,
      e: "By dividing power, no single person or group can become too powerful.",
      full: "If the person who 'Makes the law' is also the person who 'Enforces it' and the person who 'Judges it,' you have a Dictatorship. Dividing these roles keeps the government in check.",
      h: "Does 'Separation' help 'The Dictator' or 'The People'?"
    },
    {
      yr: 2018,
      q: "The 'African Union' (AU) 'Assembly' consists of:",
      o: ["Foreign Ministers", "Chief Justices", "Heads of State and Government", "Soldiers"],
      a: 2,
      e: "The Assembly is the supreme organ of the AU, made up of the Presidents/PMs of all member states.",
      full: "The Assembly meets once a year to make the 'Big Decisions' for the continent. Below them are the Ministers and the Commission who handle the daily work.",
      h: "Is the 'Assembly' for 'Ministers' or 'Presidents'?"
    },
    {
      yr: 2018,
      q: "A 'Referendum' is a direct vote on a/an:",
      o: ["Candidate for office", "Specific constitutional or political issue", "Budget item", "Appointment of a judge"],
      a: 1,
      e: "It is a form of direct democracy where the people decide on a major policy change.",
      full: "For example, if Nigeria wanted to decide whether to change its name, it might use a 'Referendum' so that every citizen can say 'Yes' or 'No' directly, instead of letting politicians decide.",
      h: "Is this 'Voting for a Person' or 'Voting on an Issue'?"
    },
    {
      yr: 2018,
      q: "The 'First Republic' of Nigeria (1963-1966) was headed by:",
      o: ["A Prime Minister and a Ceremonial President", "An Executive President only", "A Military Governor", "A British Governor-General"],
      a: 0,
      e: "Nigeria followed the Parliamentary system with Tafawa Balewa (PM) and Nnamdi Azikiwe (President).",
      full: "In this system, the 'President' was just a figurehead (like the Queen), while the 'Prime Minister' held the real executive power. This changed in 1979 to the Presidential system.",
      h: "Did the First Republic have 'One Boss' or 'Two Bosses' (PM and President)?"
    },
    {
      yr: 2018,
      q: "The 'Judiciary' uses the 'Writ of Habeas Corpus' to ensure that:",
      o: ["A person is not illegally detained", "A witness tells the truth", "The President follows the law", "A judge is paid"],
      a: 0,
      e: "Habeas Corpus literally means 'Produce the Body' and is used to challenge unlawful imprisonment.",
      full: "If the police keep you in a cell for three days without taking you to court, your lawyer can get this Writ. The Judge then orders the police to bring you to court to explain why they are holding you. If there is no legal reason, you must be released.",
      h: "Is this for 'Illegal detention' or 'Illegal voting'?"
    },
    {
      yr: 2018,
      q: "The 'United Nations' (UN) 'Secretary-General' is appointed for a term of:",
      o: ["2 years", "4 years", "5 years", "10 years"],
      a: 2,
      e: "The Secretary-General serves a 5-year term, which can be renewed once.",
      full: "The appointment is made by the General Assembly, but only after the Security Council (the P5) has recommended a candidate. This ensures the 'World's Top Diplomat' has the support of the most powerful nations.",
      h: "Is the term 'Four' or 'Five' years?"
    },
    {
      yr: 2018,
      q: "A 'Federal' system is best for a country with:",
      o: ["A small population", "Diverse ethnic and religious groups", "One single language", "No natural resources"],
      a: 1,
      e: "Federalism allows different groups to manage their own local affairs while staying in one country.",
      full: "In a country like Nigeria with over 250 ethnic groups, a 'Unitary' system would cause too much fighting. Federalism gives 'Autonomy' to the states, so people in Kano can have different local laws than people in Enugu.",
      h: "Is it for 'Simple' countries or 'Diverse/Complex' ones?"
    },
    {
      yr: 2018,
      q: "The '1976 Local Government Reform' in Nigeria was significant because it:",
      o: ["Abolished local governments", "Recognized local government as a third tier of government", "Made kings the chairmen", "Reduced the number of councils"],
      a: 1,
      e: "It created a uniform system of local government across the whole country.",
      full: "Before 1976, every region did their own thing. The Murtala/Obasanjo reform made the Local Government an 'Official' part of the government structure, with its own functions and its own share of the national money.",
      h: "Did it 'Delete' local government or make it 'The 3rd Tier'?"
    },
    {
      yr: 2018,
      q: "The 'Public Service' principle of 'Impartiality' means:",
      o: ["Working slowly", "Treating all citizens equally regardless of their party or tribe", "Only helping the rich", "Refusing to take orders"],
      a: 1,
      e: "A public servant must provide services to the public without showing favoritism.",
      full: "If you go to a government hospital or a passport office, the officer shouldn't care if you are from the North or South, or if you support the APC or PDP. They are 'Impartial' servants of the State.",
      h: "Should they 'Show Favor' or 'Treat Everyone Equal'?"
    },
    {
      yr: 2018,
      q: "In 'Pre-colonial' Igbo society, the 'Age Grades' were responsible for:",
      o: ["Electing the King", "Public works and community defense", "Writing the laws", "Taxing the elderly"],
      a: 1,
      e: "Age grades performed executive tasks like clearing roads and guarding the village.",
      full: "Because there was no 'Central King' to give orders, the village relied on these groups of men born around the same time. They acted as the 'Labor Force' and the 'Police' for the community.",
      h: "Were they 'Lawyers' or the 'Village Workforce/Defense'?"
    },
    {
      yr: 2018,
      q: "The 'Commonwealth' 'Secretariat' is located in:",
      o: ["New York", "London", "Abuja", "Ottawa"],
      a: 1,
      e: "The headquarters of the Commonwealth is Marlborough House in London.",
      full: "The Secretariat is led by a Secretary-General (currently Patricia Scotland). It organizes the meetings and helps member countries with things like election monitoring and economic development.",
      h: "Is the 'Office' in 'UK' or 'Canada'?"
    },
    {
      yr: 2018,
      q: "The 'Clifford Constitution' of 1922 was named after:",
      o: ["A Nigerian nationalist", "The British Governor-General", "A city in England", "A famous judge"],
      a: 1,
      e: "Sir Hugh Clifford was the Governor of Nigeria who introduced the 1922 constitution.",
      full: "Colonial constitutions were usually named after the Governor in power at the time (Clifford, Richards, Macpherson, Lyttelton). This shows that the British were the ones deciding the rules for Nigeria back then.",
      h: "Was 'Clifford' a 'Nigerian' or a 'British Governor'?"
    },
    {
      yr: 2018,
      q: "A 'Flexible' constitution is one that:",
      o: ["Can be bent easily", "Is unwritten", "Can be amended by a simple majority in parliament", "Is only for dictators"],
      a: 2,
      e: "Flexible constitutions are changed the same way as any ordinary law.",
      full: "The UK is the best example. They don't need a 2/3 majority of states to change a rule. If the Parliament votes 'Yes' by a simple majority, the constitution changes. It 'flexes' with the needs of the time.",
      h: "Is it 'Hard' or 'Easy' to change this type?"
    },
    {
      yr: 2018,
      q: "The 'Rule of Law' principle of 'Equality before the law' is often limited by:",
      o: ["The police", "Diplomatic Immunity", "The school system", "The weather"],
      a: 1,
      e: "Diplomats cannot be tried in the courts of the country they are visiting.",
      full: "This is a 'Legal Exception.' While the Rule of Law says *everyone* is equal, international law protects ambassadors. If a foreign ambassador breaks a law, they are usually sent home rather than jailed here.",
      h: "Are 'Ambassadors' and 'Regular Citizens' treated exactly the same by the police?"
    },
    {
      yr: 2018,
      q: "The 'Pressure Group' called the 'NLC' stands for:",
      o: ["Nigerian Law Council", "Nigerian Labour Congress", "National Liberty Committee", "Northern Leaders Conference"],
      a: 1,
      e: "The NLC is the umbrella body for trade unions in Nigeria.",
      full: "The NLC is a 'Protective' pressure group. They fight for workers' rights, like the 'Minimum Wage.' If the government refuses to increase pay, the NLC can call for a 'National Strike' to shut down the country.",
      h: "Is this for 'Lawyers' or 'Workers/Labour'?"
    },
    {
      yr: 2018,
      q: "The 'Judiciary' maintains its independence through 'Security of Tenure,' which means:",
      o: ["Judges live in safe houses", "Judges cannot be removed from office easily before retirement", "Judges have many bodyguards", "Judges are never fired"],
      a: 1,
      e: "Ensuring judges stay in office until retirement prevents them from being bullied by politicians.",
      full: "If a Judge knew the President could fire them for an 'unfriendly' judgment, the Judge would be scared. Security of Tenure means as long as they are 'of good behavior,' they keep their job until the legal age (70 for Supreme Court).",
      h: "Does 'Tenure' mean 'Safety from thieves' or 'Safety from being fired'?"
    },
    {
      yr: 2018,
      q: "The 'OAU' was founded in 1963 in:",
      o: ["Lagos", "Cairo", "Addis Ababa", "Accra"],
      a: 2,
      e: "Ethiopia hosted the founding of the Organization of African Unity.",
      full: "32 independent African states met in Addis Ababa to sign the charter. Emperor Haile Selassie of Ethiopia was the main host. This is why Addis Ababa is still the headquarters of the AU today.",
      h: "Was it founded in 'Nigeria' or 'Ethiopia'?"
    },
    {
      yr: 2018,
      q: "Which of the following is on the 'Concurrent' list in Nigeria?",
      o: ["Defense", "Currency", "Education", "Mining"],
      a: 2,
      e: "Both the Federal and State governments can make laws regarding education.",
      full: "This is why we have 'Federal Universities' (UNILAG) and 'State Universities' (LASU). On the other hand, only the Federal government can handle 'Defense' (there is no 'Lagos State Army').",
      h: "Can 'Both' the State and Federal govt build schools, or only 'One' of them?"
    },
    {
      yr: 2018,
      q: "The 'Public Complaints Commission' (PCC) cannot investigate:",
      o: ["A corrupt clerk", "The Armed Forces and the Police", "A local council worker", "A teacher"],
      a: 1,
      e: "The PCC has no jurisdiction over the military or matters of national security.",
      full: "The Ombudsman is for 'Civilian' administrative errors. If you have a problem with a soldier or the police, there are separate 'Disciplinary Boards' (like the Police Service Commission) to handle that.",
      h: "Does the PCC handle 'Soldiers' or 'Civilian Workers'?"
    },
    {
      yr: 2018,
      q: "The 'Pre-colonial' Kanem-Borno empire was known for the 'Nkenkena,' which was the:",
      o: ["Emperor's crown", "Council of State/Advisers", "Royal army", "Market tax"],
      a: 1,
      e: "The Nkenkena consisted of 12 senior officials who advised the Mai.",
      full: "Just like the Oyo Mesi in Yorubaland, the Nkenkena ensured that the Mai did not become a tyrant. They were powerful chiefs who represented the different interests within the empire.",
      h: "Is the 'Nkenkena' a 'Hat' or a 'Council'?"
    },
    {
      yr: 2018,
      q: "The 'Separation of Powers' was famously advocated by:",
      o: ["A.V. Dicey", "Baron de Montesquieu", "Abraham Lincoln", "Karl Marx"],
      a: 1,
      e: "Montesquieu argued that the Executive, Legislative, and Judicial powers must be separate.",
      full: "In his book 'The Spirit of the Laws,' he said that if the same person makes and executes the law, there can be no 'Liberty.' This became the blueprint for the US and Nigerian constitutions.",
      h: "Who is the 'Father' of Separation of Powers?"
    },
    {
      yr: 2018,
      q: "The 'African Union' (AU) 'Peace and Security Council' (PSC) can:",
      o: ["Declare war on the UN", "Intervene in a member state during a crisis (e.g., genocide)", "Increase the price of oil", "Appoint kings"],
      a: 1,
      e: "The AU has the right to intervene to stop war crimes and crimes against humanity.",
      full: "Unlike the old OAU (which did nothing), the AU can send 'Peacekeeping Troops' (like AMISOM) to a country where people are being killed in a civil war. This is called the 'Right of Intervention.'",
      h: "Can the AU 'Send troops to help' or 'Just watch'?"
    },
    {
      yr: 2018,
      q: "A 'Bye-election' is an election held to:",
      o: ["Elect a new President", "Fill a vacancy caused by death or resignation of a legislator", "Change the constitution", "Vote for a Governor"],
      a: 1,
      e: "Bye-elections happen when a seat in the Senate or House of Reps becomes empty unexpectedly.",
      full: "If a Senator dies or becomes a Minister, his seat becomes empty. Instead of waiting for the 'General Election,' the Electoral Commission holds a 'Bye-election' only for that specific district to find a replacement.",
      h: "Is this a 'Full National Election' or just 'Filling an Empty Seat'?"
    },
    {
      yr: 2018,
      q: "The '1999 Constitution' of Nigeria is:",
      o: ["Unwritten", "Unitary", "Federal and Rigid", "Flexible"],
      a: 2,
      e: "It provides for a sharing of power and is difficult to amend.",
      full: "It is 'Federal' because it recognizes 36 states and one center. It is 'Rigid' because you cannot change it by a simple vote; it requires a long, complicated process involving most of the country.",
      h: "Is Nigeria 'One single level' (Unitary) or 'Multiple levels' (Federal)?"
    },
  {
    yr: 2024,
    q: 'A system of government in which power derives from total control of the instruments of force is called ___________',
    o: ['Monarchy', 'Oligarchy', 'Capitalism', 'Fascism'],
    a: 3,
    e: 'Fascism is characterised by a strong central government that maintains total control through force, suppression of opposition, and a cult of personality around the leader.',
    full: 'Fascism is a far-right authoritarian ideology in which the state exercises absolute power over society through control of the military, police, and propaganda. Unlike monarchy (hereditary rule) or oligarchy (rule by a few elites), fascism specifically derives its power from control of the instruments of force — the army, police, and paramilitary groups.\n\nExamples: Mussolini\'s Italy, Hitler\'s Nazi Germany.\n\nOther options:\n• Monarchy: rule by a king/queen, often hereditary\n• Oligarchy: rule by a small group based on wealth or class\n• Capitalism: an economic system, not a government type',
    h: 'Which government type controls through force and suppression?',
  },


  {
    yr: 2024,
    q: 'The aggregate view of individuals in a society is referred to as ___',
    o: ['Public outcry', 'People\'s voice', 'Popular opinion', 'Public opinion'],
    a: 3,
    e: 'Public opinion is the term used to describe the collective attitudes, beliefs, and views of individuals in a society on particular issues.',
    full: 'Public opinion refers to the aggregate (combined/collective) views held by a significant portion of a population on any given issue. It is distinct from individual opinion because it represents a broad summary of how people collectively think.\n\nPublic opinion is shaped by:\n• Media\n• Political parties\n• Education\n• Culture and socialization\n\n"Popular opinion" is informal; "public outcry" implies strong negative reaction; "people\'s voice" is vague. The correct formal term is public opinion.',
    h: 'What term describes the collective views of all individuals in society?',
  },
  {
    yr: 2024,
    q: 'Nigerian Ports Authority is an example of ___',
    o: ['Civil Service', 'Public Service', 'Public Corporation', 'Maritime Corporation'],
    a: 2,
    e: 'The Nigerian Ports Authority (NPA) is a public corporation — a government-owned enterprise set up to provide specific services to the public on a commercial basis.',
    full: 'A public corporation is a government-owned business enterprise established by an Act of Parliament to provide essential services or manage key industries. It operates commercially but is owned by the state.\n\nExamples in Nigeria: Nigerian Ports Authority (NPA), NEPA (now PHCN), Nigeria Railway Corporation, NIPOST.\n\n• Civil Service: government administrative bureaucracy (ministries, departments)\n• Public Service: broader term including civil servants and other government workers\n• Maritime Corporation: not a specific recognised category in Nigerian governance\n\nNPA was established by Decree No. 38 of 1993 to manage Nigerian ports.',
    h: 'What category of organisation is the Nigerian Ports Authority?',
  },
  {
    yr: 2024,
    q: 'The electoral process in a representative government does NOT include ___',
    o: ['Free and fair elections', 'Free press', 'Independent electoral commission', 'Registration of birth'],
    a: 3,
    e: 'Registration of birth is a civil registry function — it has nothing to do with the electoral process. The electoral process deals with how citizens choose representatives.',
    full: 'The electoral process in a representative democracy includes:\n• Voter registration (registering eligible voters)\n• Nomination of candidates\n• Campaigning\n• Voting (free and fair elections)\n• Vote counting and declaration of results\n• An independent electoral body to oversee the process\n• A free press to inform voters\n\nRegistration of birth is a completely separate administrative process managed by vital statistics or civil registry offices. It establishes legal identity but is not part of the electoral machinery.',
    h: 'Which of these is NOT part of the electoral process?',
  },
  {
    yr: 2024,
    q: 'Public corporations can be controlled by ___',
    o: ['Board of Directors', 'Judicial control', 'Ownership control', 'Management control'],
    a: 0,
    e: 'Public corporations are primarily controlled by a Board of Directors appointed to oversee their operations and strategic direction on behalf of the government/public.',
    full: 'Methods of controlling public corporations include:\n\n1. Board of Directors (most direct): Appointed by the government to oversee policy and major decisions — the primary governance body.\n2. Legislative control: Parliament scrutinises their activities through committees and budget approvals.\n3. Ministerial/Executive control: The supervising ministry issues directives.\n4. Judicial control: Courts can review actions of public corporations if they act ultra vires (beyond their legal powers).\n5. Public/Consumer pressure.\n\nThe Board of Directors is the most direct and primary instrument of control in day-to-day management. EduPadi\'s original answer listed B (Judicial) but then explained Board of Directors — the correct answer is A.',
    h: 'Who is primarily responsible for controlling a public corporation?',
  },
  {
    yr: 2024,
    q: 'ECOWAS was established in ___',
    o: ['1970', '1972', '1975', '1976'],
    a: 2,
    e: 'ECOWAS (Economic Community of West African States) was established on 28 May 1975 with the signing of the Treaty of Lagos.',
    full: 'ECOWAS was founded on 28 May 1975 through the Treaty of Lagos, signed by 15 West African nations. Its primary aim is to promote economic integration and cooperation among member states.\n\nKey facts:\n• Founded: 28 May 1975\n• Headquarters: Abuja, Nigeria\n• Founding members: 15 West African nations\n• Key achievements: ECOMOG (peacekeeping), ECOWAS passport, free movement protocols\n• Nigeria was a key driving force behind ECOWAS formation under General Yakubu Gowon.',
    h: 'In what year was ECOWAS founded?',
  },
  {
    yr: 2024,
    q: 'Lack of separation of power is a feature of ___',
    o: ['Presidential system', 'Cabinet system', 'Democratic government', 'Military government'],
    a: 3,
    e: 'Military government concentrates all powers (executive, legislative, judicial) in the hands of the military authority — there is no separation of powers.',
    full: 'Separation of powers means distributing state authority among three branches:\n• Legislature (makes laws)\n• Executive (implements laws)\n• Judiciary (interprets laws)\n\nMilitary government fuses all these powers:\n• The Supreme Military Council/Armed Forces Ruling Council both makes laws (decrees) AND implements them\n• The military often suspends the judiciary or interferes with it\n• There is no elected legislature\n\nPresidential system: strong separation of powers\nCabinet/Parliamentary system: fusion of executive and legislature, but still has independence of judiciary\nDemocracy: requires separation of powers\nMilitary: no separation — all power concentrated in one body',
    h: 'Which system of government lacks separation of powers?',
  },
  {
    yr: 2024,
    q: 'The right to vote and be voted for is ___',
    o: ['Fundamental human right', 'Freedom of expression', 'Franchise', 'Electoral right'],
    a: 2,
    e: 'Franchise is the specific term for the right to vote and be voted for (stand for election). It encompasses both active suffrage (voting) and passive suffrage (being a candidate).',
    full: 'Franchise (also called suffrage) is the right to vote in public elections and the right to be voted for (stand as a candidate).\n\nTypes of franchise:\n• Universal franchise: all adult citizens can vote regardless of sex, race, religion, property\n• Limited franchise: only certain groups can vote (e.g., property-owning men historically)\n• Active suffrage: the right to vote\n• Passive suffrage: the right to stand for election\n\nWhile voting is a fundamental right, the specific term for this right is franchise. "Electoral right" is informal; "franchise" is the precise political science term used in JAMB.',
    h: 'What is the specific term for the right to vote and stand for election?',
  },
  {
    yr: 2024,
    q: 'Pressure groups are different from political parties because they ___',
    o: ['Analyse elections', 'Articulate interests', 'Aggregate interests', 'Contest elections'],
    a: 1,
    e: 'Pressure groups articulate (express/voice) the specific interests of their members. Political parties aggregate (bring together) diverse interests and contest elections to form government.',
    full: 'Key distinction:\n\n• Pressure groups: Articulate interests — they identify, express, and advocate for specific interests of a particular group (e.g., NLC for workers, NBA for lawyers). They do NOT contest elections or seek to form government.\n\n• Political parties: Aggregate interests — they bring together diverse groups and interests under a broad platform, contest elections, and seek to form government.\n\nMemory tip:\n• Pressure group = Articulate (voice one specific interest)\n• Political party = Aggregate (combine many interests) + Contest elections',
    h: 'What do pressure groups do that distinguishes them from political parties — articulate or aggregate?',
  },
  {
    yr: 2024,
    q: 'Recruitment and promotion of civil servants in Nigeria remain the responsibility of ___',
    o: ['Federal Character Commission', 'Civil Service Commission', 'National Universities Commission', 'Federal Judicial Commission'],
    a: 1,
    e: 'The Civil Service Commission is the constitutional body responsible for recruitment, promotion, and discipline of civil servants in Nigeria.',
    full: 'The Civil Service Commission (CSC) in Nigeria is established under the Constitution and is responsible for:\n• Recruitment of civil servants\n• Promotion of civil servants\n• Discipline (including dismissal) of civil servants\n\nOther commissions:\n• Federal Character Commission: Ensures equitable distribution of government positions across states and ethnicities\n• National Universities Commission (NUC): Regulates universities\n• Federal Judicial Council: Advises on appointment of judges\n\nThe CSC is separate from the Federal Character Commission, which ensures that recruitment reflects Nigeria\'s diversity — but the actual process of recruitment is the CSC\'s responsibility.',
    h: 'Which commission handles recruitment and promotion of civil servants in Nigeria?',
  },
  {
    yr: 2024,
    q: 'The organs of ECOWAS do NOT include the ___',
    o: ['Community Tribunal', 'Council of Ministers', 'Secretariat', 'Conference'],
    a: 2,
    e: 'All listed options are actually organs of ECOWAS. The Secretariat was replaced by the Commission in 2007 — so "Secretariat" as a current organ is outdated/no longer used. The odd one out in JAMB\'s context is the Secretariat.',
    full: 'Organs of ECOWAS (post-2007 restructuring):\n1. Authority of Heads of State and Government (the supreme body — sometimes called "the Conference")\n2. Council of Ministers\n3. Community Parliament\n4. Community Court of Justice (Community Tribunal)\n5. ECOWAS Commission (replaced the old Secretariat in 2007)\n6. Fund for Co-operation, Compensation and Development\n\nNote: The original "Secretariat" was renamed the "ECOWAS Commission" in 2007. JAMB treats "Secretariat" as the odd one out because it is no longer the correct name for that organ.\n\n⚠️ EduPadi\'s explanation was contradictory — the verified JAMB answer is C (Secretariat) as it is no longer a current organ.',
    h: 'Which is NOT a current organ of ECOWAS — the old Secretariat was replaced by what?',
  },
  {
    yr: 2024,
    q: 'The bipolar world was a major factor for the formation of ___',
    o: ['Non-aligned movement', 'Technical aid corps', 'NEPAD', 'ECOMOG'],
    a: 0,
    e: 'The bipolar world — divided between the US-led West and the Soviet-led East during the Cold War — motivated developing nations to form the Non-Aligned Movement (NAM) to avoid alignment with either bloc.',
    full: 'The bipolar world refers to the division of global power into two opposing blocs during the Cold War (1947–1991):\n• Western bloc: led by the USA\n• Eastern bloc: led by the USSR\n\nCountries that did not want to be drawn into this superpower rivalry — especially newly independent African and Asian nations — formed the Non-Aligned Movement (NAM) in 1961 at the Belgrade Conference.\n\nKey founders: Josip Broz Tito (Yugoslavia), Jawaharlal Nehru (India), Gamal Abdel Nasser (Egypt), Kwame Nkrumah (Ghana), Sukarno (Indonesia).\n\nNigeria was an active member of NAM as part of its non-alignment foreign policy.',
    h: 'What Cold War dynamic led to the creation of the Non-Aligned Movement?',
  },
  {
    yr: 2024,
    q: 'Absence of red-tape is a merit of ___',
    o: ['Federal government structure', 'Unitary structure', 'Confederal structure', 'Republican structure'],
    a: 1,
    e: 'A unitary system has centralised power with fewer layers of bureaucracy — less red-tape compared to federal or confederal systems where multiple levels of government create more administrative complexity.',
    full: 'Red-tape refers to excessive bureaucratic rules, regulations, and procedures that slow down government action.\n\n• Unitary system: Power is concentrated in one central government. Fewer layers = less red-tape. Decisions are made faster and more uniformly.\n• Federal system: Power is shared between central and state governments — multiple layers create more bureaucracy (red-tape).\n• Confederal system: Even more fragmented — member states retain most power, making coordination very difficult.\n\nMerit of unitary system: absence of red-tape, uniformity, faster decision-making.\nDemerit: risks of over-centralisation, lack of local representation.',
    h: 'Which government structure has less bureaucratic red-tape due to centralised power?',
  },
  {
    yr: 2024,
    q: 'The most effective instrument adopted by Nigeria against the East-West Cold War in the 1960s was ___',
    o: ['Good neighbourliness', 'Africa as the centrepiece', 'Anti-apartheid stance', 'Non-alignment policy'],
    a: 3,
    e: 'Nigeria adopted a non-alignment policy — refusing to side with either the US-led West or the Soviet-led East — allowing it to maintain sovereignty and interact freely with both blocs.',
    full: 'Nigeria\'s foreign policy in the 1960s was shaped by its desire for independence from superpower influence. The non-alignment policy allowed Nigeria to:\n• Maintain political sovereignty\n• Receive aid and assistance from both Western and Eastern blocs\n• Participate in the Non-Aligned Movement (NAM)\n• Speak freely on international issues without Cold War constraints\n\nOther pillars of Nigeria\'s foreign policy:\n• Africa as the centrepiece (prioritising African affairs)\n• Anti-apartheid stance (opposition to South Africa\'s apartheid)\n• Good neighbourliness (peaceful relations with neighbours)\n\nBut the most directly relevant to the East-West Cold War was non-alignment.',
    h: 'How did Nigeria stay neutral during the Cold War?',
  },
  {
    yr: 2024,
    q: 'The productivity of public corporations is believed to be enhanced when there is ___',
    o: ['Increase in employment rate', 'Redeployment of staff', 'Increase in working hours', 'Less political interference'],
    a: 3,
    e: 'Political interference in public corporations leads to mismanagement, corruption, and poor decision-making. Reducing it allows professional management to operate efficiently.',
    full: 'Public corporations often underperform in many countries because politicians appoint loyalists rather than competent managers, use the corporations for political patronage, or interfere in commercial decisions for political gain.\n\nFactors that enhance productivity of public corporations:\n• Less political interference ✓ (primary factor)\n• Professionalisation of management\n• Performance-based contracts\n• Autonomy in decision-making\n• Adequate funding\n• Accountability mechanisms\n\nIn Nigeria, bodies like NNPC, PHCN, and others have historically suffered from heavy political interference, making this a very relevant JAMB question.',
    h: 'What single factor most enhances public corporation productivity?',
  },
  {
    yr: 2024,
    q: 'A form of government where the powers of the state are determined by the citizens is ___',
    o: ['Monarchy', 'Aristocracy', 'Autocracy', 'Democracy'],
    a: 3,
    e: 'Democracy is the system of government in which power ultimately rests with the citizens, either directly or through elected representatives.',
    full: 'Democracy comes from the Greek: demos (people) + kratos (power/rule) = "rule by the people."\n\nIn a democracy:\n• Citizens determine who governs through free elections\n• Citizens can remove leaders through elections\n• Power is limited by constitutions and rule of law\n\nOther forms:\n• Monarchy: power held by a king/queen (hereditary)\n• Aristocracy: power held by a privileged elite/noble class\n• Autocracy: absolute power held by one person with no accountability\n\nThe key phrase "powers of the state determined by citizens" is the definition of democracy.',
    h: 'In which government system do citizens determine the powers of the state?',
  },
  {
    yr: 2024,
    q: 'The rationale behind the adoption of a federal system of government in Nigeria is to ___',
    o: ['Promote the autonomy of states', 'Establish a powerful central government', 'Create more states', 'Promote unity in diversity'],
    a: 3,
    e: 'Nigeria adopted federalism primarily to manage its ethnic, religious, and regional diversity — enabling different groups to coexist under one nation while each retaining some autonomy.',
    full: 'Nigeria has over 250 ethnic groups, three major religions, and significant regional differences between North, South-West, and South-East. A unitary system would give one group dominance over others.\n\nFederalism allows:\n• Unity: one Nigerian nation with shared federal laws and institutions\n• Diversity: states have autonomy over local matters\n• Representation: each group/region has political representation\n• Prevention of secession: by giving regions a stake in the system\n\nThe phrase "unity in diversity" captures this perfectly — federalism allows Nigeria to be one country while accommodating its extraordinary diversity.\n\nNigeria has operated as a federation since the Lyttleton Constitution of 1954.',
    h: 'What is the main reason Nigeria chose a federal system of government?',
  },
  {
    yr: 2024,
    q: 'An agent in which the state undertakes direct political socialisation is the ___',
    o: ['Church', 'School', 'Peer groups', 'Mass media'],
    a: 1,
    e: 'Schools are state-controlled institutions where the government directly shapes political values, civic knowledge, and national identity through the curriculum — making them agents of direct state political socialisation.',
    full: 'Political socialisation is the process by which people acquire political values, beliefs, and knowledge.\n\nAgents of political socialisation:\n• Family: primary and earliest agent\n• School (State-directed): the state controls the curriculum, making schools the most direct state instrument for political socialisation — teaching civic education, history, national identity\n• Mass media: influential but not fully state-controlled in democracies\n• Peer groups: informal and not state-controlled\n• Church: independent of state (in secular states)\n\nThe key word in the question is "direct" — the state DIRECTLY controls school curricula, so schools are the agent of DIRECT state political socialisation.',
    h: 'Through which institution does the state DIRECTLY socialise citizens politically?',
  },
  {
    yr: 2024,
    q: 'The famous Italian Fascist leader was ___',
    o: ['Mao Tse Tung', 'Kim Jung Un', 'Joseph Stalin', 'Benito Mussolini'],
    a: 3,
    e: 'Benito Mussolini (1883–1945) was the founder of Italian Fascism and ruled Italy as a dictator from 1922 to 1943 under the title Il Duce (The Leader).',
    full: 'Benito Mussolini founded the National Fascist Party in Italy and became Prime Minister in 1922. He established a totalitarian dictatorship, allied with Hitler\'s Nazi Germany, and ruled until 1943.\n\nOther leaders and their systems:\n• Mao Tse Tung: Communist leader of China (People\'s Republic of China, 1949)\n• Kim Jong Un: Current leader of North Korea (communist dictatorship)\n• Joseph Stalin: Communist leader of the Soviet Union\n\nFascism ≠ Communism. Mussolini\'s Italy is the textbook example of fascism — ultranationalist, militaristic, anti-communist.',
    h: 'Who was the founding fascist dictator of Italy?',
  },
  {
    yr: 2024,
    q: 'Strike action is mostly used by ___',
    o: ['Political parties', 'Traders', 'Parliamentarians', 'Pressure groups'],
    a: 3,
    e: 'Strike action is a primary tool of pressure groups — especially labour unions — used to withdraw services and force government or employers to meet their demands.',
    full: 'Pressure groups use various methods to influence government policy:\n• Lobbying (direct negotiation with officials)\n• Public demonstrations and protests\n• Petitions\n• Strike action (withdrawal of services/labour)\n• Litigation (legal challenges)\n• Media campaigns\n\nStrike action is particularly associated with:\n• Labour/trade unions (e.g., NLC in Nigeria — Nigeria Labour Congress)\n• Professional associations (e.g., NMA — Nigerian Medical Association)\n• Staff unions (e.g., ASUU — Academic Staff Union of Universities)\n\nPolitical parties contest elections; traders use boycotts; parliamentarians use legislative tools. Pressure groups — specifically labour-type pressure groups — are most associated with strikes.',
    h: 'Which group most commonly uses strikes as a tool to achieve its goals?',
  },
  {
    yr: 2024,
    q: 'A major instrument designed to promote the workings of Nigerian federalism is ___',
    o: ['Federal Character Commission', 'National Judicial Council', 'National Assembly Commission', 'National Defence Council'],
    a: 0,
    e: 'The Federal Character Commission ensures equitable representation of Nigeria\'s diverse ethnic groups and states in federal government positions — a core mechanism for making federalism work in Nigeria.',
    full: 'The Federal Character Commission (FCC) was established by the 1979 Constitution and given constitutional backing in the 1999 Constitution (Section 14(3)).\n\nIts functions:\n• Ensure equitable distribution of positions in federal institutions across states and ethnic groups\n• Prevent dominance of any one group in federal appointments\n• Monitor compliance with federal character principle by all federal agencies\n\nThis directly promotes Nigerian federalism by ensuring that the federal system benefits all states and groups equally — preventing domination by any particular region or ethnicity.\n\nWithout the FCC, federalism in Nigeria would risk becoming dominated by the most populous or politically powerful groups.',
    h: 'Which body ensures equitable representation in Nigeria\'s federal institutions?',
  },
  {
    yr: 2024,
    q: 'The political subjugation and economic exploitation of a people is known as ___',
    o: ['Colonialism', 'Neo-colonialism', 'Apartheid', 'Indirect rule'],
    a: 0,
    e: 'Colonialism is the practice of acquiring political control over another territory and exploiting it economically — exactly matching "political subjugation and economic exploitation."',
    full: 'Colonialism: One country (colonial power) takes over another territory (colony), exercises political control, and exploits its resources economically.\n\nExamples: British colonisation of Nigeria, French colonisation of Senegal.\n\nDistinctions:\n• Neo-colonialism: Indirect economic/political control after formal independence (e.g., through debt, trade agreements, multinational corporations)\n• Apartheid: System of racial segregation in South Africa — not full colonialism\n• Indirect rule: A method of colonial administration (using existing chiefs/rulers) — not the definition itself\n\nThe phrase "political subjugation AND economic exploitation" is the textbook definition of colonialism.',
    h: 'What term describes political control and economic exploitation of one people by another?',
  },
  {
    yr: 2024,
    q: 'Before a treaty can be binding on a country, it has to be approved by the ___',
    o: ['Executive', 'Legislature', 'Judiciary', 'Military'],
    a: 1,
    e: 'A treaty becomes binding on a country only after the legislature ratifies (approves) it. The executive negotiates and signs treaties, but the legislature must ratify them.',
    full: 'Treaty-making process:\n1. Negotiation: The executive (President/Foreign Affairs Ministry) negotiates the treaty\n2. Signing: Executive signs the treaty on behalf of the state\n3. Ratification: The legislature (Parliament/National Assembly) must approve the treaty before it becomes legally binding on the country\n4. Implementation: Executive implements the ratified treaty\n\nIn Nigeria:\n• The President negotiates and signs treaties\n• The National Assembly must ratify before it becomes binding\n• This is a check on executive power in international relations\n\nWithout legislative ratification, a treaty is merely an intention — it has no legal binding force on the country.',
    h: 'Who must approve a treaty before it becomes legally binding on a country?',
  },
  {
    yr: 2024,
    q: 'Delegated legislation can be regulated through ___',
    o: ['Ministerial control', 'Legislative control', 'Executive control', 'Judicial control'],
    a: 1,
    e: 'Delegated legislation is primarily regulated by the legislature through scrutiny committees, parliamentary debate, and the requirement to "lay" such legislation before Parliament.',
    full: 'Delegated legislation (also called subsidiary/subordinate legislation) is law made by bodies other than Parliament under authority granted by a Parent Act — e.g., ministers making regulations, local councils making bye-laws.\n\nMethods of legislative control over delegated legislation:\n1. Scrutiny committees: Parliamentary committees that examine statutory instruments\n2. Laying procedure: Legislation must be "laid before Parliament" — either affirmative (requires approval) or negative (can be annulled)\n3. Sunset clauses: Automatic expiry dates requiring renewal\n4. Parliamentary debate: Can be debated and revoked\n5. Ultra vires doctrine (judicial): Courts can invalidate if beyond parent act scope\n\nLegislative control is the PRIMARY method. Judicial control (courts) is secondary.',
    h: 'What is the primary method of controlling delegated legislation?',
  },
  {
    yr: 2024,
    q: 'An economic system that encourages state ownership and control of the means of production is ___',
    o: ['Socialism', 'Communism', 'Fascism', 'Capitalism'],
    a: 0,
    e: 'Socialism advocates for state or collective ownership of the means of production (factories, land, resources) to ensure equitable distribution of wealth.',
    full: 'Economic systems comparison:\n\n• Socialism: State/collective ownership of means of production; wealth distributed more equitably; the state plays a major economic role. Examples: Nordic countries (mixed), historical USSR.\n\n• Communism: A more extreme form — classless, stateless society where all means of production are communally owned. In practice, the Communist Party controls everything. Examples: China (CCP), Cuba.\n\n• Capitalism: Private ownership of means of production; free market; profit-driven. Examples: USA, UK.\n\n• Fascism: Private ownership is permitted but state controls it for nationalist goals.\n\nThe question asks specifically about "state ownership and control" — this is socialism.',
    h: 'Which economic system features state ownership and control of production?',
  },
  {
    yr: 2024,
    q: 'Which local government reform in Nigeria prevented traditional rulers from engaging in politics?',
    o: ['The 1960 Reform', 'The 1963 Reform', 'The 1976 Reform', 'The 1979 Reform'],
    a: 2,
    e: 'The 1976 Local Government Reform under General Murtala Muhammed (continued by Obasanjo) redefined the roles of traditional rulers and barred them from direct participation in partisan politics.',
    full: 'The 1976 Local Government Reform was a landmark reform in Nigeria\'s history:\n\nKey features:\n• Established uniform local government system nationwide\n• Created elected local government councils\n• Defined the role of traditional rulers as advisory/ceremonial\n• Excluded traditional rulers from partisan political activities\n• Recognised local government as the third tier of government\n• Established fixed boundaries for local government areas\n\nBefore 1976, traditional rulers (emirs, obas, chiefs) had been directly involved in local governance and politics under the Native Authority system inherited from colonial rule. The 1976 reform separated traditional authority from modern political governance.',
    h: 'Which year\'s reform removed traditional rulers from partisan politics in Nigeria?',
  },
  {
    yr: 2024,
    q: 'The party that controlled the government of South West States after the 1979 General Elections was ___',
    o: ['NPN', 'GNPP', 'NAP', 'UPN'],
    a: 3,
    e: 'The Unity Party of Nigeria (UPN), led by Chief Obafemi Awolowo, dominated the South West states in the 1979 elections, winning all five South Western states.',
    full: '1979 General Elections — results by region:\n\n• UPN (Unity Party of Nigeria) — Chief Obafemi Awolowo: Won all 5 South Western states (Lagos, Ogun, Oyo, Ondo, Bendel)\n• NPN (National Party of Nigeria) — Shehu Shagari: Won the presidency and dominated the North\n• NPP (Nigerian People\'s Party) — Nnamdi Azikiwe: Won South Eastern states\n• GNPP — Waziri Ibrahim: Won North-Eastern states\n• PRP — Aminu Kano: Won Kano and Kaduna states\n\nThe UPN was a predominantly Yoruba party that swept the South West due to Awolowo\'s massive popularity in the region.',
    h: 'Which party won the South West states in Nigeria\'s 1979 elections?',
  },
  {
    yr: 2024,
    q: 'The Commission that examines complaints of civil wrongs committed by government employees is ___',
    o: ['Public Complaints Commission', 'Civil Service Commission', 'Economic and Financial Crimes Commission', 'Judicial Service Commission'],
    a: 0,
    e: 'The Public Complaints Commission (Ombudsman) investigates complaints by citizens against government agencies and employees regarding abuse of power, maladministration, or civil wrongs.',
    full: 'The Public Complaints Commission (PCC), established in 1975, is Nigeria\'s Ombudsman — an independent body that investigates:\n• Complaints against government ministries, departments, and agencies\n• Complaints against government officials and employees\n• Cases of administrative injustice or abuse of power\n\nDistinctions:\n• Civil Service Commission: Handles recruitment, promotion, and discipline of civil servants\n• EFCC: Investigates economic and financial crimes (corruption, fraud)\n• Judicial Service Commission: Advises on appointment/discipline of judges\n\nThe PCC is specifically for "civil wrongs by government employees" — the Ombudsman function.',
    h: 'Which body acts as an Ombudsman investigating civil complaints against government workers?',
  },
  {
    yr: 2024,
    q: 'The principle of civil service that guarantees the employment of public workers is ___',
    o: ['Neutralism', 'Anonymity', 'Permanence', 'Loyalty'],
    a: 2,
    e: 'Permanence (security of tenure) ensures that civil servants cannot be arbitrarily dismissed — they retain their jobs regardless of which political party is in power.',
    full: 'Principles of the Civil Service:\n\n1. Permanence (Security of Tenure): Civil servants keep their jobs when governments change. This ensures continuity of government business and protects against political victimisation.\n\n2. Neutrality/Impartiality: Civil servants serve any government in power without partisan bias.\n\n3. Anonymity: Civil servants advise ministers but decisions are attributed to ministers, not to civil servants. They work behind the scenes.\n\n4. Loyalty: Civil servants are loyal to the government of the day.\n\n5. Meritocracy: Appointments and promotions based on merit, not political affiliation.\n\nThe question asks about the principle that "guarantees employment" — this is permanence/security of tenure.',
    h: 'Which civil service principle protects workers from losing their jobs when government changes?',
  },
  {
    yr: 2024,
    q: 'The Nigerian Civil War was fought during the military regime of ___',
    o: ['Aguiyi Ironsi', 'Yakubu Gowon', 'Murtala Muhammed', 'Olusegun Obasanjo'],
    a: 1,
    e: 'The Nigerian Civil War (Biafran War) was fought from July 1967 to January 1970 during the military regime of General Yakubu Gowon.',
    full: 'Timeline of events:\n• January 1966: First coup — General Aguiyi Ironsi takes power\n• July 1966: Counter-coup — General Yakubu Gowon takes power\n• May 1967: Eastern Region declares independence as "Republic of Biafra"\n• July 1967: Nigerian Civil War begins\n• January 1970: Biafra surrenders — war ends ("No victor, no vanquished")\n\nThe war was fought under Gowon\'s administration. He famously declared the war over with the phrase "No victor, no vanquished," and pursued a policy of reconciliation and reconstruction (3Rs).\n\nMurtala Mohammed: 1975–1976\nOlusegun Obasanjo: 1976–1979 (first time as military ruler)',
    h: 'Which military ruler was in power during the Nigerian Civil War (1967–1970)?',
  },
  {
    yr: 2024,
    q: 'The rule of law is an essential ingredient of ___',
    o: ['Democracy', 'Aristocracy', 'Monarchy', 'Autocracy'],
    a: 0,
    e: 'The rule of law — that everyone, including rulers, is subject to the law — is a fundamental pillar of democracy. It ensures equality before the law, fairness, and protection of rights.',
    full: 'The rule of law, as articulated by A.V. Dicey, has three elements:\n1. Supremacy of law: No one is above the law, including the government\n2. Equality before the law: All persons are equal in the eyes of the law\n3. Predominance of legal spirit: Rights come from the courts, not from abstract constitutional declarations\n\nDemocracy requires rule of law because:\n• It prevents arbitrary use of power\n• It protects citizens\' rights\n• It ensures accountability of government\n\nIn aristocracy, monarchy, and autocracy, rulers are often above the law — the rule of law is weak or absent.',
    h: 'The rule of law is a defining feature of which system of government?',
  },
  {
    yr: 2024,
    q: 'The judgement that ceded and transferred Bakassi legal title from Nigeria to Cameroon was delivered by ___',
    o: ['ECOWAS Court of Justice', 'Court of Justice of the African Union', 'International Criminal Court', 'International Court of Justice'],
    a: 3,
    e: 'The International Court of Justice (ICJ) — the principal judicial organ of the United Nations — delivered the landmark 2002 judgement awarding the Bakassi Peninsula to Cameroon.',
    full: 'The Bakassi Peninsula dispute:\n• Bakassi is an oil-rich peninsula in the Gulf of Guinea\n• Nigeria and Cameroon both claimed it based on different treaties\n• Nigeria based its claim on the 1906 Anglo-German Agreement\n• Cameroon based its claim on the 1975 Maroua Declaration\n\nICJ Judgement (October 2002):\n• The ICJ ruled in favour of Cameroon\n• Nigeria was ordered to transfer sovereignty of Bakassi to Cameroon\n• Transfer was completed in 2008 under President Yar\'Adua\n\nThe ICJ is the world\'s highest court for disputes between nations. The ICC (International Criminal Court) handles war crimes and crimes against humanity — completely different jurisdiction.',
    h: 'Which international court awarded Bakassi Peninsula to Cameroon in 2002?',
  },
  {
    yr: 2024,
    q: 'One of the functions of a political party is ___',
    o: ['Promotion of interest', 'Organisation of election', 'Political education', 'Announcement of election results'],
    a: 2,
    e: 'Political education — informing and educating citizens about political issues, rights, and the electoral process — is a core function of political parties.',
    full: 'Functions of political parties:\n1. Political education: Educate citizens on issues, policies, and their rights\n2. Aggregation of interests: Bring together diverse interests into a platform\n3. Recruitment of leaders: Identify and present candidates for office\n4. Formation of government: Win elections and govern\n5. Providing opposition: Hold the ruling party accountable\n6. Socialisation: Shape political values and culture\n\nWhat political parties do NOT do:\n• Organise elections (that\'s INEC/Electoral Commission)\n• Announce election results (that\'s INEC)\n• Promote one specific group\'s interest (that\'s pressure groups — though parties articulate broad interests)\n\n"Political education" is the best answer among the options as a distinct party function.',
    h: 'Which function is specifically performed by political parties — not the electoral body?',
  },
  {
    yr: 2024,
    q: 'The Aburi Accord was a popular phrase during the administration of ___',
    o: ['Aguiyi Ironsi', 'Murtala Muhammed', 'Yakubu Gowon', 'Olusegun Obasanjo'],
    a: 2,
    e: 'The Aburi Accord was reached in January 1967 at Aburi, Ghana, between the federal government and Eastern Region representatives — during Yakubu Gowon\'s military administration.',
    full: 'The Aburi Accord (January 1967):\n• Venue: Aburi, Ghana (invited by Ghana\'s Ankrah government)\n• Parties: Federal Military Government (Gowon) and Eastern Region (Ojukwu)\n• Purpose: To resolve the political crisis following the 1966 coups and prevent civil war\n• Key provisions: The Eastern Region wanted a confederal arrangement with maximum autonomy; the federal government agreed to some decentralisation at Aburi\n\nAftermath:\n• When Gowon returned to Nigeria, advisers convinced him not to implement the Aburi agreements fully\n• This breakdown contributed directly to Ojukwu declaring Biafra independent in May 1967\n• The Civil War followed in July 1967\n\nThe famous Ojukwu phrase: "On Aburi we stand" — meaning he would only accept the Aburi terms.',
    h: 'During whose administration was the Aburi Accord negotiated in 1967?',
  },
  {
    yr: 2024,
    q: 'The collective views of the citizens on a specific national matter is ___',
    o: ['Group opinions', 'Electoral opinion', 'Public opinion', 'Collective responsibility'],
    a: 2,
    e: 'Public opinion is the term for the aggregate/collective views of citizens on a specific national or social issue.',
    full: 'Public opinion: The sum of individual views, attitudes, or beliefs held by a significant number of people on matters of public concern.\n\nDistinctions:\n• Group opinions: Views of a specific, limited group (not the general public)\n• Electoral opinion: Opinions specifically about elections/candidates\n• Collective responsibility: A constitutional principle where cabinet members collectively support government decisions\n• Public opinion: The broad, aggregate view of the general citizenry on a national matter\n\nPublic opinion is important in democracy because governments are expected to be responsive to it.',
    h: 'What term describes citizens\' collective views on a national issue?',
  },
  {
    yr: 2024,
    q: 'The Nigerian Youth Movement pursued its objectives through the use of ___',
    o: ['Protest', 'Newspapers', 'Radio', 'Strike actions'],
    a: 1,
    e: 'The Nigerian Youth Movement (NYM) primarily used newspapers to spread its nationalist message and mobilise public support against colonial rule.',
    full: 'The Nigerian Youth Movement (NYM) was founded in 1934 (as Lagos Youth Movement, renamed 1936). It was Nigeria\'s first genuinely nationalist organisation.\n\nThe NYM used newspapers as their primary tool because:\n• Radio was controlled by colonial authorities\n• Newspapers (like the Daily Service) allowed them to reach educated Nigerians\n• Print media could circulate widely across regions\n• It was a safe form of political expression\n\nKey NYM leaders: Samuel Akinsanya, Ernest Ikoli, Nnamdi Azikiwe (briefly), H.O. Davies.\n\nThe NYM\'s Daily Service newspaper was a major organ for nationalist ideas. They also published manifestos and political essays through the press.',
    h: 'What medium did the Nigerian Youth Movement primarily use to advance its nationalist goals?',
  },
  {
    yr: 2024,
    q: 'NEPAD stands for ___',
    o: [
      'New Economic Programmes for African Development',
      'New Partnership for Afro-Asian Development',
      'New Economic Partnerships for African Development',
      'New Partnerships for Africa\'s Development',
    ],
    a: 3,
    e: 'NEPAD stands for New Partnership for Africa\'s Development — an African Union development programme launched in 2001.',
    full: 'NEPAD (New Partnership for Africa\'s Development):\n• Launched: 2001\n• Adopted by the African Union (AU) as a programme\n• Founders: South Africa (Thabo Mbeki), Nigeria (Olusegun Obasanjo), Senegal (Abdoulaye Wade), Algeria (Abdelaziz Bouteflika), Egypt (Hosni Mubarak)\n• Goal: Eradicate poverty, promote sustainable growth and development, integrate Africa into the world economy\n• In 2010, NEPAD was transformed into the NEPAD Agency within the AU framework\n\nMemory tip: "New PARTNERSHIPS for AFRICA\'s Development" — apostrophe in "Africa\'s" is key, and "Partnerships" not "Economic Partnerships."',
    h: 'What does NEPAD stand for?',
  },
  {
    yr: 2024,
    q: 'Military intervention in Nigerian politics was first witnessed in ___',
    o: ['1965', '1966', '1964', '1967'],
    a: 1,
    e: 'The first military intervention in Nigerian politics was the coup of January 15, 1966, which ended the First Republic and brought General J.T.U. Aguiyi Ironsi to power.',
    full: 'January 15, 1966 — Nigeria\'s first coup d\'état:\n• Staged by a group of mostly Igbo junior officers led by Major Chukwuma Kaduna Nzeogwu\n• Prime Minister Abubakar Tafawa Balewa was killed\n• Several regional premiers were also killed\n• General Aguiyi Ironsi (senior army officer) did not participate in the coup but took power as Head of State to restore order\n\nConsequences:\n• This ended Nigeria\'s First Republic (1963–1966)\n• Led to a counter-coup in July 1966 (Gowon takes power)\n• Set a precedent for military interference in Nigerian politics\n• Nigeria experienced multiple coups until the return to democracy in 1999',
    h: 'In what year did the military first intervene in Nigerian politics?',
  },
  {
    yr: 2024,
    q: 'One of these is NOT an organ of the Commonwealth of Nations ___',
    o: [
      'Assembly of Heads of State and Government',
      'Commonwealth Secretariat',
      'Conference of Prime Ministers',
      'Fund for Technical Cooperation',
    ],
    a: 2,
    e: 'The "Conference of Prime Ministers" is not a formal organ of the Commonwealth. The correct body is the Commonwealth Heads of Government Meeting (CHOGM) — not all members are led by Prime Ministers.',
    full: 'Organs of the Commonwealth of Nations:\n1. Commonwealth Heads of Government Meeting (CHOGM): The supreme body — meets every two years\n2. Commonwealth Secretariat: Administrative body — based in London\n3. Commonwealth Foundation: Supports civil society\n4. Commonwealth Fund for Technical Cooperation: Provides technical assistance to members\n\n"Conference of Prime Ministers" is an outdated/inaccurate description because:\n• Not all Commonwealth members have Prime Ministers (some have Presidents)\n• The correct term is "Commonwealth Heads of Government Meeting" (CHOGM)\n• The "Assembly of Heads of State and Government" listed in option A is also not a standard organ name\n\nThe question\'s verified JAMB answer: C (Conference of Prime Ministers) — not a current, formal organ.',
    h: 'Which listed body is NOT a formal organ of the Commonwealth of Nations?',
  },
  {
    yr: 2024,
    q: 'The commander of the army under the Hausa/Fulani pre-colonial administration was ___',
    o: ['Waziri', 'Madawaki', 'Galadima', 'Maaji'],
    a: 1,
    e: 'The Madawaki was the military commander (commander of cavalry/army) in the Hausa/Fulani pre-colonial emirate system.',
    full: 'Key titles in the Hausa/Fulani pre-colonial emirate administration:\n\n• Emir/Sultan: The supreme ruler\n• Waziri: The Prime Minister/Chief Adviser — most senior official after the Emir\n• Madawaki: Commander of the army/cavalry — military chief\n• Galadima: Governor of the western districts; also sometimes in charge of the palace\n• Alkali: Chief Judge (Islamic law)\n• Maaji: Treasurer/Finance minister\n• Sarkin Pawa: Head of butchers (shows specialisation of roles)\n\nThe Madawaki\'s role was specifically military — he commanded the emirate\'s armed forces and cavalry. This distinction from the Waziri (civilian administration) is what JAMB tests.',
    h: 'Which title in Hausa/Fulani pre-colonial rule denoted the army commander?',
  },

  // ── 2023 ──────────────────────────────────────────────────────────────────
  {
    yr: 2023,
    q: 'Which of the following is NOT a source of public opinion?',
    o: ['Social media', 'Academic Journals', 'Opinion polls', 'Political parties'],
    a: 1,
    e: 'Academic journals are scholarly research publications — they are not a direct channel through which public opinion is formed or expressed. Public opinion flows through mass media, polls, and political participation.',
    full: 'Sources of public opinion:\n• Social media ✓ — citizens express views directly on Twitter, Facebook, etc.\n• Opinion polls ✓ — surveys that measure public attitudes\n• Political parties ✓ — shape and express public views through campaigns and manifestos\n• Mass media (newspapers, TV, radio) ✓\n• Interest groups and pressure groups ✓\n• Referendums ✓\n\nAcademic journals ✗ — these are peer-reviewed research publications read by scholars. They report findings and analysis but do not directly form or reflect public opinion. The general public rarely reads academic journals.\n\nAnswer: B — Academic Journals',
    h: 'Which is NOT a source of public opinion — polls, social media, academic journals, or parties?',
  },
  {
    yr: 2023,
    q: 'Which of the following is a limitation of pressure groups?',
    o: [
      'They only represent the interests of the wealthy',
      'They have no influence on government policies',
      'They may prioritise their own interests over the public interest',
      'They often resort to violent tactics',
    ],
    a: 2,
    e: 'A key limitation of pressure groups is that they prioritise the specific interests of their members over the broader public interest — what benefits the group may harm society as a whole.',
    full: 'Advantages of pressure groups:\n• Give voice to minority/specific interests\n• Provide expertise to government\n• Act as watchdogs on government\n• Educate the public\n\nLimitations of pressure groups:\n• May prioritise group interests over public interest ✓ (e.g., ASUU strikes hurt students while fighting for lecturers)\n• Well-funded groups have disproportionate influence — BUT this doesn\'t mean they "only represent the wealthy"\n• Can be used to obstruct progressive policies\n• Some use extra-legal pressure tactics\n\nOption A is too absolute ("only the wealthy") — some represent workers, students, women.\nOption B is false — pressure groups DO influence government.\nOption D is too extreme — most pressure groups do not use violence.',
    h: 'What is the main limitation of pressure groups regarding whose interests they serve?',
  },
  {
    yr: 2023,
    q: 'Which of the following is a right associated with citizenship?',
    o: ['Right to education', 'Right to vote', 'Right to privacy', 'Right to property'],
    a: 1,
    e: 'The right to vote is the most directly and exclusively linked right to citizenship — only citizens can vote in most democracies. Other rights may also be granted to non-citizens.',
    full: 'Rights of citizens vs. rights of persons:\n• Right to vote ✓ — exclusively for citizens in most countries; the most defining civic right\n• Right to education — often extended to non-citizens (residents, asylum seekers)\n• Right to privacy — a human right available to all persons, not just citizens\n• Right to property — also available to legal residents in many countries\n\nThe right to vote (franchise/suffrage) is the quintessential citizenship right because:\n• Only citizens can participate in elections\n• It is the primary mechanism of democratic participation\n• Non-citizens are explicitly excluded from voting in national elections\n\nThis is why JAMB consistently uses "right to vote" as the defining citizenship right.',
    h: 'Which right is exclusively and most directly tied to citizenship?',
  },
  {
    yr: 2023,
    q: 'If the president refuses to sign a bill within a specific period, it can still become a law through ___',
    o: ['Legislative override', 'None of the above', 'Judicial review', 'Public petition'],
    a: 0,
    e: 'Legislative override allows the legislature to pass a bill into law despite the president\'s refusal to sign (veto), typically by a two-thirds supermajority vote.',
    full: 'The presidential veto and override process:\n\n1. Legislature passes a bill\n2. President refuses to sign (veto/withholds assent)\n3. Bill returns to legislature\n4. If legislature achieves a supermajority (typically 2/3) of both chambers — it overrides the veto\n5. Bill becomes law WITHOUT presidential signature\n\nIn Nigeria (1999 Constitution, Section 58):\n• President has 30 days to sign or return a bill with comments\n• If both chambers of the National Assembly re-pass the bill with 2/3 majority, it becomes law\n\nOther options:\n• Judicial review: Courts review laws AFTER they are enacted — not how unsigned bills become law\n• Public petition: Has no formal legislative force to bypass presidential veto',
    h: 'How can a bill become law if the president refuses to sign it?',
  },
  {
    yr: 2023,
    q: 'The process of forming public opinion is known as ___',
    o: ['Polling', 'Socialization', 'Mobilization', 'Persuasion'],
    a: 1,
    e: 'Socialization is the process through which individuals acquire political values, beliefs, and opinions from their social environment — it is the process of forming public opinion.',
    full: 'Political socialization is the lifelong process by which people develop their political values, attitudes, and beliefs through:\n• Family (primary agent)\n• Schools (formal civic education)\n• Mass media\n• Peer groups\n• Religious institutions\n• Political parties\n\nThrough socialization, individual opinions form — and the aggregate of these constitutes public opinion.\n\nDistinctions:\n• Polling: Measuring already-formed opinion (not forming it)\n• Mobilization: Activating people to take political action\n• Persuasion: Changing someone\'s existing opinion\n• Socialization: The ongoing process of forming opinions from scratch through social experience',
    h: 'What process involves acquiring political values that eventually form public opinion?',
  },
  {
    yr: 2023,
    q: 'Jus Sanguinis is a principle that grants citizenship based on ___',
    o: ['Parental citizenship', 'Place of birth', 'Ethnic background', 'Length of residency'],
    a: 0,
    e: 'Jus Sanguinis (Latin: "right of blood") grants citizenship based on having one or both parents who are citizens — citizenship by descent/bloodline.',
    full: 'Two main principles of citizenship by birth:\n\n1. Jus Sanguinis ("right of blood"): Citizenship follows the blood — you are a citizen because your parent(s) are citizens, regardless of where you were born. Used by Germany, China, Nigeria.\n\n2. Jus Soli ("right of soil"): Citizenship follows the place — you are a citizen because you were born on that country\'s territory, regardless of parents\' nationality. Used by USA, Canada, Brazil.\n\nOther ways to acquire citizenship:\n• Naturalisation: Living in a country for a period and applying\n• Registration: Marrying a citizen or other qualifying acts\n\nNigeria uses Jus Sanguinis primarily — a child born of a Nigerian parent is Nigerian, wherever born.',
    h: 'Jus Sanguinis grants citizenship through what — blood/parents or birthplace?',
  },
  {
    yr: 2023,
    q: 'Nigeria\'s foreign policy is influenced by its position as a major exporter of ___',
    o: ['Military equipment', 'Natural resources', 'Agricultural products', 'Technology'],
    a: 1,
    e: 'Nigeria\'s foreign policy is significantly shaped by its status as a major exporter of natural resources — particularly crude oil and natural gas, which form the backbone of its economy and international leverage.',
    full: 'Nigeria and natural resources in foreign policy:\n• Nigeria is Africa\'s largest oil producer and ranks among the world\'s top 10 oil exporters\n• Oil revenue constitutes over 70% of government income\n• Nigeria\'s oil wealth gives it leverage in international negotiations\n• OPEC membership shapes Nigeria\'s relations with oil-consuming nations\n• Energy diplomacy is a key tool of Nigerian foreign policy\n\nThis resource wealth influences:\n• Relations with Western nations (oil buyers)\n• African diplomacy (Nigeria as regional power due to oil wealth)\n• China-Nigeria relations (infrastructure for oil deals)\n• ECOWAS leadership (economic power from oil)',
    h: 'What resource exports most shape Nigeria\'s foreign policy and international relations?',
  },
  {
    yr: 2023,
    q: 'When an election fails to produce a clear winner, the process of determining a winner is called ___',
    o: ['A recall', 'A re-run election', 'A bye-election', 'A referendum'],
    a: 1,
    e: 'A re-run election is held when the initial election produces no clear winner — a fresh vote is conducted between the leading candidates.',
    full: 'Electoral terms:\n\n• Re-run election: Held when no candidate wins the required majority, or results are inconclusive/contested. A second vote is held — often between the top two candidates.\n\n• By-election (Bye-election): Held to fill a vacant seat mid-term when a member dies, resigns, or is disqualified.\n\n• Recall: A process by which voters can remove an elected official before their term ends.\n\n• Referendum: A direct vote by the electorate on a specific policy or constitutional question (not about candidates).\n\nIn Nigeria, INEC can order a re-run election when results are nullified due to malpractice or when no candidate achieves the constitutional threshold in a presidential election (25% in at least 2/3 of states plus the highest votes).',
    h: 'What election is held when results are inconclusive and no winner emerges?',
  },
  {
    yr: 2023,
    q: 'Which political party was known for its socialist ideology and populist policies in the 1980s?',
    o: ['People\'s Redemption Party', 'All Nigeria\'s People\'s Party', 'National Party of Nigeria', 'Nigerian National Democratic Party'],
    a: 0,
    e: 'The People\'s Redemption Party (PRP), led by Aminu Kano, was the major socialist and populist party in Nigeria\'s Second Republic (1979–1983), advocating for the masses against the wealthy elite.',
    full: 'Nigeria\'s Second Republic political parties (1979–1983):\n\n• PRP (People\'s Redemption Party) — Aminu Kano: Socialist, populist ideology; won Kano and Kaduna states; championed the poor against the "sarakuna" (ruling class)\n\n• NPN (National Party of Nigeria) — Shehu Shagari: Conservative; won presidency; dominated the North\n\n• UPN (Unity Party of Nigeria) — Obafemi Awolowo: Welfare state ideology; dominated South West\n\n• NPP (Nigerian People\'s Party) — Nnamdi Azikiwe: Centre; won South East\n\n• GNPP (Great Nigeria People\'s Party) — Waziri Ibrahim: Won North East states\n\nThe PRP\'s socialist stance (progressive taxation, welfare programs, land reform) made it the most ideologically left-wing party of the period.',
    h: 'Which Nigerian party of the Second Republic was known for socialism and populism?',
  },
    {
      yr: 2024,
      q: 'The three arms of government are',
      o: [
         'Executive, Legislative, Judiciary',
        'President, Senate, Courts',
        'Cabinet, Parliament, Judiciary',
        'Federal, State, Local',
      ],
      a: 0,
      e: 'Executive implements laws, Legislative makes laws, Judiciary interprets laws.',
      full: 'Modern democratic governments typically divide power among three separate branches to prevent any single group from becoming too powerful. This is called the separation of powers.\n\nThe Legislature (in Nigeria: the National Assembly — Senate and House of Representatives) makes the laws. The Executive (headed by the President) implements and enforces those laws through government ministries and agencies. The Judiciary (courts, headed by the Supreme Court) interprets the laws and resolves disputes about their meaning or application.\n\nThis three-way division ensures accountability. Each branch can check the others through mechanisms called checks and balances.',
      h: 'Which three bodies make, implement, and interpret laws?',
    },
    {
      yr: 2023,
      q: 'Federalism is a system where',
      o: [
        'All power is centralised',
        'Power is shared between central and component units',
        'Only states have power',
        'The military rules',
      ],
      a: 1,
      e: 'Federalism divides sovereign power between central and state governments.',
      full: 'In a unitary system, all significant power rests with the central government — local authorities exist only by permission and can be overruled or abolished. In a federal system, sovereign power is constitutionally DIVIDED between a central government and component units (states or regions), and neither can simply abolish the other.\n\nNigeria is a federal state — the Federal Government and the 36 state governments both have constitutionally defined powers. Some powers are exclusive to the federal government (defence, immigration). Some are concurrent (shared). Some belong only to states.\n\nMilitary rule concentrates power; it is the opposite of federalism.',
      h: 'Federal = power shared between levels.',
    },
    {
      yr: 2024,
      q: 'Separation of powers was propounded by',
      o: [
        'John Locke',
        'Thomas Hobbes',
        'Baron de Montesquieu',
        'Jean Jacques Rousseau',
      ],
      a: 2,
      e: 'Montesquieu developed the doctrine in The Spirit of the Laws (1748).',
      full: "The doctrine of separation of powers — that government functions should be divided among separate institutions to prevent tyranny — was most fully developed by the French political philosopher Baron de Montesquieu in his landmark work The Spirit of the Laws, published in 1748.\n\nMontesquieu was inspired by his observation of the English constitutional system. His ideas directly influenced the framers of the American Constitution and have shaped democratic constitutions around the world, including Nigeria's.\n\nJohn Locke also wrote about separation of powers (legislative and executive) but Montesquieu developed the full three-way separation including an independent judiciary. Thomas Hobbes argued for strong centralised authority. Rousseau focused on the social contract and popular sovereignty.",
      h: 'French philosopher of the 18th century.',
    },
    {
      yr: 2023,
      q: 'Rigid constitution requires',
      o: [
        'Can be changed easily',
        'Special procedure to amend',
        'No written form',
        'Military control',
      ],
      a: 1,
      e: 'A rigid constitution requires a complex amendment procedure, not a simple majority.',
      full: "Constitutions vary in how easily they can be amended. A flexible constitution can be changed by the ordinary legislative process — just like any other law, by a simple majority. The UK's unwritten constitution is an example of flexibility.\n\nA rigid constitution requires a special, more demanding procedure to be amended — such as a supermajority (e.g. two-thirds of the legislature), ratification by state legislatures, or a referendum. This rigidity protects fundamental rights and structures from being easily changed by temporary political majorities.\n\nNigeria's 1999 Constitution is rigid — amending it requires approval by two-thirds of the National Assembly and the approval of at least 24 state Houses of Assembly.",
      h: 'Rigid = hard to change = special requirements.',
    },
    {
      yr: 2022,
      q: 'Main function of the legislature is to',
      o: ['Implement laws', 'Make laws', 'Interpret laws', 'Enforce laws'],
      a: 1,
      e: 'The legislature is responsible for making laws.',
      full: "The word legislature comes from the Latin legis (law) + latura (bringing). The legislature's primary function is to deliberate on and pass laws that govern the country.\n\nIn Nigeria's bicameral National Assembly, the process involves a bill being introduced, read three times, debated, and voted on in both the Senate and House of Representatives before being sent to the President for assent.\n\nThe executive implements and enforces laws — it does not make them. The judiciary interprets laws — it explains what they mean in specific cases. Law enforcement agencies enforce laws at street level. The legislature is the lawmaking body.",
      h: 'Legislature comes from legis = law.',
    },
    {
      yr: 2024,
      q: 'Head of government in parliamentary system',
      o: ['President', 'Prime Minister', 'Monarch', 'Governor-General'],
      a: 1,
      e: 'In parliamentary system, the Prime Minister is head of government.',
      full: 'There are two main systems of executive government. In a presidential system (like Nigeria and the USA), the president is both head of state and head of government, directly elected by the people.\n\nIn a parliamentary system (like the UK, India, and many former British colonies), there is a separation between the head of state (often a monarch or president who is ceremonial) and the head of government (the Prime Minister, who leads the cabinet and is accountable to parliament).\n\nIn the UK, King Charles III is the head of state but has limited real power. The Prime Minister (from the majority party in Parliament) is the head of government and actually runs the country.',
      h: 'Parliamentary system — which official leads the government?',
    },
    {
      yr: 2023,
      q: 'Universal Adult Suffrage means',
      o: [
        'Only educated people vote',
        'All adults above minimum age can vote',
        'Only taxpayers vote',
        'Only men vote',
      ],
      a: 1,
      e: 'Universal adult suffrage grants voting rights to all adult citizens.',
      full: 'Suffrage means the right to vote. Universal adult suffrage means this right is granted to ALL adults above the minimum voting age, without discrimination based on gender, wealth, education, religion, or ethnicity.\n\nHistorically, voting was restricted in most countries — only men with property, or only white citizens, or only educated citizens could vote. Universal suffrage was a major democratic achievement won through long political struggles.\n\nIn Nigeria, all citizens aged 18 and above who are registered with INEC have the right to vote. This is universal adult suffrage in practice.',
      h: 'Universal = for all. Suffrage = right to vote.',
    },
    {
      yr: 2022,
      q: 'Checks and balances means',
      o: [
        'Government keeps financial records',
        'Each arm limits the power of others',
        'Banks regulate government',
        'Military checks civilians',
      ],
      a: 1,
      e: 'Checks and balances prevents any one arm from becoming too powerful.',
      full: 'Even with separation of powers, it is possible for one branch to dominate the others. Checks and balances is a system where each branch of government has specific powers to limit or oversee the others, preventing any single branch from accumulating unchecked power.\n\nFor example: the legislature makes laws but the executive can veto them. The executive implements laws but the legislature can override a veto with enough votes. The judiciary can declare laws unconstitutional. The executive appoints judges but the legislature must confirm them.\n\nThis web of mutual oversight ensures that power is balanced and that no president, parliament, or court can act without accountability to the others.',
      h: 'Each arm can check the others from abusing power.',
    },
    {
      yr: 2024,
      q: 'ECOWAS was established in',
      o: ['1975', '1980', '1963', '1970'],
      a: 0,
      e: 'ECOWAS was established in 1975 in Lagos.',
      full: "The Economic Community of West African States (ECOWAS) was founded on 28 May 1975 through the Treaty of Lagos, signed by 15 West African nations. Nigeria was a key driver of the organisation's creation under General Yakubu Gowon.\n\nECOWAS aims to promote economic integration, free movement of people and goods, and political stability across West Africa. Its headquarters is in Abuja, Nigeria. It has also taken on security roles — the ECOWAS Monitoring Group (ECOMOG) has intervened in regional conflicts.\n\nNever confuse the founding date (1975) with the OAU founding date (1963) or Nigeria's independence (1960).",
      h: 'When was the Treaty of Lagos signed?',
    },
    {
      yr: 2023,
      q: 'UN organ responsible for international peace',
      o: ['General Assembly', 'Security Council', 'ICJ', 'Secretariat'],
      a: 1,
      e: 'The Security Council has primary responsibility for maintaining international peace.',
      full: 'The United Nations has several principal organs with different roles. The General Assembly includes all 193 member states, debates issues, and passes non-binding resolutions. The Secretariat is the administrative arm led by the Secretary-General. The International Court of Justice (ICJ) settles legal disputes between states.\n\nThe Security Council has 15 members — 5 permanent (USA, UK, France, Russia, China) with veto power, and 10 rotating elected members. Under the UN Charter, the Security Council has PRIMARY responsibility for international peace and security. It can authorise peacekeeping operations, impose sanctions, and authorise the use of military force.',
      h: 'Peace and security = which council?',
    },
    {
      yr: 2022,
      q: 'Citizenship can be acquired by',
      o: [
        'Birth only',
        'Naturalisation only',
        'Birth, naturalisation, and registration',
        'Election',
      ],
      a: 2,
      e: 'Citizenship can be acquired by birth, naturalisation, or registration.',
      full: 'Countries determine who their citizens are through different methods:\n\nCitizenship by birth has two forms: jus soli (right of the soil — born on the territory) and jus sanguinis (right of blood — born to citizen parents). Nigeria primarily uses jus sanguinis.\n\nCitizenship by naturalisation is granted to foreigners who have lived in the country for a specified period, met certain requirements (good conduct, language proficiency), and applied formally.\n\nCitizenship by registration is a simpler process for certain categories — like foreign women who marry Nigerian citizens, or people with strong ancestral ties.\n\nAll three routes are valid in Nigerian law.',
      h: 'There are multiple ways to become a citizen.',
    },
    {
      yr: 2024,
      q: 'Rule of law means',
      o: [
        'Rulers are above the law',
        'Everyone is equal before the law',
        'Only courts make laws',
        'Law is for the poor',
      ],
      a: 1,
      e: 'Rule of law: no one is above the law — all persons subject equally.',
      full: 'The rule of law is a foundational principle of constitutional democracy. It means that the law is supreme — it applies equally to every person in society, including rulers, presidents, soldiers, and ordinary citizens. No individual, institution, or group is above the law.\n\nA.V. Dicey, the British constitutional scholar, identified three core elements: no one can be punished except for a breach of the law; everyone is equal before and under the law; and constitutional rights are the result of ordinary law rather than abstract documents.\n\nWhere the rule of law is absent, you have arbitrary government — rulers who can imprison, punish, or favour people at will, based on personal power rather than legal principle.',
      h: 'Rule OF law — everyone including leaders must obey.',
    },
    {
      yr: 2023,
      q: 'A Bill becomes a law when',
      o: [
        'The Speaker signs it',
        'Passed by Senate only',
        'It receives presidential assent',
        'The public approves',
      ],
      a: 2,
      e: 'After passing both houses, a bill becomes law when the President gives assent.',
      full: "In Nigeria's law-making process, a bill must pass through several stages. It is introduced in either the Senate or House of Representatives, read three times, debated, and voted on in that chamber. Then it goes to the other chamber for the same process.\n\nIf both chambers pass the bill (including resolving any differences), it is sent to the President. The President can either sign it — giving assent and making it law — or withhold assent (a veto). If the President withholds assent, the National Assembly can override the veto with a two-thirds majority vote in both chambers.\n\nPresidential assent is the final, critical step that converts a bill into an Act of Parliament — a binding law.",
      h: 'Last step in the lawmaking process.',
    },
    {
      yr: 2022,
      q: 'Political socialisation refers to',
      o: [
        'Making politicians social',
        'Process of acquiring political values',
        'Socialising in parties',
        'Registering to vote',
      ],
      a: 1,
      e: 'Political socialisation is how individuals learn political values from family, school, media.',
      full: "Political socialisation is the lifelong process through which individuals acquire political knowledge, values, beliefs, and attitudes. It is how citizens come to understand politics and form opinions about government, authority, rights, and civic duties.\n\nThe primary agents of political socialisation include: family (the first and most influential — children absorb parents' political views early); schools (civic education, history classes, national symbols); peer groups (friends and social circles reinforce or challenge views); mass media (television, social media, newspapers shape political perceptions); and religious institutions (which can carry political values).\n\nThis process never truly ends — people continue to update their political views throughout life as they encounter new experiences.",
      h: 'How do people learn their political beliefs?',
    },
    {
      yr: 2024,
      q: 'Which is an example of an unwritten constitution?',
      o: ['USA', 'Nigeria', 'UK', 'France'],
      a: 2,
      e: 'The UK has no single codified constitutional document — its constitution is unwritten.',
      full: 'Most countries have a codified constitution — a single written document that is the supreme law of the land, containing the fundamental rights, powers, and structures of government. Examples include Nigeria (1999 Constitution), USA (1787 Constitution), and France.\n\nThe United Kingdom is famously different. There is no single document called "The British Constitution." Instead, British constitutional law is scattered across centuries of Acts of Parliament (like the Magna Carta of 1215, the Bill of Rights of 1689), court judgements, and unwritten conventions that everyone follows without being explicitly legally required to.\n\nThis makes the UK constitution unwritten (or more precisely, uncodified) — a product of gradual evolution rather than a single founding moment.',
      h: 'Which country relies on conventions rather than a single written document?',
    },
    {
      yr: 2023,
      q: 'A state can be defined by',
      o: [
        'Its army only',
        'Population, territory, government, sovereignty',
        'Only its government',
        'Only its population',
      ],
      a: 1,
      e: 'The four elements of a state are: population, territory, government, and sovereignty.',
      full: 'A state in international relations is more than just a country name — it must possess four essential elements to be recognised as a state in the Westphalian sense:\n\nPopulation: a permanent group of people who live in the territory. A state without people is not a state. Territory: a defined geographic area with recognised borders. Government: an organised authority that can make and enforce rules. Sovereignty: the supreme power to govern without interference from external authorities.\n\nAn army is not one of the four elements — states can exist without a military (Costa Rica has no army). The four elements are the classical definition from international law.',
      h: 'What four elements define a state?',
    },
    {
      yr: 2022,
      q: 'Pressure group differs from political party because it',
      o: [
        'Has members',
        'Seeks to influence government but not control it',
        'Has a constitution',
        'Organises elections',
      ],
      a: 1,
      e: 'Pressure groups seek to influence policy without seeking political power themselves.',
      full: 'Both pressure groups and political parties participate in the political process, but they differ fundamentally in their goals.\n\nPolitical parties seek to WIN POWER — to control government by contesting elections and filling government positions. Once in power, they make laws and run the country.\n\nPressure groups (interest groups) do NOT seek to govern. They seek to INFLUENCE those who govern. They lobby politicians, campaign in public, commission research, organise protests, and use media to push specific policies. Examples: trade unions, business associations, environmental groups, religious organisations.\n\nBoth may have constitutions and members, and both may organise activities — but only parties contest elections to take power.',
      h: 'Pressure groups influence; parties seek to control?',
    },
    {
      yr: 2024,
      q: 'Bicameral legislature means',
      o: ['One house', 'Two houses', 'Three houses', 'Many houses'],
      a: 1,
      e: 'Bicameral = two chambers. In Nigeria: Senate and House of Representatives.',
      full: "The word bicameral comes from Latin: bi (two) + camera (chamber). A bicameral legislature has two separate houses or chambers that both play a role in the law-making process.\n\nNigeria's National Assembly is bicameral: the Senate (upper house, 109 members) and the House of Representatives (lower house, 360 members). For most bills to become law, both houses must pass them.\n\nBicameral systems are common in federations — the upper house often represents the component units (states) while the lower house represents population. A unicameral legislature has only one chamber (like the parliaments of Ghana and Senegal).",
      h: 'Bi = two. Cameral = chamber.',
    },
    {
      yr: 2023,
      q: 'The Nigerian Senate has how many members?',
      o: ['360', '109', '120', '469'],
      a: 1,
      e: 'The Nigerian Senate has 109 members — 3 from each of 36 states plus 1 from FCT.',
      full: 'The Nigerian Senate is the upper chamber of the National Assembly. Its composition reflects the federal structure of Nigeria:\n\n3 senators per state × 36 states = 108 senators, plus 1 senator representing the Federal Capital Territory (Abuja) = 109 senators total.\n\nThis equal representation of states in the Senate (regardless of population) ensures that smaller states have an equal voice to large states like Lagos or Kano. The House of Representatives, by contrast, is allocated seats based on population — it has 360 members.\n\nDo not confuse 360 (House of Representatives members) with 109 (Senate members).',
      h: 'Three senators per state x 36 states + 1 FCT.',
    },
    {
      yr: 2022,
      q: 'Judicial review is the power of courts to',
      o: [
        'Appoint judges',
        'Declare laws unconstitutional',
        'Make new laws',
        'Amend the constitution',
      ],
      a: 1,
      e: 'Judicial review allows courts to strike down laws that conflict with the constitution.',
      full: 'Judicial review is the power of courts — ultimately the Supreme Court — to examine laws, executive actions, and government decisions to determine whether they are consistent with the constitution. If found inconsistent, the court can declare them null and void.\n\nThis power makes the judiciary a vital check on the legislature and executive. Even if parliament passes a law with a large majority, the Supreme Court can strike it down if it violates fundamental constitutional rights or exceeds legislative powers.\n\nJudicial review is central to constitutional democracy. In Nigeria, Section 1(3) of the 1999 Constitution states that any law inconsistent with the constitution is void to the extent of its inconsistency.',
      h: 'Which court power protects the constitution?',
    },
    {
      yr: 2024,
      q: 'Proportional representation is a type of',
      o: ['Electoral system', 'Constitution', 'Government', 'Political party'],
      a: 0,
      e: 'Proportional representation is an electoral system where seats are allocated based on percentage of votes received.',
      full: 'An electoral system determines how votes translate into seats or positions. There are different types.\n\nUnder first-past-the-post (FPTP), used in Nigeria for most elections, the candidate with the most votes wins — even if they do not have a majority. Votes for losing candidates count for nothing.\n\nUnder proportional representation (PR), seats are allocated roughly in proportion to the percentage of votes each party receives. If a party gets 30% of votes, it gets approximately 30% of the seats. This system is considered fairer in representing minority views but can lead to many small parties and coalition governments.\n\nPR is used in South Africa, Germany, and many other democracies.',
      h: 'How seats are allocated based on votes = type of what?',
    },
    {
      yr: 2023,
      q: 'The OAU was replaced by',
      o: ['ECOWAS', 'African Union', 'United Nations', 'NEPAD'],
      a: 1,
      e: 'The Organisation of African Unity (OAU) was replaced by the African Union (AU) in 2002.',
      full: "The Organisation of African Unity (OAU) was founded in 1963 in Addis Ababa by 32 independent African states. Its primary goals were to end colonialism in Africa and oppose apartheid. It was a significant symbol of Pan-African unity.\n\nHowever, the OAU was widely criticised for its principle of non-interference in member states' internal affairs, which prevented it from responding to human rights abuses and internal conflicts.\n\nIn 2002, the OAU was replaced by the African Union (AU), modelled partly on the European Union. The AU has a more interventionist mandate, can impose sanctions on members, and addresses governance, democracy, and human rights in addition to the original Pan-African goals. Its headquarters remains in Addis Ababa, Ethiopia.",
      h: 'Which pan-African body replaced the OAU?',
    },
    {
      yr: 2022,
      q: 'Parliamentary government originated in',
      o: ['France', 'USA', 'UK', 'Germany'],
      a: 2,
      e: 'Parliamentary government originated in the United Kingdom.',
      full: "The parliamentary system of government evolved gradually in Britain over centuries — it was not designed all at once but developed through historical struggles between monarchs and nobles.\n\nThe Magna Carta (1215) was an early step, limiting royal power. The development of Parliament as a representative body, the English Civil War (1640s), the Glorious Revolution (1688), and the Bill of Rights (1689) progressively established parliamentary sovereignty and cabinet government.\n\nBy the 18th and 19th centuries, Britain's Westminster model — with a Prime Minister accountable to Parliament, a constitutional monarchy, and an independent judiciary — was well established and exported to former British colonies including Nigeria, India, Canada, and Australia.",
      h: 'Where did Westminster-style parliament originate?',
    },
    {
      yr: 2024,
      q: 'Delegated legislation refers to',
      o: [
        'Laws made by the president alone',
        'Laws made by subordinate bodies under authority',
        'Laws made by courts',
        'International laws',
      ],
      a: 1,
      e: 'Delegated legislation is law made by subordinate bodies under authority granted by parliament.',
      full: 'Parliament is the primary law-making body but it cannot practically legislate on every technical detail of every policy area. Instead, Parliament passes an Enabling Act (or parent Act) that grants specific powers to the Executive or other bodies to make detailed rules and regulations.\n\nThese rules and regulations made under that delegated authority are called delegated legislation (or secondary legislation). Examples include ministerial orders, local council bylaws, and rules made by regulatory agencies.\n\nDelegated legislation must stay within the limits set by the enabling act — if it exceeds those limits, courts can strike it down as ultra vires (beyond the power granted).',
      h: 'Who makes delegated legislation?',
    },
    {
      yr: 2023,
      q: 'The concept of sovereignty means',
      o: [
        'A country has an army',
        'Supreme power to make and enforce laws',
        'Having a constitution',
        'Being a member of the UN',
      ],
      a: 1,
      e: 'Sovereignty is the supreme, absolute power of a state to make and enforce laws within its territory.',
      full: "Sovereignty is the concept that within a defined territory, a state has the final, supreme, and absolute authority — no higher power exists that can override it within that territory. A sovereign state can make any laws it chooses and enforce them without external interference.\n\nThere are two dimensions: internal sovereignty (supremacy over everyone within the territory — no group can override the state's authority) and external sovereignty (independence from foreign control — no other state can legally tell this state what to do).\n\nSovereignty is challenged in practice by international obligations, treaties, and organisations like the UN — but in theory, each state retains the right to withdraw and act independently.",
      h: 'Supreme, ultimate power of a state.',
    },
    {
      yr: 2022,
      q: 'Secularism in government means',
      o: [
        'Government promotes religion',
        'Government is separate from religion',
        'Only Christians can govern',
        'Only Muslims can govern',
      ],
      a: 1,
      e: 'A secular government maintains separation between state authority and religious institutions.',
      full: "Secularism in government means that the state operates independently of religious institutions. Government policy, legislation, and public institutions are based on civic principles rather than religious doctrine. No single religion is given official state status or used as the basis of law.\n\nSecular states protect religious freedom — citizens may practice any religion or none. But the state itself remains neutral on religious questions.\n\nNigeria's constitution declares it a secular state, though this is sometimes debated given the prevalence of religion in public life. The separation prevents theocracy (government by religious authorities) and ensures that laws apply equally to people of all faiths and none.",
      h: 'Secular = separated from which institution?',
    },
    {
      yr: 2024,
      q: 'The main function of the executive arm is to',
      o: [
        'Make laws',
        'Implement laws',
        'Interpret laws',
        'Amend the constitution',
      ],
      a: 1,
      e: 'The executive implements and enforces the laws made by the legislature.',
      full: 'The three arms of government have distinct functions that must not be confused.\n\nThe Legislature (National Assembly) makes laws. The Judiciary (courts) interprets those laws and resolves disputes. The Executive — headed by the President and including all government ministries, agencies, and security forces — carries out and enforces the laws.\n\nThis is why ministers, the police, EFCC, NAFDAC, and other government bodies are part of the executive arm — they implement specific policies and enforce specific laws. The President also appoints key officials, manages foreign policy, and leads the armed forces. All of these are implementation roles.',
      h: 'Execute = carry out. What does the executive carry out?',
    },
    {
      yr: 2023,
      q: 'Coalition government is formed when',
      o: [
        'One party wins majority',
        'Multiple parties combine to form government',
        'Military takes over',
        'President appoints cabinet alone',
      ],
      a: 1,
      e: 'A coalition government is formed when no single party wins an outright majority and parties combine.',
      full: "In many democratic elections, no single party wins enough seats to form a majority government. When this happens, parties must negotiate and combine forces to achieve a working majority — this is called a coalition government.\n\nCoalitions are especially common in countries with proportional representation, where seats are spread more evenly among multiple parties. The coalition partners must agree on a shared programme of government and divide ministerial positions between them.\n\nCoalitions can be unstable — if the parties disagree significantly, the government can collapse. Germany, Israel, and Italy have historically relied heavily on coalition governments. Nigeria's presidential system and first-past-the-post elections make coalition governments less common but not impossible.",
      h: 'When no single party has majority, what do they form?',
    },
    {
      yr: 2022,
      q: 'Censure motion in parliament is used to',
      o: [
        'Pass a bill',
        'Express disapproval of the executive',
        'Amend the constitution',
        'Elect the president',
      ],
      a: 1,
      e: "A censure or vote of no confidence expresses parliament's disapproval of the executive.",
      full: "One of the key tools of legislative oversight is the ability to formally express disapproval of the executive or specific ministers. A censure motion or vote of no confidence is exactly this — a formal parliamentary vote saying the executive (or a minister) no longer has the confidence of parliament.\n\nIn a parliamentary system, losing a vote of no confidence typically forces the Prime Minister to resign or call a new election. In Nigeria's presidential system, the National Assembly can pass a vote of no confidence in the Vice President or ministers, signalling political disapproval, though the consequences differ from a parliamentary system.\n\nCensure is a powerful political tool — it signals that parliament believes the executive is performing poorly or acting improperly.",
      h: "Parliament's way of showing disapproval of government.",
    },
    {
      yr: 2024,
      q: 'The Electoral Commission in Nigeria is called',
      o: ['EFCC', 'INEC', 'NBS', 'NHRC'],
      a: 1,
      e: 'INEC (Independent National Electoral Commission) conducts elections in Nigeria.',
      full: "The Independent National Electoral Commission (INEC) is Nigeria's electoral management body, established by Section 153 of the 1999 Constitution. INEC is responsible for organising, undertaking, and supervising all elections to the offices of the President, Vice President, Governor, Deputy Governor, and members of the National and State Assemblies.\n\nINEC also registers political parties, registers voters, maintains the voters' register, and monitors campaigns. Its independence is crucial — it must be free from political interference to conduct credible elections.\n\nThe EFCC (Economic and Financial Crimes Commission) fights financial crimes. The NBS (National Bureau of Statistics) collects data. The NHRC (National Human Rights Commission) protects human rights. Only INEC conducts elections.",
      h: 'Which commission organises Nigerian elections?',
    },
  ];
